const testData = {
  1: [
    {
      title: " CBSE (Test- 1)",
      questions: [
        // Maths (1–3)
        {
          "question": "What is the value of (x + 3)(x - 3)?",
          "options": ["x² + 9", "x² - 9", "x² + 6x", "x² - 6x"],
          "answer": "x² - 9",
          "subject": "Maths"
        },
        {
          "question": "If the roots of the quadratic equation x² + 4x + k = 0 are equal, find the value of k.",
          "options": ["4", "8", "2", "1"],
          "answer": "4",
          "subject": "Maths"
        },
        {
          "question": "Find the distance between the points (2, 3) and (4, 7).",
          "options": ["2", "4", "5", "√20"],
          "answer": "√20",
          "subject": "Maths"
        },
        {
          "question": "What is the sum of first 10 natural numbers?",
          "options": ["55", "45", "50", "60"],
          "answer": "55",
          "subject": "Maths"
        },
        {
          "question": "The value of sin 30° is:",
          "options": ["1", "√3/2", "1/2", "0"],
          "answer": "1/2",
          "subject": "Maths"
        },
        {
          "question": "What is the HCF of 12 and 18?",
          "options": ["6", "2", "4", "12"],
          "answer": "6",
          "subject": "Maths"
        },
        {
          "question": "A quadratic equation has how many roots?",
          "options": ["1", "2", "3", "Infinite"],
          "answer": "2",
          "subject": "Maths"
        },
        {
          "question": "What is the formula to find the area of a circle?",
          "options": ["πr²", "2πr", "πd", "r²"],
          "answer": "πr²",
          "subject": "Maths"
        },
        {
          "question": "If A = 2, B = 3, then the value of A² + B² is:",
          "options": ["13", "10", "12", "11"],
          "answer": "13",
          "subject": "Maths"
        },
        {
          "question": "What is the value of tan 45°?",
          "options": ["0", "1", "√3", "2"],
          "answer": "1",
          "subject": "Maths"
        },
        {
          "question": "What is the surface area of a cube with side 4 cm?",
          "options": ["96 cm²", "64 cm²", "48 cm²", "32 cm²"],
          "answer": "96 cm²",
          "subject": "Maths"
        },
        {
          "question": "Which of the following is a linear equation?",
          "options": ["x + 2 = 0", "x² + 3x = 4", "x³ = 8", "x² = 4"],
          "answer": "x + 2 = 0",
          "subject": "Maths"
        },
        {
          "question": "The mean of 3, 7, 9, 4 is:",
          "options": ["5.75", "6", "5", "7"],
          "answer": "5.75",
          "subject": "Maths"
        },
        {
          "question": "The mode of the numbers 3, 3, 5, 7, 3, 9 is:",
          "options": ["3", "5", "7", "9"],
          "answer": "3",
          "subject": "Maths"
        },
        {
          "question": "A pair of linear equations in two variables may have:",
          "options": ["No solution", "One solution", "Infinitely many solutions", "All of the above"],
          "answer": "All of the above",
          "subject": "Maths"
        },
        {
          "question": "Find the volume of a cube of side 5 cm.",
          "options": ["125 cm³", "25 cm³", "150 cm³", "100 cm³"],
          "answer": "125 cm³",
          "subject": "Maths"
        },
        {
          "question": "What is the formula for the surface area of a sphere?",
          "options": ["4πr²", "2πr", "πr²", "πd²"],
          "answer": "4πr²",
          "subject": "Maths"
        },
        {
          "question": "If sin A = 1/2, then angle A is:",
          "options": ["30°", "45°", "60°", "90°"],
          "answer": "30°",
          "subject": "Maths"
        },
        {
          "question": "Find the LCM of 8 and 12.",
          "options": ["24", "16", "12", "48"],
          "answer": "24",
          "subject": "Maths"
        },
        {
          "question": "The value of √81 is:",
          "options": ["9", "8", "7", "6"],
          "answer": "9",
          "subject": "Maths"
        },
        {
          "question": "What is the next term in the sequence: 2, 4, 8, 16, ...?",
          "options": ["20", "24", "32", "18"],
          "answer": "32",
          "subject": "Maths"
        },
        {
          "question": "What is the formula for finding the slope of a line?",
          "options": ["(y₂ - y₁)/(x₂ - x₁)", "(x₂ - x₁)/(y₂ - y₁)", "x² + y²", "None of these"],
          "answer": "(y₂ - y₁)/(x₂ - x₁)",
          "subject": "Maths"
        },
        {
          "question": "The roots of x² - 5x + 6 = 0 are:",
          "options": ["2 and 3", "1 and 6", "5 and 6", "1 and 5"],
          "answer": "2 and 3",
          "subject": "Maths"
        },
        {
          "question": "What is the circumference of a circle with radius 7 cm?",
          "options": ["44 cm", "22 cm", "14 cm", "None"],
          "answer": "44 cm",
          "subject": "Maths"
        },
        {
          "question": "What is the standard form of a quadratic equation?",
          "options": ["ax² + bx + c = 0", "ax + b = 0", "x² + y² = r²", "None"],
          "answer": "ax² + bx + c = 0",
          "subject": "Maths"
        },
        {
          "question": "The number 49 is a:",
          "options": ["Prime number", "Square number", "Cube number", "Odd number"],
          "answer": "Square number",
          "subject": "Maths"
        },
        {
          "question": "The coordinates of the origin are:",
          "options": ["(0,0)", "(1,1)", "(0,1)", "(1,0)"],
          "answer": "(0,0)",
          "subject": "Maths"
        },
        {
          "question": "The sum of interior angles of a triangle is:",
          "options": ["180°", "360°", "90°", "270°"],
          "answer": "180°",
          "subject": "Maths"
        },
        {
          "question": "Find the height of a triangle with area 24 cm² and base 6 cm.",
          "options": ["8 cm", "6 cm", "4 cm", "10 cm"],
          "answer": "8 cm",
          "subject": "Maths"
        },
        {
          "question": "The graph of y = mx + c is a:",
          "options": ["Straight line", "Circle", "Parabola", "Hyperbola"],
          "answer": "Straight line",
          "subject": "Maths"
        },
        {
          "question": "Which device is used to measure electric current?",
          "options": ["Voltmeter", "Ammeter", "Galvanometer", "Ohmmeter"],
          "answer": "Ammeter",
          "subject": "Science"
        },
        {
          "question": "The SI unit of power is:",
          "options": ["Joule", "Watt", "Newton", "Volt"],
          "answer": "Watt",
          "subject": "Science"
        },
        {
          "question": "A positively charged object has:",
          "options": ["More electrons", "More protons", "Equal protons and electrons", "No charge"],
          "answer": "More protons",
          "subject": "Science"
        },
        {
          "question": "Which of the following is a good conductor of electricity?",
          "options": ["Plastic", "Glass", "Copper", "Wood"],
          "answer": "Copper",
          "subject": "Science"
        },
        {
          "question": "The direction of magnetic field lines outside a magnet is:",
          "options": ["North to South", "South to North", "Random", "Circular"],
          "answer": "North to South",
          "subject": "Science"
        },
        {
          "question": "What is the speed of light in vacuum?",
          "options": ["3 × 10⁸ m/s", "3 × 10⁶ m/s", "1.5 × 10⁸ m/s", "None"],
          "answer": "3 × 10⁸ m/s",
          "subject": "Science"
        },
        {
          "question": "What happens to resistance if the length of a wire is doubled?",
          "options": ["Becomes half", "Remains same", "Becomes double", "Becomes four times"],
          "answer": "Becomes double",
          "subject": "Science"
        },
        {
          "question": "Which lens is used to correct myopia?",
          "options": ["Convex lens", "Concave lens", "Bifocal lens", "Cylindrical lens"],
          "answer": "Concave lens",
          "subject": "Science"
        },
        {
          "question": "The unit of electric charge is:",
          "options": ["Ampere", "Coulomb", "Volt", "Ohm"],
          "answer": "Coulomb",
          "subject": "Science"
        },
        {
          "question": "Electric power is equal to:",
          "options": ["VI", "IR", "V/I", "I/R"],
          "answer": "VI",
          "subject": "Science"
        },
        {
          "question": "Which rule gives the direction of current induced in a conductor?",
          "options": ["Fleming’s Left-hand Rule", "Right-hand Thumb Rule", "Fleming’s Right-hand Rule", "Ohm’s Law"],
          "answer": "Fleming’s Right-hand Rule",
          "subject": "Science"
        },
        {
          "question": "Which of the following is not a magnetic material?",
          "options": ["Iron", "Nickel", "Copper", "Cobalt"],
          "answer": "Copper",
          "subject": "Science"
        },
        {
          "question": "Which mirror is used in a solar cooker?",
          "options": ["Concave", "Convex", "Plane", "Cylindrical"],
          "answer": "Concave",
          "subject": "Science"
        },
        {
          "question": "The resistance of a wire depends on:",
          "options": ["Length", "Area", "Material", "All of these"],
          "answer": "All of these",
          "subject": "Science"
        },
        {
          "question": "1 kWh is equal to:",
          "options": ["3600 J", "3.6 × 10⁶ J", "1000 J", "60 J"],
          "answer": "3.6 × 10⁶ J",
          "subject": "Science"
        },
        {
          "question": "What is Ohm’s Law?",
          "options": ["V = IR", "V = I/R", "V = R/I", "I = VR"],
          "answer": "V = IR",
          "subject": "Science"
        },
        {
          "question": "The image formed by a plane mirror is:",
          "options": ["Real and inverted", "Virtual and erect", "Magnified", "Reduced"],
          "answer": "Virtual and erect",
          "subject": "Science"
        },
        {
          "question": "Which color of light bends the most in a prism?",
          "options": ["Red", "Blue", "Green", "Violet"],
          "answer": "Violet",
          "subject": "Science"
        },
        {
          "question": "The phenomenon of splitting of white light is called:",
          "options": ["Dispersion", "Reflection", "Refraction", "Scattering"],
          "answer": "Dispersion",
          "subject": "Science"
        },
        {
          "question": "What is the nature of image formed by convex mirror?",
          "options": ["Real and inverted", "Virtual and erect", "Magnified", "None"],
          "answer": "Virtual and erect",
          "subject": "Science"
        },
        {
          "question": "The SI unit of resistance is:",
          "options": ["Ohm", "Watt", "Volt", "Ampere"],
          "answer": "Ohm",
          "subject": "Science"
        },
        {
          "question": "Which of these is a renewable source of energy?",
          "options": ["Coal", "Petroleum", "Wind", "Natural gas"],
          "answer": "Wind",
          "subject": "Science"
        },
        {
          "question": "Which of these is responsible for greenhouse effect?",
          "options": ["Oxygen", "Carbon dioxide", "Nitrogen", "Helium"],
          "answer": "Carbon dioxide",
          "subject": "Science"
        },
        {
          "question": "Which device converts electrical energy into mechanical energy?",
          "options": ["Motor", "Generator", "Bulb", "Battery"],
          "answer": "Motor",
          "subject": "Science"
        },
        {
          "question": "Electric fuse is used to prevent:",
          "options": ["Shock", "Short circuit", "Overheating", "Overloading"],
          "answer": "Overloading",
          "subject": "Science"
        },
        {
          "question": "In a series circuit, the current is:",
          "options": ["Same in all components", "Different in each", "Zero", "Maximum at end"],
          "answer": "Same in all components",
          "subject": "Science"
        },
        {
          "question": "In electromagnetic induction, current is induced due to:",
          "options": ["Static charge", "Magnetic field change", "Friction", "Heat"],
          "answer": "Magnetic field change",
          "subject": "Science"
        },
        {
          "question": "SI unit of work is:",
          "options": ["Joule", "Watt", "Newton", "Pascal"],
          "answer": "Joule",
          "subject": "Science"
        },
        {
          "question": "Which of these is a magnetic material?",
          "options": ["Iron", "Wood", "Plastic", "Rubber"],
          "answer": "Iron",
          "subject": "Science"
        },
        {
          "question": "Which rule helps to determine the direction of force in a motor?",
          "options": ["Fleming’s Left-hand Rule", "Right-hand Rule", "Lenz Law", "Ohm’s Law"],
          "answer": "Fleming’s Left-hand Rule",
          "subject": "Science"
        },
        {
          "question": "Which gas is evolved during the reaction of acids with metals?",
          "options": ["Oxygen", "Carbon dioxide", "Hydrogen", "Nitrogen"],
          "answer": "Hydrogen",
          "subject": "Science"
        },
        {
          "question": "What is the chemical formula of baking soda?",
          "options": ["Na₂CO₃", "NaHCO₃", "CaCO₃", "NaCl"],
          "answer": "NaHCO₃",
          "subject": "Science"
        },
        {
          "question": "Which acid is present in lemon?",
          "options": ["Acetic acid", "Citric acid", "Sulphuric acid", "Lactic acid"],
          "answer": "Citric acid",
          "subject": "Science"
        },
        {
          "question": "Which element is common to all organic compounds?",
          "options": ["Hydrogen", "Carbon", "Oxygen", "Nitrogen"],
          "answer": "Carbon",
          "subject": "Science"
        },
        {
          "question": "Which of the following is an indicator?",
          "options": ["Salt", "Water", "Litmus", "Alcohol"],
          "answer": "Litmus",
          "subject": "Science"
        },
        {
          "question": "Which gas turns lime water milky?",
          "options": ["Carbon dioxide", "Oxygen", "Nitrogen", "Hydrogen"],
          "answer": "Carbon dioxide",
          "subject": "Science"
        },
        {
          "question": "The reaction between an acid and base is called:",
          "options": ["Decomposition", "Neutralization", "Combination", "Displacement"],
          "answer": "Neutralization",
          "subject": "Science"
        },
        {
          "question": "Rusting of iron is a:",
          "options": ["Physical change", "Chemical change", "Reversible change", "None"],
          "answer": "Chemical change",
          "subject": "Science"
        },
        {
          "question": "The pH value of neutral solution is:",
          "options": ["0", "14", "7", "1"],
          "answer": "7",
          "subject": "Science"
        },
        {
          "question": "Which of the following is a strong acid?",
          "options": ["Acetic acid", "Sulphuric acid", "Citric acid", "Carbonic acid"],
          "answer": "Sulphuric acid",
          "subject": "Science"
        },
        {
          "question": "Which organelle is called the powerhouse of the cell?",
          "options": ["Nucleus", "Chloroplast", "Mitochondria", "Ribosome"],
          "answer": "Mitochondria",
          "subject": "Science"
        },
        {
          "question": "Which part of the plant carries out photosynthesis?",
          "options": ["Root", "Stem", "Leaf", "Flower"],
          "answer": "Leaf",
          "subject": "Science"
        },
        {
          "question": "Blood is pumped by which organ?",
          "options": ["Lungs", "Brain", "Heart", "Kidney"],
          "answer": "Heart",
          "subject": "Science"
        },
        {
          "question": "Which gas is released during photosynthesis?",
          "options": ["Carbon dioxide", "Oxygen", "Nitrogen", "Hydrogen"],
          "answer": "Oxygen",
          "subject": "Science"
        },
        {
          "question": "In humans, the fertilization of egg takes place in:",
          "options": ["Uterus", "Vagina", "Ovary", "Fallopian tube"],
          "answer": "Fallopian tube",
          "subject": "Science"
        },
        {
          "question": "The basic unit of life is:",
          "options": ["Atom", "Molecule", "Cell", "Tissue"],
          "answer": "Cell",
          "subject": "Science"
        },
        {
          "question": "Which is the largest gland in the human body?",
          "options": ["Pancreas", "Liver", "Thyroid", "Salivary gland"],
          "answer": "Liver",
          "subject": "Science"
        },
        {
          "question": "Which hormone regulates sugar level in blood?",
          "options": ["Adrenaline", "Insulin", "Thyroxine", "Estrogen"],
          "answer": "Insulin",
          "subject": "Science"
        },
        {
          "question": "The green pigment in plants is called:",
          "options": ["Chlorophyll", "Hemoglobin", "Xanthophyll", "Melanin"],
          "answer": "Chlorophyll",
          "subject": "Science"
        },
        {
          "question": "Which system in the body is responsible for transport of oxygen?",
          "options": ["Respiratory system", "Circulatory system", "Digestive system", "Nervous system"],
          "answer": "Circulatory system",
          "subject": "Science"
        },
        {
          "question": "Which organ excretes urea in humans?",
          "options": ["Lungs", "Liver", "Kidneys", "Intestine"],
          "answer": "Kidneys",
          "subject": "Science"
        },
        {
          "question": "Which disease is caused by a virus?",
          "options": ["Malaria", "Tuberculosis", "AIDS", "Typhoid"],
          "answer": "AIDS",
          "subject": "Science"
        },
        {
          "question": "The site of complete digestion in human is:",
          "options": ["Stomach", "Mouth", "Large intestine", "Small intestine"],
          "answer": "Small intestine",
          "subject": "Science"
        },
        {
          "question": "Reproduction that does not involve gametes is called:",
          "options": ["Sexual", "Asexual", "Binary fission", "Pollination"],
          "answer": "Asexual",
          "subject": "Science"
        },
        {
          "question": "The DNA is present in:",
          "options": ["Cytoplasm", "Mitochondria", "Nucleus", "Cell wall"],
          "answer": "Nucleus",
          "subject": "Science"
        },
        {
          "question": "Which part of the brain controls voluntary actions?",
          "options": ["Cerebellum", "Cerebrum", "Medulla", "Spinal cord"],
          "answer": "Cerebrum",
          "subject": "Science"
        },
        {
          "question": "Which vitamin is produced in skin by sunlight?",
          "options": ["Vitamin A", "Vitamin B", "Vitamin C", "Vitamin D"],
          "answer": "Vitamin D",
          "subject": "Science"
        },
        {
          "question": "Which of the following controls cell activities?",
          "options": ["Mitochondria", "Ribosome", "Nucleus", "Lysosome"],
          "answer": "Nucleus",
          "subject": "Science"
        },
        {
          "question": "Which structure helps a plant in respiration?",
          "options": ["Stomata", "Chloroplast", "Guard cells", "Lenticels"],
          "answer": "Stomata",
          "subject": "Science"
        },
        {
          "question": "Gregor Mendel is known as the father of:",
          "options": ["Biology", "Genetics", "Chemistry", "Ecology"],
          "answer": "Genetics",
          "subject": "Science"
        }

      ],
    },










    {
      title: " CBSE (Test- 2)",
      questions: [
        // Maths (1–3)
        {
          "question": "What is the value of (a + b)²?",
          "options": ["a² + b²", "a² + 2ab + b²", "2a² + b²", "a² - 2ab + b²"],
          "answer": "a² + 2ab + b²",
          "subject": "Maths"
        },
        {
          "question": "The value of sin 90° is:",
          "options": ["0", "1", "0.5", "√3/2"],
          "answer": "1",
          "subject": "Maths"
        },
        {
          "question": "Which of the following is a quadratic equation?",
          "options": ["x + 2 = 0", "x² + 5x + 6 = 0", "x³ + 1 = 0", "2x - 3 = 0"],
          "answer": "x² + 5x + 6 = 0",
          "subject": "Maths"
        },
        {
          "question": "Area of a circle is given by:",
          "options": ["2πr", "πr²", "πd", "πr"],
          "answer": "πr²",
          "subject": "Maths"
        },
        {
          "question": "If a line has a slope of 0, it is:",
          "options": ["Vertical", "Inclined", "Horizontal", "Curved"],
          "answer": "Horizontal",
          "subject": "Maths"
        },
        {
          "question": "The solution of the equation x² - 4 = 0 is:",
          "options": ["x = ±4", "x = ±2", "x = 0", "x = 2 only"],
          "answer": "x = ±2",
          "subject": "Maths"
        },
        {
          "question": "The HCF of 12 and 18 is:",
          "options": ["6", "12", "3", "9"],
          "answer": "6",
          "subject": "Maths"
        },
        {
          "question": "Which of the following is a rational number?",
          "options": ["√2", "π", "1/2", "√5"],
          "answer": "1/2",
          "subject": "Maths"
        },
        {
          "question": "The value of tan 45° is:",
          "options": ["0", "1", "√3", "∞"],
          "answer": "1",
          "subject": "Maths"
        },
        {
          "question": "A line parallel to x-axis has an equation:",
          "options": ["x = a", "y = a", "y = 0", "x + y = 0"],
          "answer": "y = a",
          "subject": "Maths"
        },
        {
          "question": "The roots of the equation x² + x - 6 = 0 are:",
          "options": ["-3, 2", "3, -2", "-1, 6", "2, 1"],
          "answer": "-3, 2",
          "subject": "Maths"
        },
        {
          "question": "Volume of a cylinder is:",
          "options": ["πr²h", "2πrh", "πr² + h", "πr³"],
          "answer": "πr²h",
          "subject": "Maths"
        },
        {
          "question": "The point (0, 0) is called:",
          "options": ["X-intercept", "Y-intercept", "Origin", "Vertex"],
          "answer": "Origin",
          "subject": "Maths"
        },
        {
          "question": "Sum of first n natural numbers is:",
          "options": ["n(n-1)/2", "n(n+1)/2", "n²", "n(n+2)/2"],
          "answer": "n(n+1)/2",
          "subject": "Maths"
        },
        {
          "question": "A pair of linear equations in two variables has no solution if the lines are:",
          "options": ["Parallel", "Intersecting", "Coincident", "Overlapping"],
          "answer": "Parallel",
          "subject": "Maths"
        },
        {
          "question": "Which is the largest 4-digit number divisible by 12?",
          "options": ["9996", "9999", "9992", "10000"],
          "answer": "9996",
          "subject": "Maths"
        },
        {
          "question": "A quadratic equation has two equal roots if:",
          "options": ["D > 0", "D = 0", "D < 0", "No condition"],
          "answer": "D = 0",
          "subject": "Maths"
        },
        {
          "question": "Distance between (0, 0) and (3, 4) is:",
          "options": ["5", "6", "7", "4"],
          "answer": "5",
          "subject": "Maths"
        },
        {
          "question": "What is the 10th term of the AP: 3, 6, 9, ...?",
          "options": ["30", "27", "33", "36"],
          "answer": "30",
          "subject": "Maths"
        },
        {
          "question": "LCM of 15 and 20 is:",
          "options": ["60", "45", "30", "35"],
          "answer": "60",
          "subject": "Maths"
        },
        {
          "question": "The sum of interior angles of a triangle is:",
          "options": ["180°", "90°", "360°", "270°"],
          "answer": "180°",
          "subject": "Maths"
        },
        {
          "question": "In a right triangle, the square of the hypotenuse equals:",
          "options": ["Sum of all sides", "Sum of squares of base and height", "Twice the base", "Product of sides"],
          "answer": "Sum of squares of base and height",
          "subject": "Maths"
        },
        {
          "question": "Surface area of a cube of side a is:",
          "options": ["6a²", "4a²", "a³", "2a²"],
          "answer": "6a²",
          "subject": "Maths"
        },
        {
          "question": "Which is a prime number?",
          "options": ["9", "15", "17", "21"],
          "answer": "17",
          "subject": "Maths"
        },
        {
          "question": "If a polygon has 5 sides, it is called:",
          "options": ["Hexagon", "Quadrilateral", "Pentagon", "Octagon"],
          "answer": "Pentagon",
          "subject": "Maths"
        },
        {
          "question": "The graph of a linear equation in two variables is a:",
          "options": ["Point", "Line", "Curve", "Circle"],
          "answer": "Line",
          "subject": "Maths"
        },
        {
          "question": "The probability of getting a 3 when a die is rolled once is:",
          "options": ["1/3", "1/6", "1/2", "1/4"],
          "answer": "1/6",
          "subject": "Maths"
        },
        {
          "question": "Mean of first 5 even numbers is:",
          "options": ["4", "5", "6", "8"],
          "answer": "6",
          "subject": "Maths"
        },
        {
          "question": "In coordinate geometry, x-axis is also known as:",
          "options": ["Horizontal axis", "Vertical axis", "Origin", "Diagonal"],
          "answer": "Horizontal axis",
          "subject": "Maths"
        },
        {
          "question": "The area of a triangle with base 10 and height 5 is:",
          "options": ["50", "25", "20", "30"],
          "answer": "25",
          "subject": "Maths"
        },
        {
          "question": "Which of the following is not a unit of speed?",
          "options": ["m/s", "km/h", "m/s²", "cm/s"],
          "answer": "m/s²",
          "subject": "Science"
        },
        {
          "question": "What is the SI unit of force?",
          "options": ["Joule", "Newton", "Pascal", "Watt"],
          "answer": "Newton",
          "subject": "Science"
        },
        {
          "question": "Acceleration is defined as:",
          "options": ["Change in velocity", "Rate of change of velocity", "Rate of change of displacement", "Rate of change of speed"],
          "answer": "Rate of change of velocity",
          "subject": "Science"
        },
        {
          "question": "Which law states that every action has an equal and opposite reaction?",
          "options": ["First law of motion", "Second law of motion", "Third law of motion", "Law of gravitation"],
          "answer": "Third law of motion",
          "subject": "Science"
        },
        {
          "question": "The weight of an object is:",
          "options": ["Same as mass", "Mass × acceleration due to gravity", "Always constant", "Independent of gravity"],
          "answer": "Mass × acceleration due to gravity",
          "subject": "Science"
        },
        {
          "question": "The commercial unit of energy is:",
          "options": ["Joule", "Watt", "Kilowatt-hour", "Watt-second"],
          "answer": "Kilowatt-hour",
          "subject": "Science"
        },
        {
          "question": "Work is said to be done when:",
          "options": ["There is no displacement", "Force is applied without motion", "Force causes displacement", "Energy is conserved"],
          "answer": "Force causes displacement",
          "subject": "Science"
        },
        {
          "question": "Which of these is a scalar quantity?",
          "options": ["Force", "Velocity", "Acceleration", "Speed"],
          "answer": "Speed",
          "subject": "Science"
        },
        {
          "question": "One newton is equal to:",
          "options": ["1 kg m/s²", "1 kg/m²", "1 m/kg²", "1 N/m"],
          "answer": "1 kg m/s²",
          "subject": "Science"
        },
        {
          "question": "Power is defined as:",
          "options": ["Energy × time", "Work done × time", "Work done ÷ time", "Force × time"],
          "answer": "Work done ÷ time",
          "subject": "Science"
        },
        {
          "question": "The SI unit of pressure is:",
          "options": ["Watt", "Pascal", "Newton", "Joule"],
          "answer": "Pascal",
          "subject": "Science"
        },
        {
          "question": "Which device converts electrical energy into mechanical energy?",
          "options": ["Bulb", "Electric motor", "Generator", "Heater"],
          "answer": "Electric motor",
          "subject": "Science"
        },
        {
          "question": "The speed of light in vacuum is:",
          "options": ["3 × 10⁸ m/s", "3 × 10⁶ m/s", "3 × 10⁵ km/s", "3 × 10⁴ m/s"],
          "answer": "3 × 10⁸ m/s",
          "subject": "Science"
        },
        {
          "question": "Sound cannot travel through:",
          "options": ["Air", "Water", "Steel", "Vacuum"],
          "answer": "Vacuum",
          "subject": "Science"
        },
        {
          "question": "Which mirror is used in a rearview mirror of a vehicle?",
          "options": ["Plane", "Concave", "Convex", "None"],
          "answer": "Convex",
          "subject": "Science"
        },
        {
          "question": "Which lens is used to correct myopia?",
          "options": ["Convex", "Concave", "Cylindrical", "Plane"],
          "answer": "Concave",
          "subject": "Science"
        },
        {
          "question": "The focal length of a concave lens is:",
          "options": ["Positive", "Negative", "Zero", "Infinite"],
          "answer": "Negative",
          "subject": "Science"
        },
        {
          "question": "In refraction, the bending of light occurs because of:",
          "options": ["Reflection", "Change in speed", "Dispersion", "Diffraction"],
          "answer": "Change in speed",
          "subject": "Science"
        },
        {
          "question": "Which color of light is scattered the most?",
          "options": ["Red", "Green", "Blue", "Violet"],
          "answer": "Violet",
          "subject": "Science"
        },
        {
          "question": "Which phenomenon explains the blue color of the sky?",
          "options": ["Reflection", "Refraction", "Scattering", "Interference"],
          "answer": "Scattering",
          "subject": "Science"
        },
        {
          "question": "Ohm's law relates:",
          "options": ["Voltage, resistance, and current", "Force and acceleration", "Energy and time", "Current and frequency"],
          "answer": "Voltage, resistance, and current",
          "subject": "Science"
        },
        {
          "question": "Which of the following is a good conductor of electricity?",
          "options": ["Rubber", "Plastic", "Copper", "Wood"],
          "answer": "Copper",
          "subject": "Science"
        },
        {
          "question": "Unit of electric current is:",
          "options": ["Volt", "Ohm", "Ampere", "Watt"],
          "answer": "Ampere",
          "subject": "Science"
        },
        {
          "question": "The resistance of a conductor depends on:",
          "options": ["Length", "Area", "Material", "All of these"],
          "answer": "All of these",
          "subject": "Science"
        },
        {
          "question": "A fuse wire should have:",
          "options": ["Low melting point", "High melting point", "High resistance", "Thick diameter"],
          "answer": "Low melting point",
          "subject": "Science"
        },
        {
          "question": "The device used to break an electric circuit is:",
          "options": ["Fuse", "Switch", "Resistor", "Capacitor"],
          "answer": "Switch",
          "subject": "Science"
        },
        {
          "question": "Which effect of electric current is used in an electric heater?",
          "options": ["Chemical", "Magnetic", "Heating", "Mechanical"],
          "answer": "Heating",
          "subject": "Science"
        },
        {
          "question": "The direction of magnetic field around a straight conductor is:",
          "options": ["Straight", "Circular", "Diagonal", "Radial"],
          "answer": "Circular",
          "subject": "Science"
        },
        {
          "question": "A magnetic field is produced by:",
          "options": ["Stationary charge", "Moving charge", "Mass", "Heat"],
          "answer": "Moving charge",
          "subject": "Science"
        },
        {
          "question": "The magnetic field inside a solenoid is:",
          "options": ["Zero", "Weak", "Strong and uniform", "None"],
          "answer": "Strong and uniform",
          "subject": "Science"
        },
        {
          "question": "Which of the following is a chemical change?",
          "options": ["Melting of ice", "Boiling of water", "Rusting of iron", "Breaking of glass"],
          "answer": "Rusting of iron",
          "subject": "Science"
        },
        {
          "question": "Which gas is evolved when metal reacts with acid?",
          "options": ["Oxygen", "Carbon dioxide", "Hydrogen", "Nitrogen"],
          "answer": "Hydrogen",
          "subject": "Science"
        },
        {
          "question": "What is the chemical formula of quicklime?",
          "options": ["Ca(OH)₂", "CaCO₃", "CaO", "CaCl₂"],
          "answer": "CaO",
          "subject": "Science"
        },
        {
          "question": "Which acid is present in vinegar?",
          "options": ["Formic acid", "Acetic acid", "Citric acid", "Oxalic acid"],
          "answer": "Acetic acid",
          "subject": "Science"
        },
        {
          "question": "Litmus turns red in:",
          "options": ["Base", "Neutral solution", "Acid", "Salt solution"],
          "answer": "Acid",
          "subject": "Science"
        },
        {
          "question": "pH of neutral solution is:",
          "options": ["0", "14", "7", "1"],
          "answer": "7",
          "subject": "Science"
        },
        {
          "question": "Which of the following is a salt?",
          "options": ["HCl", "NaOH", "NaCl", "H₂SO₄"],
          "answer": "NaCl",
          "subject": "Science"
        },
        {
          "question": "The metal used in thermometers is:",
          "options": ["Iron", "Mercury", "Zinc", "Lead"],
          "answer": "Mercury",
          "subject": "Science"
        },
        {
          "question": "Which of the following metals does not react with water?",
          "options": ["Potassium", "Calcium", "Magnesium", "Copper"],
          "answer": "Copper",
          "subject": "Science"
        },
        {
          "question": "The green coating on copper is due to:",
          "options": ["Iron oxide", "Basic copper carbonate", "Copper nitrate", "Copper sulfate"],
          "answer": "Basic copper carbonate",
          "subject": "Science"
        },
        {
          "question": "Which allotrope of carbon is the hardest?",
          "options": ["Graphite", "Charcoal", "Diamond", "Coal"],
          "answer": "Diamond",
          "subject": "Science"
        },
        {
          "question": "Which element is common in all organic compounds?",
          "options": ["Carbon", "Hydrogen", "Oxygen", "Nitrogen"],
          "answer": "Carbon",
          "subject": "Science"
        },
        {
          "question": "Which of the following is a saturated hydrocarbon?",
          "options": ["Alkene", "Alkyne", "Alkane", "Alcohol"],
          "answer": "Alkane",
          "subject": "Science"
        },
        {
          "question": "Soap is formed by the reaction between:",
          "options": ["Acid and base", "Oil and alkali", "Alcohol and acid", "Salt and water"],
          "answer": "Oil and alkali",
          "subject": "Science"
        },
        {
          "question": "Which part of the cell contains genetic material?",
          "options": ["Cytoplasm", "Cell wall", "Nucleus", "Mitochondria"],
          "answer": "Nucleus",
          "subject": "Science"
        },
        {
          "question": "Which of the following is the powerhouse of the cell?",
          "options": ["Ribosome", "Chloroplast", "Mitochondria", "Nucleus"],
          "answer": "Mitochondria",
          "subject": "Science"
        },
        {
          "question": "Which tissue is responsible for the movement in our body?",
          "options": ["Connective tissue", "Muscular tissue", "Nervous tissue", "Epithelial tissue"],
          "answer": "Muscular tissue",
          "subject": "Science"
        },
        {
          "question": "Which part of the plant performs photosynthesis?",
          "options": ["Root", "Stem", "Leaf", "Flower"],
          "answer": "Leaf",
          "subject": "Science"
        },
        {
          "question": "Which pigment is essential for photosynthesis?",
          "options": ["Hemoglobin", "Chlorophyll", "Keratin", "Melanin"],
          "answer": "Chlorophyll",
          "subject": "Science"
        },
        {
          "question": "Blood is a type of:",
          "options": ["Connective tissue", "Epithelial tissue", "Muscle tissue", "Nervous tissue"],
          "answer": "Connective tissue",
          "subject": "Science"
        },
        {
          "question": "The structural and functional unit of kidney is:",
          "options": ["Neuron", "Nephron", "Alveoli", "Glomerulus"],
          "answer": "Nephron",
          "subject": "Science"
        },
        {
          "question": "Which gas is used by plants during photosynthesis?",
          "options": ["Oxygen", "Carbon dioxide", "Nitrogen", "Hydrogen"],
          "answer": "Carbon dioxide",
          "subject": "Science"
        },
        {
          "question": "The process of release of energy from food is called:",
          "options": ["Digestion", "Respiration", "Transpiration", "Osmosis"],
          "answer": "Respiration",
          "subject": "Science"
        },
        {
          "question": "Xylem in plants is responsible for:",
          "options": ["Transport of food", "Transport of water", "Photosynthesis", "Growth"],
          "answer": "Transport of water",
          "subject": "Science"
        },
        {
          "question": "Which hormone regulates blood sugar?",
          "options": ["Insulin", "Adrenaline", "Thyroxine", "Estrogen"],
          "answer": "Insulin",
          "subject": "Science"
        },
        {
          "question": "The process of removing metabolic waste from the body is called:",
          "options": ["Respiration", "Excretion", "Reproduction", "Transpiration"],
          "answer": "Excretion",
          "subject": "Science"
        },
        {
          "question": "Which disease is caused by deficiency of iodine?",
          "options": ["Diabetes", "Scurvy", "Goitre", "Rickets"],
          "answer": "Goitre",
          "subject": "Science"
        },
        {
          "question": "Which type of reproduction results in genetic variation?",
          "options": ["Asexual", "Sexual", "Budding", "Fragmentation"],
          "answer": "Sexual",
          "subject": "Science"
        },
        {
          "question": "Which of these carries oxygen in blood?",
          "options": ["White blood cells", "Red blood cells", "Platelets", "Plasma"],
          "answer": "Red blood cells",
          "subject": "Science"
        },
        {
          "question": "Which planet is known as the Red Planet?",
          "options": ["Mars", "Venus", "Saturn", "Jupiter"],
          "answer": "Mars",
          "subject": "Science"
        },
      ],
    },










    {
      title: " CBSE (Test- 3)",
      questions: [
        // Maths (1–3)
        {
          "question": "The value of (a + b)² is:",
          "options": ["a² + b²", "a² + b² + 2ab", "a² - b²", "2a + 2b"],
          "answer": "a² + b² + 2ab",
          "subject": "Maths"
        },
        {
          "question": "What is the sum of the first 10 natural numbers?",
          "options": ["45", "55", "65", "50"],
          "answer": "55",
          "subject": "Maths"
        },
        {
          "question": "The HCF of 24 and 36 is:",
          "options": ["6", "12", "18", "24"],
          "answer": "12",
          "subject": "Maths"
        },
        {
          "question": "What is the LCM of 8 and 12?",
          "options": ["24", "48", "36", "16"],
          "answer": "24",
          "subject": "Maths"
        },
        {
          "question": "The zero of the polynomial x² - 4 is:",
          "options": ["2", "-2", "±2", "0"],
          "answer": "±2",
          "subject": "Maths"
        },
        {
          "question": "A line parallel to x-axis has slope:",
          "options": ["1", "0", "∞", "-1"],
          "answer": "0",
          "subject": "Maths"
        },
        {
          "question": "The perimeter of a circle is also called:",
          "options": ["Area", "Diameter", "Radius", "Circumference"],
          "answer": "Circumference",
          "subject": "Maths"
        },
        {
          "question": "Which of the following is a quadratic equation?",
          "options": ["x + 2 = 0", "x² + 3x + 2 = 0", "2x = 5", "3x + 4 = 7"],
          "answer": "x² + 3x + 2 = 0",
          "subject": "Maths"
        },
        {
          "question": "The distance between (0,0) and (3,4) is:",
          "options": ["5", "7", "6", "4"],
          "answer": "5",
          "subject": "Maths"
        },
        {
          "question": "What is the area of a triangle with base 10 cm and height 5 cm?",
          "options": ["50", "25", "30", "15"],
          "answer": "25",
          "subject": "Maths"
        },
        {
          "question": "How many tangents can be drawn from an external point to a circle?",
          "options": ["1", "2", "3", "Infinite"],
          "answer": "2",
          "subject": "Maths"
        },
        {
          "question": "Which of the following is a Pythagorean triplet?",
          "options": ["3, 4, 6", "5, 12, 13", "2, 3, 4", "6, 8, 10"],
          "answer": "5, 12, 13",
          "subject": "Maths"
        },
        {
          "question": "What is the surface area of a cube of side 4 cm?",
          "options": ["64", "96", "48", "32"],
          "answer": "96",
          "subject": "Maths"
        },
        {
          "question": "The median of first five odd numbers is:",
          "options": ["3", "5", "7", "9"],
          "answer": "5",
          "subject": "Maths"
        },
        {
          "question": "If sin θ = 1/2, then θ is:",
          "options": ["30°", "45°", "60°", "90°"],
          "answer": "30°",
          "subject": "Maths"
        },
        {
          "question": "A cone has how many faces?",
          "options": ["1", "2", "3", "4"],
          "answer": "2",
          "subject": "Maths"
        },
        {
          "question": "How many terms are there in an AP: 2, 5, 8, ..., 50?",
          "options": ["15", "16", "17", "18"],
          "answer": "17",
          "subject": "Maths"
        },
        {
          "question": "Which of the following numbers is irrational?",
          "options": ["22/7", "√2", "1.5", "0.25"],
          "answer": "√2",
          "subject": "Maths"
        },
        {
          "question": "In ∆ABC, if angle A = 90°, then side opposite to angle A is called:",
          "options": ["Base", "Height", "Hypotenuse", "Median"],
          "answer": "Hypotenuse",
          "subject": "Maths"
        },
        {
          "question": "The value of tan 45° is:",
          "options": ["0", "1", "√3", "∞"],
          "answer": "1",
          "subject": "Maths"
        },
        {
          "question": "In statistics, mode is:",
          "options": ["Average", "Highest", "Lowest", "Most frequent value"],
          "answer": "Most frequent value",
          "subject": "Maths"
        },
        {
          "question": "If sides of triangle are 3 cm, 4 cm, and 5 cm, it's a:",
          "options": ["Scalene", "Isosceles", "Right-angled", "Equilateral"],
          "answer": "Right-angled",
          "subject": "Maths"
        },
        {
          "question": "What is the volume of a cube with side 3 cm?",
          "options": ["9", "18", "27", "81"],
          "answer": "27",
          "subject": "Maths"
        },
        {
          "question": "What is the 10th term of the AP: 3, 7, 11, ...?",
          "options": ["39", "40", "41", "43"],
          "answer": "39",
          "subject": "Maths"
        },
        {
          "question": "In a circle, the angle subtended by a diameter is always:",
          "options": ["60°", "90°", "120°", "180°"],
          "answer": "90°",
          "subject": "Maths"
        },
        {
          "question": "Which of the following has no solution?",
          "options": ["x + 2 = 2 + x", "2x = 2x + 1", "x - x = 0", "3x = 3x"],
          "answer": "2x = 2x + 1",
          "subject": "Maths"
        },
        {
          "question": "The solution of 3x - 9 = 0 is:",
          "options": ["1", "2", "3", "4"],
          "answer": "3",
          "subject": "Maths"
        },
        {
          "question": "How many sides does a hexagon have?",
          "options": ["4", "5", "6", "7"],
          "answer": "6",
          "subject": "Maths"
        },
        {
          "question": "Which of these angles is obtuse?",
          "options": ["45°", "90°", "100°", "180°"],
          "answer": "100°",
          "subject": "Maths"
        },
        {
          "question": "What is the cube root of 64?",
          "options": ["3", "4", "6", "8"],
          "answer": "4",
          "subject": "Maths"
        },
        {
          "question": "What is the SI unit of work?",
          "options": ["Watt", "Newton", "Joule", "Pascal"],
          "answer": "Joule",
          "subject": "Science"
        },
        {
          "question": "Which of the following is a vector quantity?",
          "options": ["Speed", "Distance", "Velocity", "Work"],
          "answer": "Velocity",
          "subject": "Science"
        },
        {
          "question": "The rate of change of velocity is called:",
          "options": ["Speed", "Acceleration", "Momentum", "Force"],
          "answer": "Acceleration",
          "subject": "Science"
        },
        {
          "question": "Force = mass × _____?",
          "options": ["Momentum", "Velocity", "Acceleration", "Displacement"],
          "answer": "Acceleration",
          "subject": "Science"
        },
        {
          "question": "A body is said to be in uniform motion if it:",
          "options": ["Has varying speed", "Remains at rest", "Covers equal distances in equal time intervals", "Speeds up continuously"],
          "answer": "Covers equal distances in equal time intervals",
          "subject": "Science"
        },
        {
          "question": "Which law of motion explains the recoil of a gun?",
          "options": ["First law", "Second law", "Third law", "Law of gravitation"],
          "answer": "Third law",
          "subject": "Science"
        },
        {
          "question": "Which physical quantity is measured in Newtons?",
          "options": ["Work", "Force", "Pressure", "Power"],
          "answer": "Force",
          "subject": "Science"
        },
        {
          "question": "What is the acceleration due to gravity on Earth?",
          "options": ["9.8 m/s²", "8.9 m/s²", "10.5 m/s²", "9.2 m/s²"],
          "answer": "9.8 m/s²",
          "subject": "Science"
        },
        {
          "question": "Work done is zero when:",
          "options": ["Displacement is zero", "Force is applied", "Body moves in circular path", "Velocity is zero"],
          "answer": "Displacement is zero",
          "subject": "Science"
        },
        {
          "question": "Power is the rate of:",
          "options": ["Displacement", "Force", "Work", "Energy"],
          "answer": "Work",
          "subject": "Science"
        },
        {
          "question": "What is the SI unit of power?",
          "options": ["Joule", "Newton", "Watt", "Ampere"],
          "answer": "Watt",
          "subject": "Science"
        },
        {
          "question": "Which device is used to measure current?",
          "options": ["Voltmeter", "Ammeter", "Galvanometer", "Barometer"],
          "answer": "Ammeter",
          "subject": "Science"
        },
        {
          "question": "In which direction does heat flow?",
          "options": ["Cold to hot", "Hot to cold", "Both ways", "Randomly"],
          "answer": "Hot to cold",
          "subject": "Science"
        },
        {
          "question": "The image formed by a plane mirror is:",
          "options": ["Real and inverted", "Real and erect", "Virtual and inverted", "Virtual and erect"],
          "answer": "Virtual and erect",
          "subject": "Science"
        },
        {
          "question": "The unit of electric current is:",
          "options": ["Ohm", "Volt", "Ampere", "Watt"],
          "answer": "Ampere",
          "subject": "Science"
        },
        {
          "question": "What is the frequency of AC supply in India?",
          "options": ["50 Hz", "60 Hz", "100 Hz", "220 Hz"],
          "answer": "50 Hz",
          "subject": "Science"
        },
        {
          "question": "A concave lens always forms an image that is:",
          "options": ["Real and inverted", "Virtual and erect", "Real and erect", "Virtual and inverted"],
          "answer": "Virtual and erect",
          "subject": "Science"
        },
        {
          "question": "Which mirror is used in car rear-view mirrors?",
          "options": ["Concave", "Convex", "Plane", "None"],
          "answer": "Convex",
          "subject": "Science"
        },
        {
          "question": "Ohm’s Law relates voltage, current and:",
          "options": ["Power", "Resistance", "Capacitance", "Charge"],
          "answer": "Resistance",
          "subject": "Science"
        },
        {
          "question": "SI unit of resistance is:",
          "options": ["Ohm", "Watt", "Ampere", "Volt"],
          "answer": "Ohm",
          "subject": "Science"
        },
        {
          "question": "What does a fuse wire protect in an electric circuit?",
          "options": ["High voltage", "Overloading", "Short circuit", "Open circuit"],
          "answer": "Overloading",
          "subject": "Science"
        },
        {
          "question": "Which color of light deviates most in a prism?",
          "options": ["Red", "Green", "Blue", "Violet"],
          "answer": "Violet",
          "subject": "Science"
        },
        {
          "question": "If the focal length of a lens is negative, it is:",
          "options": ["Concave", "Convex", "Plane", "None"],
          "answer": "Concave",
          "subject": "Science"
        },
        {
          "question": "Which of the following has the highest speed in vacuum?",
          "options": ["Sound", "Light", "Water waves", "Radio waves"],
          "answer": "Light",
          "subject": "Science"
        },
        {
          "question": "The laws of reflection apply to:",
          "options": ["Plane mirrors only", "Curved mirrors only", "All types of mirrors", "None"],
          "answer": "All types of mirrors",
          "subject": "Science"
        },
        {
          "question": "Which lens is used to correct myopia?",
          "options": ["Convex", "Concave", "Cylindrical", "None"],
          "answer": "Concave",
          "subject": "Science"
        },
        {
          "question": "Which quantity remains constant in uniform circular motion?",
          "options": ["Velocity", "Speed", "Acceleration", "Displacement"],
          "answer": "Speed",
          "subject": "Science"
        },
        {
          "question": "The force which opposes motion is called:",
          "options": ["Magnetic", "Electrostatic", "Gravitational", "Friction"],
          "answer": "Friction",
          "subject": "Science"
        },
        {
          "question": "How many electrons constitute 1 coulomb charge?",
          "options": ["1.6 × 10¹⁹", "6.02 × 10²³", "3.6 × 10⁶", "6.25 × 10¹⁸"],
          "answer": "6.25 × 10¹⁸",
          "subject": "Science"
        },
        {
          "question": "Which device converts electrical energy to mechanical energy?",
          "options": ["Motor", "Generator", "Battery", "Transformer"],
          "answer": "Motor",
          "subject": "Science"
        },
        {
          "question": "Which gas is evolved when zinc reacts with dilute hydrochloric acid?",
          "options": ["Oxygen", "Hydrogen", "Carbon dioxide", "Nitrogen"],
          "answer": "Hydrogen",
          "subject": "Science"
        },
        {
          "question": "Which of the following is a chemical change?",
          "options": ["Melting of ice", "Boiling of water", "Rusting of iron", "Breaking of glass"],
          "answer": "Rusting of iron",
          "subject": "Science"
        },
        {
          "question": "Which metal does not react with dilute acids?",
          "options": ["Zinc", "Copper", "Magnesium", "Iron"],
          "answer": "Copper",
          "subject": "Science"
        },
        {
          "question": "pH value of neutral solution is:",
          "options": ["0", "7", "14", "5"],
          "answer": "7",
          "subject": "Science"
        },
        {
          "question": "Which one of the following is an acid-base indicator?",
          "options": ["Water", "Soap", "Litmus", "Salt"],
          "answer": "Litmus",
          "subject": "Science"
        },
        {
          "question": "Which acid is present in vinegar?",
          "options": ["Citric acid", "Acetic acid", "Hydrochloric acid", "Sulphuric acid"],
          "answer": "Acetic acid",
          "subject": "Science"
        },
        {
          "question": "Which compound is used in baking powder?",
          "options": ["Washing soda", "Sodium bicarbonate", "Calcium carbonate", "Sodium chloride"],
          "answer": "Sodium bicarbonate",
          "subject": "Science"
        },
        {
          "question": "Which non-metal is a good conductor of electricity?",
          "options": ["Sulphur", "Carbon (graphite)", "Phosphorus", "Iodine"],
          "answer": "Carbon (graphite)",
          "subject": "Science"
        },
        {
          "question": "Which gas is used in the manufacture of fertilizers?",
          "options": ["Oxygen", "Nitrogen", "Hydrogen", "Chlorine"],
          "answer": "Nitrogen",
          "subject": "Science"
        },
        {
          "question": "What is the common name of CaOCl₂?",
          "options": ["Washing soda", "Bleaching powder", "Limewater", "Baking soda"],
          "answer": "Bleaching powder",
          "subject": "Science"
        },
        {
          "question": "Sodium and potassium are stored in:",
          "options": ["Water", "Alcohol", "Kerosene", "Air"],
          "answer": "Kerosene",
          "subject": "Science"
        },
        {
          "question": "Which acid is used in car batteries?",
          "options": ["Hydrochloric acid", "Sulphuric acid", "Nitric acid", "Carbonic acid"],
          "answer": "Sulphuric acid",
          "subject": "Science"
        },
        {
          "question": "What is the formula of quicklime?",
          "options": ["CaCO₃", "Ca(OH)₂", "CaO", "CaCl₂"],
          "answer": "CaO",
          "subject": "Science"
        },
        {
          "question": "Which vitamin is synthesized in the skin?",
          "options": ["A", "B", "C", "D"],
          "answer": "D",
          "subject": "Science"
        },
        {
          "question": "Which of these is a communicable disease?",
          "options": ["Cancer", "Diabetes", "Tuberculosis", "Asthma"],
          "answer": "Tuberculosis",
          "subject": "Science"
        },
        {
          "question": "Which organ purifies blood in humans?",
          "options": ["Heart", "Liver", "Kidney", "Lungs"],
          "answer": "Kidney",
          "subject": "Science"
        },
        {
          "question": "The basic unit of life is:",
          "options": ["Tissue", "Cell", "Organ", "Organ system"],
          "answer": "Cell",
          "subject": "Science"
        },
        {
          "question": "Which part of the plant is responsible for photosynthesis?",
          "options": ["Root", "Stem", "Leaf", "Flower"],
          "answer": "Leaf",
          "subject": "Science"
        },
        {
          "question": "What is the site of respiration in cells?",
          "options": ["Nucleus", "Ribosome", "Mitochondria", "Chloroplast"],
          "answer": "Mitochondria",
          "subject": "Science"
        },
        {
          "question": "Which hormone controls sugar levels in blood?",
          "options": ["Insulin", "Adrenaline", "Thyroxine", "Estrogen"],
          "answer": "Insulin",
          "subject": "Science"
        },
        {
          "question": "The chromosome number in humans is:",
          "options": ["23", "46", "44", "22"],
          "answer": "46",
          "subject": "Science"
        },
        {
          "question": "Who is known as the father of genetics?",
          "options": ["Newton", "Darwin", "Mendel", "Pasteur"],
          "answer": "Mendel",
          "subject": "Science"
        },
        {
          "question": "Which gas do green plants absorb?",
          "options": ["Oxygen", "Carbon dioxide", "Nitrogen", "Hydrogen"],
          "answer": "Carbon dioxide",
          "subject": "Science"
        },
        {
          "question": "Which disease is caused by mosquito?",
          "options": ["Tuberculosis", "Malaria", "Typhoid", "Cholera"],
          "answer": "Malaria",
          "subject": "Science"
        },
        {
          "question": "Which component of blood fights infection?",
          "options": ["RBC", "Platelets", "WBC", "Plasma"],
          "answer": "WBC",
          "subject": "Science"
        },
        {
          "question": "What is the main function of xylem?",
          "options": ["Transport of food", "Transport of water", "Photosynthesis", "Reproduction"],
          "answer": "Transport of water",
          "subject": "Science"
        },
        {
          "question": "Which kingdom does Amoeba belong to?",
          "options": ["Plantae", "Fungi", "Protista", "Monera"],
          "answer": "Protista",
          "subject": "Science"
        },
        {
          "question": "DNA is found in which part of the cell?",
          "options": ["Nucleus", "Cytoplasm", "Mitochondria", "Cell wall"],
          "answer": "Nucleus",
          "subject": "Science"
        },
        {
          "question": "Pollination is the transfer of pollen from:",
          "options": ["Anther to ovary", "Anther to stigma", "Stigma to ovary", "Stigma to anther"],
          "answer": "Anther to stigma",
          "subject": "Science"
        },
        {
          "question": "Which part of the brain controls breathing?",
          "options": ["Cerebrum", "Cerebellum", "Medulla", "Pons"],
          "answer": "Medulla",
          "subject": "Science"
        },

      ],
    },

  ],






    //////////////////////////////////////////////////////////////////























  2: [
    {
      title: "jee main (Test-1)",
      questions: [
        // Maths (1–7)
        {
          question: "Group A consists of 7 boys and 3 girls, while group B consists of 6 boys and 5 girls. The number of ways, 4 boys and 4 girls can be invited for a picnic if 5 of them must be from group A and the remaining 3 from group B, is equal to:",
          options: ["8575", "8750", "8925", "9100"],
          answer: "8925",
          subject: "Maths"
        },
        {
          question: "Let a = 3î - ĵ + 2k̂, b = a × (2î - k̂) and c = b × k̂. Then the projection of 2ĵ on a is:",
          options: ["14", "2√7", "2√14", "3√7"],
          answer: "2√14",
          subject: "Maths"
        },
        {
          question: "Let f: (0, ∞) → ℝ be differentiable and satisfies x²f′(x) = 2xf(x) + 3, with f(1) = 4. Then 2f(2) is equal to:",
          options: ["23", "19", "29", "39"],
          answer: "39",
          subject: "Maths"
        },
        {
          question: "Let f(x) = (2 - x)/(1 + x), then f(f(x)) = ?",
          options: ["x", "1 - x", "2x/(1 + x)", "1/(1 + x²)"],
          answer: "x",
          subject: "Maths"
        },
        {
          question: "The maximum value of f(x) = sin²x + sin⁴x on [0, π/2] is:",
          options: ["5/4", "1", "√2", "3/2"],
          answer: "5/4",
          subject: "Maths"
        },
        {
          question: "The number of real roots of the equation cos⁻¹(x) = ln(1 + x), x ∈ (0, 1):",
          options: ["0", "1", "2", "3"],
          answer: "1",
          subject: "Maths"
        },
        {
          question: "Let S be the set of all values of λ such that the system of equations x + 2y - 3z = 2, 2x + λy + 5z = 5, 14x + 3y + μz = 33 has infinitely many solutions. Then λ + μ equals:",
          options: ["12", "10", "13", "11"],
          answer: "12",
          subject: "Maths"
        },
  
        {
          question: "In an arithmetic progression, if S₄₀ = 1030 and S₁₂ = 57, then S₃₀ - S₁₀ equals:",
          options: ["525", "510", "515", "505"],
          answer: "515",
          subject: "Maths"
        },
        {
          question: "The number of real solutions of x² + 3x + 2 = min(|x - 3|, |x + 2|):",
          options: ["2", "1", "3", "0"],
          answer: "2",
          subject: "Maths"
        },
        {
          question: "If the 30th and 12th terms of (1 + x)²ⁿ⁻¹ have coefficients A and B respectively, and 2A = 5B, then n = ?",
          options: ["19", "20", "21", "22"],
          answer: "21",
          subject: "Maths"
        },
        {
          question: "Let y = y(x) be the solution of dy/dx = (2cosx sin2x - 4 sinx)/2, with y(π/3) = 0. Then y′(π/4) + y(π/4) = ?",
          options: ["0", "1", "2", "3"],
          answer: "1",
          subject: "Maths"
        },
        {
          question: "Let S = ∑ (from n=1 to ∞) of (5 + nα)/7ⁿ. Then α = ?",
          options: ["1", "6", "1/7", "6/7"],
          answer: "6",
          subject: "Maths"
        },
  
        {
          question: "The number of functions f: {1, 2, ..., 100} → {0, 1} assigning 1 to exactly one value ≤ 98 is:",
          options: ["98", "196", "392", "784"],
          answer: "392",
          subject: "Maths"
        },
        {
          question: "Let e₁ and e₂ be the eccentricities of two hyperbolas with transverse axis product 100√10. If e₁ = √(5/2), and length of latus rectum of first = 15√2, second = 12√5, then 225e₂² = ?",
          options: ["25", "35", "45", "55"],
          answer: "55",
          subject: "Maths"
        },
        {
          question: "Evaluate: ∫[(x² + 2x + 5)/(x⁴ + 2x³ + 5x² + 2x + 1)] dx = log(...). If α + 2β = ?",
          options: ["12", "14", "16", "18"],
          answer: "16",
          subject: "Maths"
        },

        {
          question: "The equation x² + 3x + 2 = min(|x - 3|, |x + 2|) has how many real solutions?",
          options: ["0", "1", "2", "3"],
          answer: "2",
          subject: "Maths"
        },
        {
          question: "Let P be the image of point Q(7, –2, 5) in the line x–1/2 = y+1/3 = z/4. R(5, p, q) lies on this line. What is the square of the area of triangle PQR?",
          options: ["800", "925", "957", "960"],
          answer: "957",
          subject: "Maths"
        },
        {
          question: "Evaluate: ∫[(x² + 2x + 5)/(x⁴ + 2x³ + 5x² + 2x + 1)] dx. If result is log expression of form α + 2β, find α + 2β.",
          options: ["12", "14", "16", "18"],
          answer: "16",
          subject: "Maths"
        },
        {
          question: "Let e₁ and e₂ be the eccentricities of two hyperbolas with latus rectums 15√2 and 12√5 respectively. If product of transverse axes is 100√10 and e₁ = √(5/2), then 225e₂² = ?",
          options: ["25", "35", "45", "55"],
          answer: "55",
          subject: "Maths"
        },
        {
          question: "How many functions f: {1,2,...,100} → {0,1} assign 1 to exactly one value ≤ 98?",
          options: ["98", "196", "392", "784"],
          answer: "392",
          subject: "Maths"
        },
        {
          question: "If y is solution of dy/dx = (2cosx·sin2x - 4sinx)/2 with y(π/3) = 0, then y′(π/4) + y(π/4) = ?",
          options: ["0", "1", "2", "3"],
          answer: "1",
          subject: "Maths"
        },
        {
          question: "A particle's position vector is r(t) = 5t² î - 5t ĵ. What is speed and angle of motion at t = 2s?",
          options: ["5√17 m/s, tan⁻¹4 with -Y", "5√17 m/s, tan⁻¹4 with +X", "5√15 m/s, tan⁻¹4 with +X", "5√15 m/s, tan⁻¹4 with -Y"],
          answer: "5√17 m/s, tan⁻¹4 with -Y",
          subject: "Maths"
        },






        {
          question: "A point moves such that vector r(t) = 5t²î - 5tĵ. Velocity at t = 2s has magnitude and direction:",
          options: ["5√17 m/s, angle tan⁻¹(4) with -Y", "5√17 m/s, angle tan⁻¹(4) with +X", "5√15 m/s, angle tan⁻¹(4) with +X", "5√15 m/s, angle tan⁻¹(4) with -Y"],
          answer: "5√17 m/s, angle tan⁻¹(4) with -Y",
          subject: "Physics"
        },

        {
          question: "The function f(x) = log|sin(x)| + log|cos(x)| is defined in how many intervals in (0, 2π)?",
          options: ["2", "6", "4", "8"],
          answer: "8",
          subject: "Physics"
        },
  
        {
          question: "The temperature of a body in air falls from 40°C to 24°C in 4 min. If air temp is 16°C, its temperature in next 4 min will be:",
          options: ["14°C", "28°C", "42°C", "56°C"],
          answer: "56°C",
          subject: "Physics"
        },
        {
          question: "A solid sphere rolls without slipping. What is ratio of linear KE to rotational KE?",
          options: ["5:2", "4:3", "3:4", "2:5"],
          answer: "5:2",
          subject: "Physics"
        },
        {
          question: "A particle oscillates as x(t) = x₀ sin²(t/2). Which graph represents its KE as a function of x?",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 4",
          subject: "Physics"
        },
        {
          question: "A solid and hollow sphere of same mass and radius roll down an incline. Which reaches bottom first?",
          options: ["Solid", "Hollow", "Same time", "Solid twice faster"],
          answer: "Solid",
          subject: "Physics"
        },
        {
          question: "Charges q on a rotating ring of radius R with N charges. What is IA – IB for loops A and B?",
          options: ["(2/π)Nqω", "(Nqω)/(π²)", "(2Nqω)/π", "(Nqω)/π"],
          answer: "(2Nqω)/π",
          subject: "Physics"
        },
        {
          question: "Two spheres touch, one uncharged, other 4×10⁻⁸ C. After separation, force = 9×10⁻³ N. Distance?",
          options: ["1 cm", "2 cm", "3 cm", "4 cm"],
          answer: "2 cm",
          subject: "Physics"
        },
        {
          question: "Energy E and momentum p of a body of mass m relate as:",
          options: ["E² = p²c² + m²c⁴", "E² = p²c + mc²", "E = pc + mc", "E = pc + mc²"],
          answer: "E² = p²c² + m²c⁴",
          subject: "Physics"
        },
  

        {
          question: "Order of increasing wavelength: (A) Microwaves, (B) UV, (C) IR, (D) X-rays",
          options: ["λ3 < λ4 < λ2 < λ1", "λ4 < λ3 < λ1 < λ2", "λ4 < λ3 < λ2 < λ1", "λ4 < λ2 < λ3 < λ1"],
          answer: "λ4 < λ2 < λ3 < λ1",
          subject: "Physics"
        },
        {
          question: "Electron moves straight in magnetic field. Which statement is correct?",
          options: [
            "(A) true, (R) false",
            "(A) false, (R) true",
            "Both true and (R) explains (A)",
            "Both true but (R) does not explain (A)"
          ],
          answer: "Both true and (R) explains (A)",
          subject: "Physics"
        },
        {
          question: "The energy E and momentum p of a moving body of mass m are related by:",
          options: [
            "E² = p²c² + m²c⁴",
            "E² = p²c + mc²",
            "E = pc + mc",
            "E = pc + mc²"
          ],
          answer: "E² = p²c² + m²c⁴",
          subject: "Physics"
        },
        {
          question: "Assertion: In an insulated container, a gas is adiabatically shrunk to half of its initial volume. The temperature of the gas decreases. Reason: Free expansion of an ideal gas is an irreversible and an adiabatic process.",
          options: [
            "Both (A) and (R) are true but (R) is not the correct explanation of (A)",
            "(A) is true but (R) is false",
            "(A) is false but (R) is true",
            "Both (A) and (R) are true and (R) is the correct explanation of (A)"
          ],
          answer: "(A) is false but (R) is true",
          subject: "Physics"
        },
        {
          question: "In photoelectric effect, which statements are true?",
          options: [
            "(A), (B), (C)",
            "(D), (E)",
            "(A), (C), (E)",
            "(C), (E)"
          ],
          answer: "(A), (C), (E)",
          subject: "Physics"
        },
        {
          question: "Arrange in ascending order of wavelength (λ): Microwaves (λ₁), UV (λ₂), IR (λ₃), X-rays (λ₄).",
          options: [
            "λ₃ < λ₄ < λ₂ < λ₁",
            "λ₄ < λ₃ < λ₁ < λ₂",
            "λ₄ < λ₃ < λ₂ < λ₁",
            "λ₄ < λ₂ < λ₃ < λ₁"
          ],
          answer: "λ₄ < λ₂ < λ₃ < λ₁",
          subject: "Physics"
        },
        {
          question: "A point's position vector is r(t) = 5t² î - 5t ĵ. What is the velocity at t = 2s?",
          options: [
            "5√17 m/s, angle tan⁻¹4 with -Y",
            "5√17 m/s, angle tan⁻¹4 with +X",
            "5√15 m/s, angle tan⁻¹4 with +X",
            "5√15 m/s, angle tan⁻¹4 with -Y"
          ],
          answer: "5√17 m/s, angle tan⁻¹4 with -Y",
          subject: "Physics"
        },
        {
          question: "Two spheres touch. One has charge 4×10⁻⁸ C, other is uncharged. After touching and separating, force between them is 9×10⁻³ N. Distance between them?",
          options: ["1 cm", "2 cm", "3 cm", "4 cm"],
          answer: "2 cm",
          subject: "Physics"
        },
        {
          question: "Charges are placed on a rotating circle. What is the difference in enclosed current between loop A and B?",
          options: [
            "(2/π)Nqω",
            "(Nqω)/(π²)",
            "(2Nqω)/π",
            "(Nqω)/π"
          ],
          answer: "(2Nqω)/π",
          subject: "Physics"
        },




  
        {
          question: "When ethane-1,2-diamine is added to NiCl₂, the colour changes are:",
          options: [
            "Green → Pale blue → Blue → Violet",
            "Pale blue → Blue → Violet → Green",
            "Pale blue → Blue → Green → Violet",
            "Violet → Blue → Pale blue → Green"
          ],
          answer: "Green → Pale blue → Blue → Violet",
          subject: "Chemistry"
        },
        {
          question: "Which mixing gives max temp rise?",
          options: [
            "30 mL HCl and 30 mL NaOH",
            "30 mL CH₃COOH and 30 mL NaOH",
            "45 mL CH₃COOH and 25 mL NaOH",
            "50 mL HCl and 20 mL NaOH"
          ],
          answer: "30 mL HCl and 30 mL NaOH",
          subject: "Chemistry"
        },
        {
          question: "Identify correct set of reagents for aromatic substitution reaction:",
          options: [
            "Br₂ | FeBr₃, H₂O(Δ), NaOH",
            "Ac₂O, Br₂, H₂O(Δ), NaOH",
            "H₂SO₄, Ac₂O, Br₂, H₂O(Δ), NaOH",
            "Ac₂O, H₂SO₄, Br₂, NaOH"
          ],
          answer: "H₂SO₄, Ac₂O, Br₂, H₂O(Δ), NaOH",
          subject: "Chemistry"
        },


        {
          question: "The number of stereoisomers possible for 5-phenylpent-4-en-2-ol is:",
          options: ["2", "3", "4", "5"],
          answer: "4",
          subject: "Chemistry"
        },

        {
          question: "In photoelectric effect, which statements are true?",
          options: ["(A), (B), (C)", "(D), (E)", "(A), (C), (E)", "(C), (E)"],
          answer: "(A), (C), (E)",
          subject: "Chemistry"
        },

        {
          question: "Structure of major product of haloalkane + AgCN reaction?",
          options: ["(1)", "(2)", "(3)", "(4)"],
          answer: "(3)",
          subject: "Chemistry"
        },
        {
          question: "Identify compound A in reaction series involving KNO₂ and NH₄OH:",
          options: ["CoS", "MnS", "NiS", "ZnS"],
          answer: "CoS",
          subject: "Chemistry"
        },
        {
          question: "A compound has 54.2% C, 9.2% H, 36.6% O. Molar mass = 132 g/mol. What is molecular formula?",
          options: ["C6H12O6", "C5H10O4", "C4H8O3", "C3H6O2"],
          answer: "C6H12O6",
          subject: "Chemistry"
        },
        {
          question: "Given sp and sp² hybridized carbon atoms in a structure. Find count:",
          options: ["3 and 6", "4 and 6", "4 and 5", "3 and 5"],
          answer: "3 and 5",
          subject: "Chemistry"
        },
        {
          question: "The correct order of set of reagents for a given aromatic conversion is:",
          options: [
            "Br₂ | FeBr₃, H₂O(Δ), NaOH",
            "Ac₂O, Br₂, H₂O(Δ), NaOH",
            "H₂SO₄, Ac₂O, Br₂, H₂O(Δ), NaOH",
            "Ac₂O, H₂SO₄, Br₂, NaOH"
          ],
          answer: "H₂SO₄, Ac₂O, Br₂, H₂O(Δ), NaOH",
          subject: "Chemistry"
        },
        {
          question: "Structure of the major product of the given haloalkane reaction is:",
          options: ["(1)", "(2)", "(3)", "(4)"],
          answer: "(3)",
          subject: "Chemistry"
        },
        {
          question: "In the given reaction, the compound 'A' is:",
          options: ["CoS", "MnS", "NiS", "ZnS"],
          answer: "CoS",
          subject: "Chemistry"
        },
        {
          question: "A compound contains 54.2% C, 9.2% H, 36.6% O. Molar mass = 132 g/mol. Molecular formula is:",
          options: ["C6H12O6", "C5H10O4", "C4H8O3", "C3H6O2"],
          answer: "C6H12O6",
          subject: "Chemistry"
        },
        {
          question: "Number of sp and sp² hybridized carbon atoms respectively in the structure are:",
          options: ["3 and 6", "4 and 6", "4 and 5", "3 and 5"],
          answer: "3 and 5",
          subject: "Chemistry"
        },
        {
          question: "Which of the following groups are activating and ortho/para directing?",
          options: [
            "(A), (C), (D) only",
            "(A) and (C) only",
            "(A) only",
            "(A), (B) and (E) only"
          ],
          answer: "(A), (C) and (D) only",
          subject: "Chemistry"
        },

        {
          question: "Match transition metal ions to magnetic moment: (A) Ti³⁺, (B) V²⁺, (C) Ni²⁺, (D) Sc³⁺",
          options: [
            "(A)-(III), (B)-(I), (C)-(II), (D)-(IV)",
            "(A)-(IV), (B)-(II), (C)-(III), (D)-(I)",
            "(A)-(III), (B)-(I), (C)-(IV), (D)-(II)",
            "(A)-(II), (B)-(IV), (C)-(I), (D)-(III)"
          ],
          answer: "(A)-(III), (B)-(I), (C)-(IV), (D)-(II)",
          subject: "Chemistry"
        },
  
        {
          question: "Match (A) Adenine, (B) Cytosine, (C) Thymine, (D) Uracil to structure:",
          options: [
            "(A)-(III), (B)-(I), (C)-(IV), (D)-(II)",
            "(A)-(IV), (B)-(III), (C)-(II), (D)-(I)",
            "(A)-(III), (B)-(IV), (C)-(II), (D)-(I)",
            "(A)-(III), (B)-(IV), (C)-(I), (D)-(II)"
          ],
          answer: "(A)-(III), (B)-(IV), (C)-(II), (D)-(I)",
          subject: "Chemistry"
        },
        {
          question: "The heat of formation of SO₂(g) from S and O₂ using reactions with x and y kcal is:",
          options: [
            "2x/y kcal",
            "y – 2x kcal",
            "x + y kcal",
            "2x + y kcal"
          ],
          answer: "y – 2x kcal",
          subject: "Chemistry"
        },
        {
          question: "In a reaction H₂ + I₂ ⇌ 2HI, which graph correctly shows equilibrium attainment?",
          options: ["Graph 1", "Graph 2", "Graph 3", "Graph 4"],
          answer: "Graph 2",
          subject: "Chemistry"
        },
        {
          question: "In Carius method, 0.25g organic compound gives 0.15g AgBr. %Br in compound is (×10⁻¹ %)?",
          options: ["240", "255", "270", "280"],
          answer: "255",
          subject: "Chemistry"
        },
        {
          question: "Observed molar mass of MX₂ = 65.6, normal = 164. Degree of ionisation of MX₂ is:",
          options: ["60%", "65%", "70%", "75%"],
          answer: "75%",
          subject: "Chemistry"
        },
  
        // Chemistry (73–77)
        {
          question: "No. of stereoisomers for 5-phenylpent-4-en-2-ol:",
          options: ["2", "3", "4", "5"],
          answer: "4",
          subject: "Chemistry"
        },
        {
          question: "A hydrocarbon with molar mass 80 g/mol and 90% C has how many degrees of unsaturation?",
          options: ["2", "3", "4", "5"],
          answer: "3",
          subject: "Chemistry"
        },
        {
          question: "Strongest reducing agent among: Cl⁻, Cr, MnO₄⁻, Mn²⁺ based on SRP values:",
          options: ["Cl⁻", "Cr", "MnO₄⁻", "Mn²⁺"],
          answer: "Cr",
          subject: "Chemistry"
        },
        {
          question: "Which orbital has lowest energy?",
          options: ["4s (n=4)", "3px (n=3)", "3dx²–y² (n=3)", "4pz (n=4)"],
          answer: "3px (n=3)",
          subject: "Chemistry"
        },
        {
          question: "Which reagent forms yellow ppt with cobalt salt solution?",
          options: ["KCl", "KNO₂", "HCl", "NH₄OH"],
          answer: "KNO₂",
          subject: "Chemistry"
        },
  
        {
          question: "Which statement is true for 1st order reaction?",
          options: [
            "I true, II false",
            "Both false",
            "I false, II true",
            "Both true"
          ],
          answer: "I true, II false",
          subject: "Chemistry"
        },
        {
          question: "Which statement about O₃ is correct?",
          options: [
            "I false, II true",
            "Both true",
            "I true, II false",
            "Both false"
          ],
          answer: "I true, II false",
          subject: "Chemistry"
        },
        {
          question: "Identify correct acid-base mixing leading to maximum temp increase:",
          options: [
            "30 mL HCl and 30 mL NaOH",
            "30 mL CH₃COOH and 30 mL NaOH",
            "45 mL CH₃COOH and 25 mL NaOH",
            "50 mL HCl and 20 mL NaOH"
          ],
          answer: "30 mL HCl and 30 mL NaOH",
          subject: "Chemistry"
        },
        {
          question: "The number of stereoisomers for 5-phenylpent-4-en-2-ol is:",
          options: ["2", "3", "4", "5"],
          answer: "4",
          subject: "Chemistry"
        },
      ],
    },    
    
    
    
    
    {
      title:"Jee main (Test-2",
      questions:[
        {
          question: "Let 1/2 + 1/6 + 1/12 + ... up to n terms be Sn. If the sum of first six terms of an A.P. with first term –p and common difference p is S20252026, then the absolute difference between 20th and 15th terms of the A.P. is",
          options: ["25", "90", "20", "45"],
          answer: "25",
          subject: "Maths"
        },
        {
          question: "For a statistical data x₁ to x₁₀, the mean is 5.5 and Σxᵢ² = 371. Two values 4 and 5 were wrong and should be 6 and 8. The variance of the corrected data is",
          options: ["7", "5", "9", "4"],
          answer: "7",
          subject: "Maths"
        },
        {
          question: "In ∆ABC, side AC = 6, vertex B = (1, 2, 3), and A, C lie on line (x+6)/3 = (y–7)/2 = (z–7)/2. Area of ∆ABC is",
          options: ["17", "56", "21", "42"],
          answer: "21",
          subject: "Maths"
        },
        {
          question: "Let f: ℝ\\{0} → ℝ such that f(1/x) – f(x) = (5x – 6)/(3x²). If limₓ→0⁺ f(x)/x = β/α, then α + 2β =",
          options: ["6", "3", "4", "5"],
          answer: "4",
          subject: "Maths"
        },
        {
          question: "A line through (–1,2,1) parallel to (x–1)/2 = y/3 = (z+1)/4 intersects the line (x+2)/3 = (y–3)/2 = (z+4)/1. Find distance from this point to Q(4,–5,1).",
          options: ["10", "5√5", "5", "5√6"],
          answer: "5√5",
          subject: "Maths"
        },
        {
          question: "limₓ→0 (cosec x + 2cosx + 3cosx – cosx·sinx + 4) is",
          options: ["1/15", "1 – 2/15", "1/2 × 15", "0"],
          answer: "1 – 2/15",
          subject: "Maths"
        },
        {
          question: "Let **a** = 2î + ĵ + k̂, **b** = 3î + ĵ – k̂ and **c** is coplanar with **a**, **b**, perpendicular to **b**, and **a**·**c** = 5. Find **c**.",
          options: ["18", "3/2", "11/6", "16"],
          answer: "11/6",
          subject: "Maths"
        },
        {
          question: "Let R = {(x,y): 0 ≤ x ≤ 3, 0 ≤ y ≤ 9 – x²/11}. Find area of largest inscribed rectangle aligned with axes.",
          options: ["625/111", "821/123", "567/121", "730/119"],
          answer: "567/121",
          subject: "Maths"
        },
        {
          question: "Find the area of region: {(x, y): x² + 4x + 2 ≤ y ≤ |x + 2|}",
          options: ["5", "24/5", "20/3", "7"],
          answer: "20/3",
          subject: "Maths"
        },
        {
          question: "A and B throw dice alternately. A wins if he gets sum 5 before B gets 8. B wins if he gets 8 before A gets 5. A starts. Find probability A wins.",
          options: ["8/19", "9/19", "9/17", "8/17"],
          answer: "9/19",
          subject: "Maths"
        },
        {
          question: "Let y(x) solve: (5x / (1 + x²)) y + (1 + x²) dy/dx = 0, with y(0) = 0. Then y(3) = ?",
          options: ["14/3", "5√3/2", "2√2", "15/2"],
          answer: "5√3/2",
          subject: "Maths"
        },
        {
          question: "Let I(m,n) = ∫₀¹ xᵐ⁻¹ (1–x)ⁿ⁻¹ dx. Find I(9,14) + I(10,13)",
          options: ["I(9,1)", "I(1,13)", "I(9,13)", "I(19,27)"],
          answer: "I(9,13)",
          subject: "Maths"
        },
        {
          question: "The product of all rational roots of (x² – 9x + 11)² – (x – 4)(x – 5) = 3 is",
          options: ["7", "14", "21", "28"],
          answer: "14",
          subject: "Maths"
        },
        {
          question: "A circle x² + y² – 2x + 4y – 4 = 0 is reflected in line 2x – 3y + 5 = 0. Let A on image circle lie on same horizontal line as center O. Another point B(α,β), β < 4 lies on circle such that arc AB = 1/6th of perimeter. Then 3β – α = ?",
          options: ["4", "3", "4√3", "3√3"],
          answer: "4",
          subject: "Maths"
        },
        {
          question: "Let α, β be roots of 2z² – 3z – 2i = 0. Then find value of: (Re[(α + β)¹⁹ + (α + β)¹¹] × Im[(α + β)¹⁹ + (α + β)¹¹]) / (α + β)¹⁵",
          options: ["441", "398", "312", "409"],
          answer: "441",
          subject: "Maths"
        },
        {
          question: "Let f(x) = (x² + 2x + 4)(x² + 4x + 16)/(x² + 4x + 32). Find f(1/15) + f(2/15) + ... + f(598/15)",
          options: ["118", "92", "102", "108"],
          answer: "118",
          subject: "Maths"
        },
        {
          question: "The system 2x – y + z = 4; 5x + λy + 3z = 12; 100x – 47y + μz = 212 has infinite solutions. Find μ – 2λ.",
          options: ["59", "55", "56", "57"],
          answer: "57",
          subject: "Maths"
        },
        {
          question: "Let (1 + x)ⁿ⁺⁴ have binomial coefficients of 5th, 6th, and 7th terms in A.P. (i.e. C₄, C₅, C₆). If n ≠ 10, find largest coefficient in expansion.",
          options: ["10", "70", "35", "20"],
          answer: "35",
          subject: "Maths"
        },
        {
          question: "A point (13/2, 1) lies on ellipse (x²/a² + y²/b² = 1). If product of focal distances is 7/4, then find |e₁ – e₂|.",
          options: ["(3 – 2√2)/3", "(1 – 2√2)/3", "(1 – √3)/2", "(3 – 2√2)/2"],
          answer: "(3 – 2√2)/2",
          subject: "Maths"
        },
        {
          question: "Let lines 3x – 4y – α = 0, 8x – 11y – 33 = 0, and 2x – 3y + λ = 0 be concurrent. If image of point (1,2) in line 2x – 3y + λ = 0 is (57/13, –40/13), then |α·λ| = ?",
          options: ["91", "84", "113", "101"],
          answer: "91",
          subject: "Maths"
        },
        {
          question: "How many 3-digit numbers are divisible by 2 and 3 but **not** by 4 or 9?",
          options: [],
          answer: "125",
          subject: "Maths"
        },
        {
          question: "Let f be differentiable and satisfies: 2(x+2)²·f(x) – 3(x+2)² = ∫₀ˣ⁺² t·f(t) dt. If x ≥ 0, find f(2).",
          options: [],
          answer: "19",
          subject: "Maths"
        },
        {
          question: "Matrix A is 3×3, XTAX = 0 for all nonzero vectors X. If det(adj(2(A+I))) = 2^α 3^β 5^γ, find α² + β² + γ²",
          options: [],
          answer: "44",
          subject: "Maths"
        },
        {
          question: "Let S = {p₁, p₂,...,p₁₀} = first 10 primes. Let A = S ∪ P, where P is the set of all distinct products of primes in S. Find number of ordered pairs (x, y), x ∈ S, y ∈ A such that x divides y.",
          options: [],
          answer: "5120",
          subject: "Maths"
        },
        {
          question: "If α ≤ β, α + β = 8, and sec²(tan⁻¹α) + cosec²(cot⁻¹β) = 36, find α² + β.",
          options: [],
          answer: "14",
          subject: "Maths"
        },



        {
          question: "A parallel plate capacitor has area A and separation d. If E is the electric field and ε₀ is permittivity of free space, what is the potential energy stored?",
          options: ["(1/4)ε₀E²Ad", "(1/2)ε₀E²Ad", "ε₀E²Ad", "(3/4)ε₀E²Ad"],
          answer: "(1/2)ε₀E²Ad",
          subject: "Physics"
        },
        {
          question: "A plano-convex lens of refractive index 1.5 is immersed in a liquid (n = 1.2). If its plane side is silvered, and it behaves as a concave mirror with focal length 0.2 m, what is the radius of curvature?",
          options: ["0.20 m", "0.15 m", "0.25 m", "0.10 m"],
          answer: "0.10 m",
          subject: "Physics"
        },
        {
          question: "For y = (32.3 × 1125) / 27.4 with all digits significant, how should the result be reported?",
          options: ["1330", "1326.2", "1326.19", "1326.186"],
          answer: "1330",
          subject: "Physics"
        },
        {
          question: "Two satellites are launched in circular orbits of radii R and 1.03R. What is the percent increase in time period?",
          options: ["9%", "2.5%", "3%", "4.5%"],
          answer: "4.5%",
          subject: "Physics"
        },
        {
          question: "Work done to break a big water drop into 27 equal drops is 10 J. What is the work needed to break it into 64 drops?",
          options: ["10 J", "20 J", "5 J", "15 J"],
          answer: "15 J",
          subject: "Physics"
        },
        {
          question: "In YDSE using 480 nm and 600 nm light, how many bright fringes of 480 nm are needed for first coincidence with 600 nm?",
          options: ["6", "8", "5", "4"],
          answer: "5",
          subject: "Physics"
        },
        {
          question: "If pressure of an ideal gas increases linearly with temperature, which statements are true?",
          options: ["A, D, E", "E only", "A, C", "A, B, C, D"],
          answer: "A, D, E",
          subject: "Physics"
        },
        {
          question: "A car on a banked road of radius r and angle θ has max speed v₀ before slipping. What is μ?",
          options: [
            "(v₀²/rg + tanθ)/(v₀²/rg - tanθ)",
            "(v₀²/rg + tanθ)/(v₀²/rg + tanθ)",
            "(v₀²/rg - tanθ)/(v₀²/rg + tanθ)",
            "(v₀²/rg)/(v₀²/rg + tanθ)"
          ],
          answer: "(v₀²/rg + tanθ)/(v₀²/rg - tanθ)",
          subject: "Physics"
        },
        {
          question: "A force F = α + βx² acts in x-direction. If W = 5 J for 1 m displacement and α = 1 N, find β.",
          options: ["8 N/m²", "15 N/m²", "12 N/m²", "10 N/m²"],
          answer: "12 N/m²",
          subject: "Physics"
        },
        {
          question: "Two plano-convex lenses of R = 2 cm and R = 3 cm (immersed in liquid, n = 1.2) are made of n = 1.5 glass. Find f₁/f₂.",
          options: ["1:2", "1:3", "2:3", "3:5"],
          answer: "1:3",
          subject: "Physics"
        },
        {
          question: "A SHM has T = 2s and amplitude = 1 cm. If D and d are total distance and displacement in 12.5s, find D/d.",
          options: ["10", "15/4", "16/5", "25"],
          answer: "25",
          subject: "Physics"
        },
        {
          question: "An AC is I = Iₐ sin(ωt) + I_b cos(ωt). What is the RMS current?",
          options: [
            "√(Iₐ² + I_b²) / √2",
            "(Iₐ² + I_b²) / √2",
            "√(Iₐ² + I_b²)",
            "Iₐ² + I_b²"
          ],
          answer: "√(Iₐ² + I_b²) / √2",
          subject: "Physics"
        },
        {
          question: "An electron with initial velocity v₀ enters E = –E₀k̂. If its initial λ = λ₀, what is the λ after time t?",
          options: [
            "λ₀ / √(1 + (eE₀t / mv₀)²)",
            "λ₀ + (eE₀t / mv₀)",
            "λ₀",
            "λ₀ – (eE₀t / mv₀)"
          ],
          answer: "λ₀ / √(1 + (eE₀t / mv₀)²)",
          subject: "Physics"
        },
        {
          question: "A square loop of side 1 m is held in front of point charge q = 1 C. If flux is (5/ε₀) Nm²/C, find p in (5/ε₀)p.",
          options: [],
          answer: "48",
          subject: "Physics"
        },
        {
          question: "Screw gauge has least count 0.01 mm. Pitch increases by 75%, circular scale divisions reduce by 50%. New least count in ×10⁻³ mm?",
          options: [],
          answer: "35",
          subject: "Physics"
        },
        {
          question: "Current of 5 A flows in a square loop of side 0.5 m. Magnetic field at center is p × 10⁻⁶ T. Find p.",
          options: [],
          answer: "8",
          subject: "Physics"
        },
        {
          question: "A uniform solid cylinder of radius r rolls on 45° incline. Find linear acceleration of center of mass.",
          options: ["(1/√6)g", "(2/3)g", "2g", "(1/2)g"],
          answer: "(2/3)g",
          subject: "Physics"
        },
        {
          question: "In Bohr model, wavelength from A to C is 2000 Å, B to C is 6000 Å. What is λ for A to B?",
          options: ["2000 Å", "3000 Å", "6000 Å", "4000 Å"],
          answer: "3000 Å",
          subject: "Physics"
        },
        {
          question: "What is the relative decrease in focal length when power increases by 0.1 D from 2.5 D?",
          options: ["0.01", "0.04", "0.1", "0.40"],
          answer: "0.04",
          subject: "Physics"
        },
        {
          question: "Electric field lines for different capacitor geometries are given. Which configurations give 10× capacitance?",
          options: ["C and E only", "C only", "B and D only", "A only"],
          answer: "C and E only",
          subject: "Physics"
        },
        {
          question: "An object is moved by F = α + βx² and W = 5 J for 1 m. If α = 1 N, what is β?",
          options: [],
          answer: "12",
          subject: "Physics"
        },
        {
          question: "Light emission statements: Which of B, D, E apply to solar cell and LED?",
          options: ["B, E", "B, D, E", "A, C, E", "A, C"],
          answer: "B, E",
          subject: "Physics"
        },
        {
          question: "In LCR circuit, at resonance, which relation is true?",
          options: ["X_L = X_C", "Z = R", "Current is max", "All of these"],
          answer: "All of these",
          subject: "Physics"
        },
        {
          question: "Torque on a rectangular loop in uniform magnetic field is max when plane of loop is:",
          options: ["Perpendicular to B", "Parallel to B", "At 45°", "No torque"],
          answer: "Parallel to B",
          subject: "Physics"
        },
        {
          question: "A glass rod rubbed with silk is brought near a negatively charged body. What will happen?",
          options: ["Repelled", "Attracted", "No effect", "Depends on mass"],
          answer: "Repelled",
          subject: "Physics"
        },




        {
          question: "Aman plans to synthesize a molecule using aldol condensation. He performs ozonolysis on a cyclic alkene to form a dicarbonyl compound. Which alkene leads to the target molecule 'x'?",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 3",
          subject: "Chemistry"
        },
        {
          question: "Which molecule among P, Q, R, S reacts fastest with HBr (aq)?",
          options: ["P", "R", "Q", "S"],
          answer: "Q",
          subject: "Chemistry"
        },
        {
          question: "Co(NH₃)₅Cl₃ gives 3 ions in water and 2 moles of AgCl with AgNO₃. The structure of the complex is:",
          options: [
            "[Co(NH₃)₄Cl]Cl₂·NH₃",
            "[Co(NH₃)₄Cl₂]Cl·NH₃",
            "[Co(NH₃)₃Cl₃]·2NH₃",
            "[Co(NH₃)₅Cl]Cl₂"
          ],
          answer: "[Co(NH₃)₅Cl]Cl₂",
          subject: "Chemistry"
        },
        {
          question: "Which of the following is true about Ribose in DNA?",
          options: ["A, B and E", "B, D and E", "A, C and D", "A, C and E"],
          answer: "A, C and D",
          subject: "Chemistry"
        },
        {
          question: "Which is the strongest base among the given species?",
          options: ["CH₃O⁻", "NH₂⁻", "H⁻", "CH₃⁻"],
          answer: "NH₂⁻",
          subject: "Chemistry"
        },
        {
          question: "Which salt shows pH > 7 when dissolved in water?",
          options: ["NH₄Cl", "CH₃COONa", "KNO₃", "NaHSO₄"],
          answer: "CH₃COONa",
          subject: "Chemistry"
        },
        {
          question: "Match the oxoacids of phosphorus with correct oxidation state and basicity.",
          options: ["A – (3, 3), B – (5, 2)", "A – (5, 3), B – (3, 2)", "A – (3, 2), B – (5, 3)", "A – (5, 2), B – (3, 3)"],
          answer: "A – (5, 2), B – (3, 3)",
          subject: "Chemistry"
        },
        {
          question: "Which of the following is paramagnetic?",
          options: ["O₂", "N₂", "CO", "F₂"],
          answer: "O₂",
          subject: "Chemistry"
        },
        {
          question: "Which pair of solutions will form a buffer?",
          options: [
            "HCl and NaOH",
            "CH₃COOH and NaOH (1:1)",
            "CH₃COOH and CH₃COONa",
            "NaOH and NH₄Cl"
          ],
          answer: "CH₃COOH and CH₃COONa",
          subject: "Chemistry"
        },
        {
          question: "A solution contains 1:1 HCl and CH₃COOH, both 0.1 M. What is the [H⁺] in solution?",
          options: ["1.3×10⁻¹", "1×10⁻¹", "3×10⁻²", "1×10⁻²"],
          answer: "1.3×10⁻¹",
          subject: "Chemistry"
        },
        {
          question: "Which of the following contains only σ bonds?",
          options: ["CH₄", "C₂H₆", "C₂H₄", "C₂H₂"],
          answer: "C₂H₆",
          subject: "Chemistry"
        },
        {
          question: "Which reaction type forms soap?",
          options: ["Saponification", "Hydrolysis", "Neutralization", "Oxidation"],
          answer: "Saponification",
          subject: "Chemistry"
        },
        {
          question: "Which of the following represents a correct pair of enantiomers?",
          options: ["A and B", "C and D", "A and C", "B and D"],
          answer: "A and B",
          subject: "Chemistry"
        },
        {
          question: "Which molecule shows geometrical isomerism?",
          options: ["[Pt(NH₃)₂Cl₂]", "[Ni(CN)₄]²⁻", "[Co(NH₃)₅Cl]²⁺", "[Fe(CO)₅]"],
          answer: "[Pt(NH₃)₂Cl₂]",
          subject: "Chemistry"
        },
        {
          question: "Which polymer is a condensation polymer?",
          options: ["Polyethylene", "Teflon", "Nylon-6,6", "PVC"],
          answer: "Nylon-6,6",
          subject: "Chemistry"
        },
        {
          question: "The standard electrode potential for Zn²⁺/Zn and Cu²⁺/Cu are –0.76 V and +0.34 V respectively. What is the EMF of cell Zn|Zn²⁺||Cu²⁺|Cu?",
          options: [],
          answer: "1.10",
          subject: "Chemistry"
        },
        {
          question: "The bond order of N₂⁺ is ______.",
          options: [],
          answer: "2.5",
          subject: "Chemistry"
        },
        {
          question: "Number of ions produced when Al₂(SO₄)₃ is dissolved in water is ______.",
          options: [],
          answer: "5",
          subject: "Chemistry"
        },
        {
          question: "Atomic number of an element is 35. Number of unpaired electrons in ground state is ______.",
          options: [],
          answer: "1",
          subject: "Chemistry"
        },
        {
          question: "Number of resonance structures possible for CO₃²⁻ is ______.",
          options: [],
          answer: "3",
          subject: "Chemistry"
        },
        {
          question: "The half-life of a radioactive element is 10 days. Time after which 75% decays is ______ days.",
          options: [],
          answer: "20",
          subject: "Chemistry"
        },
        {
          question: "In a reaction A + B → Products, rate = k[A]²[B]. If [A] triples and [B] doubles, the rate increases by factor ______.",
          options: [],
          answer: "18",
          subject: "Chemistry"
        },
        {
          question: "1 mole of ideal gas at 300 K and 1 atm expands isothermally to double its volume. Work done (in J) is ______.",
          options: [],
          answer: "1729",
          subject: "Chemistry"
        },
        {
          question: "The oxidation state of Mn in KMnO₄ is ______.",
          options: [],
          answer: "7",
          subject: "Chemistry"
        },
        {
          question: "The pH of 10⁻⁸ M HCl is ______.",
          options: [],
          answer: "6.96",
          subject: "Chemistry"
        }
      ]
    },









    {
      title:"jee main (test-3)",
      questions:[
        {
          question: "If ∑ₙCᵣ · r³/2³ = α – β, where α, β ∈ ℝ, then (α + β)² is equal to",
          options: ["18", "27", "81", "9"],
          answer: "81",
          subject: "Maths"
        },
        {
          question: "Let z ∈ ℂ be such that (z + 2 + 3i)/(z + 2 – 3i) = (2 + 3i)/(2 – 3i). Then the sum of all possible values of z² is",
          options: ["–19 – 2i", "–19 + 2i", "19 – 2i", "19 + 2i"],
          answer: "–19 – 2i",
          subject: "Maths"
        },
        {
          question: "Let a line passing through point (4,1,0) intersect the lines L₁: (x–1)/2 = (y–1)/3 = (z–2)/4 and L₂: x–6 = y = –z + 4 at points A(α, β, γ) and B(a, b, c) respectively. Then the value of the determinant formed by A and B is",
          options: ["16", "6", "12", "8"],
          answer: "8",
          subject: "Maths"
        },
        {
          question: "A line through point (5,5) intersects the ellipse x²/36 + y²/25 = 1 at A and B such that (PA)·(PB) is maximum. Then 5(PA² + PB²) = ?",
          options: ["377", "218", "338", "290"],
          answer: "338",
          subject: "Maths"
        },
        {
          question: "Let A = {–3, –2, –1, 0, 1, 2, 3}. Let R on A be defined by xRy iff 0 ≤ x² + 2y ≤ 4. Let l be number of elements in R, m be minimum elements to make R reflexive. Then l + m = ?",
          options: ["18", "19", "17", "20"],
          answer: "18",
          subject: "Maths"
        },
        {
          question: "Let A be 3×3 matrix with |A| = 5. Then |2adj(3A · adj(2A))| = 2^α · 3^β · 5^γ. Find α + β + γ.",
          options: ["25", "26", "27", "28"],
          answer: "27",
          subject: "Maths"
        },
        {
          question: "Let f(x) be defined piecewise: x < 0 → (1 + x^a)^(1/x), x = 0 → 1 + b, x > 0 → (4 + x^1/3)^(1/x). If f(x) is continuous at x = 0, then e^(a·b·c) = ?",
          options: ["48", "72", "36", "64"],
          answer: "48",
          subject: "Maths"
        },
        {
          question: "A line through origin makes equal angles with coordinate axes and intersects lines L₁: 2x + y + 6 = 0 and L₂: 4x + 2y – p = 0 at points A, B respectively. If AB = 2/√9 and M is foot of perpendicular from A to L₂, then AM/BM = ?",
          options: ["3", "5", "2", "4"],
          answer: "3",
          subject: "Maths"
        },
        {
          question: "The sum of all rational terms in expansion of (2 + ³√3)^8 is",
          options: ["3763", "18817", "33845", "16923"],
          answer: "18817",
          subject: "Maths"
        },
        {
          question: "Line L₁ passes through (1,2,3) and is parallel to z-axis. Line L₂ passes through (λ,5,6) and is parallel to y-axis. If shortest distance between them is 3 for λ = λ₁, λ₂ (λ₂ < λ₁), then square of distance of point (λ₁, λ₂, 7) from L₁ is",
          options: ["32", "25", "37", "40"],
          answer: "25",
          subject: "Maths"
        },
        {
          question: "Radius of smallest circle touching y = x² + 2 and x = y² + 2 is",
          options: ["7√2/4", "7√2/16", "7√2/2", "7√2/8"],
          answer: "7√2/8",
          subject: "Maths"
        },
        {
          question: "The sum 1 + 3 + 11 + 25 + 45 + 71 + … up to 20 terms is equal to",
          options: ["8124", "7240", "7130", "6982"],
          answer: "7240",
          subject: "Maths"
        },
        {
          question: "Number of solutions of 2x + 3tanx = π in [–π/2, π/2] is",
          options: ["5", "3", "4", "6"],
          answer: "5",
          subject: "Maths"
        },
        {
          question: "Let domain of f(x) = log₂(log₄(log₆(3 + 4x – x²))) be (a, b). If ∫ₐᵇ [x] dx = p – q – r, where p, q, r ∈ ℕ, gcd(p,q,r)=1, then p + q + r = ?",
          options: ["8", "10", "11", "9"],
          answer: "10",
          subject: "Maths"
        },
        {
          question: "If domain of f(x) = log((12x³ – 5x + 3)/(4x² + 2e^x – x)) is [α, β), then α² + 4β = ?",
          options: ["3", "7", "4", "5"],
          answer: "4",
          subject: "Maths"
        },
        {
          question: "Let ∫₀ˣ (3t² – t) dt = f(x), and f(5) = –2. Then f(1) = ?",
          options: ["(6 – √2)/5", "(4 – √2)/5", "(2 – √2)/5", "(8 – √2)/5"],
          answer: "(6 – √2)/5",
          subject: "Maths"
        },
        {
          question: "Let a₁, a₂, a₃,… be an increasing GP of positive numbers. If a₃·a₅ = 729 and a₂ + a₄ = 111/4, then 24(a₁ + a₂ + a₃) = ?",
          options: ["130", "131", "129", "128"],
          answer: "129",
          subject: "Maths"
        },
        {
          question: "Let α, β be roots of 2x² + 3x – 16 = 0 and γ, δ be roots of x² + 3x – 1 = 0. Define Pₙ = αⁿ + βⁿ, Qₙ = γⁿ + δⁿ. Then (P₂₅ – P₂₃)/(P₂₄) + (Q₂₅ + Q₂₄)/(Q₂₃) = ?",
          options: ["4", "3", "7", "5"],
          answer: "5",
          subject: "Maths"
        },
        {
          question: "Let g be differentiable such that ∫₀ˣ g(t) dt = x ∫₀ˣ t g(t) dt, x ≥ 0, and y = y(x) solves dy/dx – y tanx = 2(x+1) secx·g(x), y(0)=0. Then y(π/3) = ?",
          options: ["(2π)/3", "(4π)/3", "(2π√3)/3", "(4π√3)/3"],
          answer: "(4π)/3",
          subject: "Maths"
        },
        {
          question: "If y = sinx/(27x) + cosx/(28x) + 1/x, then y'' + y = ?",
          options: ["28", "1", "–1", "27"],
          answer: "–1",
          subject: "Maths"
        },
        {
          question: "Let vector **a** = î + ĵ + k̂, **b** = 3î + 2ĵ – k̂, and **c** = ĵ + k̂. Let **d** = λî + μĵ + unit vector such that **a** × **d** = **b** × **d** and **c**·**d** = 1. If **c** ⊥ **a**, then the value of 2(λ + 3μ) = ?",
          options: ["5","80","20","12"],
          answer: "5",
          subject: "Maths"
        },
        {
          question: "The area of region bounded by y = max{|x|, |x – 2|}, x-axis, x = –2, x = 4 is",
          options: ["2","12","20","29"],
          answer: "12",
          subject: "Maths"
        },
        {
          question: "Let point (4, 2√3) lies on hyperbola x²/a² – y²/b² = 1, and product of focal distances is 32. If p is length of conjugate axis and q is latus rectum, then p² + q² = ?",
          options: ["28", "120", "–1", "27"],
          answer: "120",
          subject: "Maths"
        },
        {
          question: "Total number of 5-letter words using A, B, C, D, E arranged in dictionary. If P(Wₙ) = 2·P(Wₙ₋₁), and P(CDBEA) = (2^α)/(2^β – 1), then α + β = ?",
          options: ["40", "183", "17", "50"],
          answer: "183",
          subject: "Maths"
        },
        {
          question: "Number of 7-digit numbers such that digit sum is even is of the form 10^n · m. Find m + n.",
          options: ["14", "30", "17", "5"],
          answer: "14",
          subject: "Maths"
        },



        {
          question: "Match the following nuclear and chemical reactions correctly.",
          options: [
            "A-III, B-I, C-IV, D-II",
            "A-II, B-I, C-IV, D-III",
            "A-III, B-I, C-II, D-IV",
            "A-II, B-I, C-III, D-IV"
          ],
          answer: "A-III, B-I, C-II, D-IV",
          subject: "Physics"
        },
        {
          question: "A particle is released from height S. At a certain point, KE = 3× PE. What is the height and speed at that moment?",
          options: [
            "S/2, √(2gS)",
            "3S/4, √(2gS)",
            "S/4, √(2gS/3)",
            "S/4, √(3gS/2)"
          ],
          answer: "3S/4, √(2gS)",
          subject: "Physics"
        },
        {
          question: "In minimum deviation through prism, which statements are true?",
          options: [
            "A, B and E only",
            "B, D and E only",
            "B, C and D only",
            "A, C and D only"
          ],
          answer: "A, C and D only",
          subject: "Physics"
        },
        {
          question: "Radiation pressure of 450W light on a reflecting surface 2m away is:",
          options: [
            "1.5 × 10⁻⁸ Pa",
            "0",
            "3 × 10⁻⁸ Pa",
            "6 × 10⁻⁸ Pa"
          ],
          answer: "6 × 10⁻⁸ Pa",
          subject: "Physics"
        },
        {
          question: "Two dielectrics of ε₁ and ε₂ are placed in a capacitor in two configurations. What is C₁/C₂?",
          options: [
            "(4ε₁ε₂)/(ε₁ + ε₂)²",
            "ε₀(ε₁ + ε₂)/2",
            "(ε₁ε₂)/(ε₁ + ε₂)",
            "(2ε₁ε₂)/(ε₁ + ε₂)²"
          ],
          answer: "(4ε₁ε₂)/(ε₁ + ε₂)²",
          subject: "Physics"
        },
        {
          question: "A piston is attached to a spring F = –kx³ and separates gas. Work done when piston moves from L₀ to L₁ is:",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 1",
          subject: "Physics"
        },
        {
          question: "Capacitance of composite dielectric system shown is:",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 1",
          subject: "Physics"
        },
        {
          question: "Melting of ice at 273K and 1 atm involves:",
          options: [
            "Internal energy unchanged",
            "Internal energy decreases",
            "Work done by ice-water system",
            "Work done on ice-water system"
          ],
          answer: "Work done on ice-water system",
          subject: "Physics"
        },
        {
          question: "Color of light required for photoemission from metal with work function 3 eV:",
          options: ["Red", "Yellow", "Green", "Blue"],
          answer: "Blue",
          subject: "Physics"
        },
        {
          question: "Match the quantities with correct dimensions: G, GPE, GP, g.",
          options: [
            "A-II, B-IV, C-III, D-I",
            "A-IV, B-III, C-II, D-I",
            "A-I, B-III, C-IV, D-II",
            "A-III, B-II, C-I, D-IV"
          ],
          answer: "A-IV, B-III, C-II, D-I",
          subject: "Physics"
        },
        {
          question: "A tangential force of 49 N on a solid sphere of mass 20 kg on rough plane leads to acceleration of center of mass:",
          options: ["2.5 m/s²", "0.25 m/s²", "3.5 m/s²", "0.35 m/s²"],
          answer: "3.5 m/s²",
          subject: "Physics"
        },
        {
          question: "Identify correct logic gate for truth table: A·(A + B):",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 2",
          subject: "Physics"
        },
        {
          question: "Potential on shell of radius 10cm is 120V. What is potential at center, 5 cm, and 15 cm?",
          options: ["120V, 120V, 80V", "0V, 120V, 40V", "0V, 0V, 80V", "120V, 0V, 40V"],
          answer: "120V, 120V, 80V",
          subject: "Physics"
        },
        {
          question: "Cylindrical tank full of water with a 50 kg load has a hole at 90 cm. Find velocity of water when hole opens.",
          options: ["3 m/s", "2 m/s", "5 m/s", "4 m/s"],
          answer: "4 m/s",
          subject: "Physics"
        },
        {
          question: "Gas at 800 cm³ and 27°C compressed adiabatically to 200 cm³. ΔT = ? (γ = 1.5)",
          options: ["300 K", "522 K", "327 K", "600 K"],
          answer: "300 K",
          subject: "Physics"
        },
        {
          question: "System of two masses m and M with spring constant k is slightly displaced. Which is true?",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 1",
          subject: "Physics"
        },
        {
          question: "Biconvex lens has R₁ = 10, R₂ = 15, μ = 1.5. What is focal length?",
          options: ["1.5", "1.2", "1.4", "1.8"],
          answer: "1.5",
          subject: "Physics"
        },
        {
          question: "Which graphs represent one-dimensional motion of a particle?",
          options: [
            "A and B only",
            "A, C and D only",
            "A, B and C only",
            "A, B and D only"
          ],
          answer: "A, B and D only",
          subject: "Physics"
        },
        {
          question: "Wire of 25 m length and area 5 mm² has resistivity 2×10⁻⁶ Ωm and is bent into circle. Resistance between opposite points is:",
          options: ["100 Ω", "50 Ω", "12.5 Ω", "25 Ω"],
          answer: "12.5 Ω",
          subject: "Physics"
        },
        {
          question: "A loop with semicircles of radii 6π m and 4π m carries 12 A current. Find magnetic field at center in 10⁻⁷ T units.",
          options: [],
          answer: "7",
          subject: "Physics"
        },
        {
          question: "Ammeter (240 Ω) with 10 Ω shunt and 150.4 Ω series resistance. If current is 20 V / total R, what is reading in mA?",
          options: [],
          answer: "5",
          subject: "Physics"
        },
        {
          question: "Three spheres of mass m at triangle a collide in 4s. If sides doubled and mass becomes 2m, new time is:",
          options: [],
          answer: "8",
          subject: "Physics"
        },
        {
          question: "Two light waves of intensity 4I and 9I interfere. Max–min intensity = xI. What is x?",
          options: [],
          answer: "24",
          subject: "Physics"
        },
        {
          question: "Wire of 4 cm carrying 8 A in 0.15 T field. Magnetic force in mN is:",
          options: [],
          answer: "48",
          subject: "Physics"
        },
        {
          question: "The RMS speed of an ideal gas molecule at 300K if molar mass is 28 g/mol is:",
          options: [],
          answer: "515",
          subject: "Physics"
        },



        {
          question: "2 moles each of ethylene glycol and glucose are dissolved in 500 g of water. The boiling point of the resulting solution is (Kb = 0.52 K·kg·mol⁻¹):",
          options: ["377.3 K", "375.3 K", "379.2 K", "277.3 K"],
          answer: "377.3 K",
          subject: "Chemistry"
        },
        {
          question: "Which compound would give 3-methyl-6-oxoheptanal upon ozonolysis?",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 3",
          subject: "Chemistry"
        },
        {
          question: "In the following reactions, which one is NOT correct?",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 1",
          subject: "Chemistry"
        },
        {
          question: "Among 10⁻⁹ g each of Pb, Po, Pr, and Pt, which has highest number of atoms?",
          options: ["Po", "Pb", "Pt", "Pr"],
          answer: "Pr",
          subject: "Chemistry"
        },
        {
          question: "Correct order of limiting molar conductivity for cations in water at 298K is:",
          options: [
            "H⁺ > Na⁺ > K⁺ > Ca²⁺ > Mg²⁺",
            "Mg²⁺ > H⁺ > Ca²⁺ > K⁺ > Na⁺",
            "H⁺ > Ca²⁺ > Mg²⁺ > K⁺ > Na⁺",
            "H⁺ > Na⁺ > Ca²⁺ > Mg²⁺ > K⁺"
          ],
          answer: "H⁺ > Ca²⁺ > Mg²⁺ > K⁺ > Na⁺",
          subject: "Chemistry"
        },
        {
          question: "Which of the following cannot form hydrogen bonds?",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 4",
          subject: "Chemistry"
        },
        {
          question: "Which metal forms an amphoteric oxide?",
          options: ["Na", "Mg", "Zn", "Ca"],
          answer: "Zn",
          subject: "Chemistry"
        },
        {
          question: "Which polymer is a condensation polymer?",
          options: ["PVC", "Teflon", "Nylon-6,6", "Polyethylene"],
          answer: "Nylon-6,6",
          subject: "Chemistry"
        },
        {
          question: "Which complex shows maximum paramagnetism?",
          options: ["[Fe(CN)₆]⁴⁻", "[Fe(H₂O)₆]²⁺", "[FeF₆]³⁻", "[Fe(H₂O)₆]³⁺"],
          answer: "[Fe(H₂O)₆]²⁺",
          subject: "Chemistry"
        },
        {
          question: "Among B, Be, C and Li, which has correct statements?",
          options: ["B and D only", "B, C and E only", "A, C and D only", "B and C only"],
          answer: "B and C only",
          subject: "Chemistry"
        },
        {
          question: "Which is the correct order of wavelength absorbed by these complexes: [Co(NH₃)₅(H₂O)]³⁺, [Co(NH₃)₆]³⁺, [Co(CN)₆]³⁻, [CoCl(NH₃)₅]²⁺?",
          options: ["C > B > A > D", "D > C > B > A", "C > B > D > A", "D > A > B > C"],
          answer: "D > A > B > C",
          subject: "Chemistry"
        },
        {
          question: "In the reaction sequence: A → B → C, identify A, B, and C.",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 4",
          subject: "Chemistry"
        },
        {
          question: "Number of optical isomers exhibited by [Fe(C₂O₄)₃]³⁻ complex is _____",
          options: [],
          answer: "2",
          subject: "Chemistry"
        },
        {
          question: "0.42 g of C₄H₁₀N₂ liberates how much N₂ at STP in mL?",
          options: [],
          answer: "109",
          subject: "Chemistry"
        },
        {
          question: "Given: ΔHsub(C) = 710, ΔH(C–H) = 414, ΔH(H–H) = 436, ΔH(C–C) = 611 kJ/mol. What is ΔHf° of C₂H₄?",
          options: [],
          answer: "25",
          subject: "Chemistry"
        },
        {
          question: "On combustion, 0.5 g of organic compound gives 1.46 g CO₂ and 0.9 g H₂O. Percentage of carbon is:",
          options: [],
          answer: "80",
          subject: "Chemistry"
        },
        {
          question: "In Cr reactions, if B = CrO₄²⁻ and C = Cr₂O₇²⁻, then number of terminal oxygens in C is:",
          options: [],
          answer: "6",
          subject: "Chemistry"
        },
        {
          question: "Order of reactivity in SN1: (A) CH₃Cl, (B) (CH₃)₂CHCl, (C) (CH₃)₃CCl, (D) C₆H₅CH₂Cl",
          options: ["C > D > B > A", "D > C > B > A", "C > B > D > A", "B > C > D > A"],
          answer: "C > D > B > A",
          subject: "Chemistry"
        },
        {
          question: "The color of [Ti(H₂O)₆]³⁺ is due to:",
          options: [
            "Charge transfer transition",
            "d–d transition",
            "LMCT",
            "No transition (colorless)"
          ],
          answer: "d–d transition",
          subject: "Chemistry"
        },
        {
          question: "Which of the following is a pseudo-halide?",
          options: ["CN⁻", "Cl⁻", "OH⁻", "F⁻"],
          answer: "CN⁻",
          subject: "Chemistry"
        },
        {
          question: "Which one shows maximum boiling point?",
          options: ["CH₄", "C₂H₆", "CH₃OH", "CH₃Cl"],
          answer: "CH₃OH",
          subject: "Chemistry"
        },
        {
          question: "Which plot represents Raoult’s law for ideal solution?",
          options: ["Plot 1", "Plot 2", "Plot 3", "Plot 4"],
          answer: "Plot 2",
          subject: "Chemistry"
        },
        {
          question: "The compound that releases nitrogen gas in Lassaigne’s test is:",
          options: ["NH₂NH₂", "C₆H₅NH₂", "CH₃NH₂", "NH₄Cl"],
          answer: "NH₂NH₂",
          subject: "Chemistry"
        },
        {
          question: "Which statement about DNA and RNA is correct?",
          options: [
            "Both contain deoxyribose",
            "Both contain uracil",
            "DNA contains thymine, RNA contains uracil",
            "Both are double-stranded"
          ],
          answer: "DNA contains thymine, RNA contains uracil",
          subject: "Chemistry"
        },
        {
          question: "Which salt solution has highest pH?",
          options: ["CH₃COONa", "NH₄Cl", "NaHSO₄", "KNO₃"],
          answer: "CH₃COONa",
          subject: "Chemistry"
        }
      ]
      
    },






    {
      title:"jee main (test-4)",
      questions:[
        {
          question: "From all the English alphabets, five letters are chosen and are arranged in alphabetical order. The total number of ways, in which the middle letter is ‘M’, is:",
          options: ["4356", "6084", "14950", "5148"],
          answer: "5148",
          subject: "Maths"
        },
        {
          question: "Using the principal values of the inverse trigonometric functions, the sum of the maximum and the minimum values of 16((sec⁻¹x)² + (cosec⁻¹x)²) is:",
          options: ["18π²", "31π²", "24π²", "22π²"],
          answer: "22π²",
          subject: "Maths"
        },
        {
          question: "The number of non-empty equivalence relations on the set {1, 2, 3} is:",
          options: ["5", "7", "4", "6"],
          answer: "5",
          subject: "Maths"
        },
        {
          question: "Let the relation R on the set A = {1, 2, 3, ..., 10} be defined as aRb ⇔ b = a + 1. Then the number of elements in the transitive closure of R is:",
          options: ["36", "45", "55", "10"],
          answer: "45",
          subject: "Maths"
        },
        {
          question: "If a vector a makes angles α, β, γ with x, y, z axes respectively and sin²α + sin²β + sin²γ = 2, then the angle between vector a and the z-axis is:",
          options: ["π/2", "π/3", "π/4", "π/6"],
          answer: "π/3",
          subject: "Maths"
        },
        {
          question: "Let e₁ and e₂ be the eccentricities of two hyperbolas with transverse axis product 100√10. If e₁ = √(5/2), and length of latus rectum of first = 15√2, second = 12√5, then 225e₂² = ?",
          options: ["25", "35", "45", "55"],
          answer: "55",
          subject: "Maths"
        },
        {
          question: "If A = [1 2; 3 4] and Aⁿ = [a b; c d], then a + d is equal to:",
          options: ["Fₙ₊₁", "F₂ₙ", "Fₙ₋₁", "Fₙ"],
          answer: "Fₙ₊₁",
          subject: "Maths"
        },
        {
          question: "Let f(x) = 7tan⁸x + 7tan⁶x − 3tan⁴x − 3tan²x, and I₁ = ∫₀^π/4 f(x) dx, I₂ = ∫₀^π/4 x f(x) dx. Then 7I₁ + 12I₂ is equal to:",
          options: ["π", "2π", "1", "2"],
          answer: "1",
          subject: "Maths"
        },
        {
          question: "Let vector **b** = λî + 4k̂ and vector **a** = 2î + 2ĵ + 2k̂. If **a** + **c** = 7 and **c** is projection of **b** on **a**, then area of parallelogram formed by **b** and **c** is:",
          options: [],
          answer: "16",
          subject: "Maths"
        },
        {
          question: "Let ∑ (r=0 to 15) [2^(r+1)]/(r+1) C₁₅ = m/n with gcd(m,n)=1, then m − n equals:",
          options: [],
          answer: "2035",
          subject: "Maths"
        },
        {
          question: "Let f(x) = −3x² − 2 for x < 1 and ax² + bx for x ≥ 1. If f(x) is differentiable for all x, then area enclosed by y = f(x) and y = −20 is 3α + β, α, β ∈ Z, then α + β =",
          options: [],
          answer: "10",
          subject: "Maths"
        },
        {
          question: "Let matrix A be of order 3 such that det(A) = −2. If det(3adj(−6adj(3A))) = 2ᵐ + n·3ᵐⁿ, with m > n, then 4m + 2n = ?",
          options: [],
          answer: "34",
          subject: "Maths"
        },
        {
          question: "Let f(x) = log₂(log₄(log₆(3 + 4x − x²))). If the domain is (a, b) and ∫ₐ^ᵦ x dx = p − q − r, then p + q + r =",
          options: [],
          answer: "47",
          subject: "Maths"
        },
        {
          question: "Find number of solutions of 2x + 3tanx = π in x ∈ [−π/2, π/2]",
          options: ["5", "3", "4", "6"],
          answer: "5",
          subject: "Maths"
        },
        {
          question: "Sum of 20 terms of the series 1 + 3 + 11 + 25 + 45 + 71 + ⋯ is:",
          options: ["8124", "7240", "7130", "6982"],
          answer: "7240",
          subject: "Maths"
        },
        {
          question: "The number of solutions of |x − 2| + |x − 4| + |x − 6| = 10 is:",
          options: ["3", "2", "1", "0"],
          answer: "3",
          subject: "Maths"
        },
        {
          question: "If f(x) = x³ − 3x² − 9x + 6, then total number of critical points is:",
          options: ["2", "1", "3", "0"],
          answer: "2",
          subject: "Maths"
        },
        {
          question: "Let α and β be roots of x² + x + 1 = 0, then |α³ + β³| equals:",
          options: ["1", "2", "0", "√3"],
          answer: "1",
          subject: "Maths"
        },
        {
          question: "A man has 4 keys and only one opens the lock. He tries them one after another without replacement. Probability lock opens on second try is:",
          options: ["1/2", "1/4", "1/3", "3/4"],
          answer: "1/3",
          subject: "Maths"
        },
        {
          question: "If P(E) = 3/5, P(F) = 2/5, and P(E ∩ F) = 1/5, then P(E ∪ F) equals:",
          options: ["4/5", "3/5", "1", "2/5"],
          answer: "4/5",
          subject: "Maths"
        },
        {
          question: "Let z₁ = 1 + i and z₂ = 2 − 3i. Then |z₁z₂| equals:",
          options: ["√10", "√13", "√26", "√20"],
          answer: "√26",
          subject: "Maths"
        },
        {
          question: "If (1 + i)^n is purely real, then n is divisible by:",
          options: ["4", "2", "3", "5"],
          answer: "4",
          subject: "Maths"
        },
        {
          question: "Find the remainder when (x² + x + 1)(x − 1)³ is divided by x² + 1",
          options: ["2x + 3", "x − 1", "x + 2", "x² + 1"],
          answer: "2x + 3",
          subject: "Maths"
        },
        {
          question: "Area of triangle with sides a = 13, b = 14, and included angle C = π/6 is:",
          options: ["91", "91/2", "91√3/2", "91√2/2"],
          answer: "91/2",
          subject: "Maths"
        },
        {
          question: "If f(x) = tan⁻¹x + cot⁻¹x, then f(x) is:",
          options: ["π/2", "π", "0", "undefined"],
          answer: "π/2",
          subject: "Maths"
        },




        {
          question: "An electron enters symmetrically between two oppositely charged metal plates (each of 10 cm length) with horizontal velocity 10⁶ m/s. If electric field is 9.1 V/cm, what is the vertical component of velocity as it exits?",
          options: ["0", "16 × 10⁶", "16 × 10⁴", "1 × 10⁶"],
          answer: "16 × 10⁶",
          subject: "Physics"
        },
        {
          question: "A 10⁻³ kg ice at –10°C is converted to vapour at 110°C. What is the heat required?",
          options: ["3022 J", "3043 J", "3024 J", "3003 J"],
          answer: "3043 J",
          subject: "Physics"
        },
        {
          question: "If B is magnetic field and μ₀ is permeability of free space, dimensions of B/μ₀ are:",
          options: ["ML²T⁻²A⁻¹", "L⁻¹A", "LT⁻²A⁻¹", "MT⁻²A⁻¹"],
          answer: "L⁻¹A",
          subject: "Physics"
        },
        {
          question: "A bob of mass m performs vertical circular motion on a string. If it becomes slack at point D, ratio of KE at point B to point C is:",
          options: ["1", "3", "4", "2"],
          answer: "2",
          subject: "Physics"
        },
        {
          question: "A uniform disc of radius R has a circular portion of radius R/2 removed. Find the moment of inertia of remaining part about central axis.",
          options: ["27/32 MR²", "217/32 MR²", "213/32 MR²", "29/32 MR²"],
          answer: "213/32 MR²",
          subject: "Physics"
        },
        {
          question: "A 40 μF capacitor is connected to 100 V. If a dielectric of K = 2 is introduced, extra charge and energy change are:",
          options: ["2 mC & 0.4 J", "8 mC & 2.0 J", "4 mC & 0.2 J", "2 mC & 0.2 J"],
          answer: "4 mC & 0.2 J",
          subject: "Physics"
        },
        {
          question: "An ideal monoatomic gas is heated by 50°C at constant pressure. If E₁ and E₂ are heat and internal energy change respectively, and E₁/E₂ = 9/2, then x =",
          options: [],
          answer: "15",
          subject: "Physics"
        },
        {
          question: "Two soap bubbles of radius 2 cm and 4 cm in contact. Radius of curvature of common surface is:",
          options: [],
          answer: "4",
          subject: "Physics"
        },
        {
          question: "Ratio of heights in first and last second of projectile with u = 60 m/s at 30° is:",
          options: [],
          answer: "5",
          subject: "Physics"
        },
        {
          question: "In YDSE, fringe width decreases in a denser medium. This is because:",
          options: ["Both A and R true, R is correct explanation", "A true, R false", "Both true, R not explanation", "A false, R true"],
          answer: "Both A and R true, R is correct explanation",
          subject: "Physics"
        },
        {
          question: "Sliding contact of potentiometer at center, Rp = 1Ω, Re = 2Ω, find current in circuit.",
          options: ["1.35 A", "1.0 A", "0.3 A", "0.9 A"],
          answer: "1.0 A",
          subject: "Physics"
        },
        {
          question: "A loop carries current I = 12 A, formed of semicircles with radii 6π m and 4π m. Resultant magnetic field at center is k × 10⁻⁷ T. Find k:",
          options: [],
          answer: "7",
          subject: "Physics"
        },
        {
          question: "An ammeter with 240 Ω internal resistance has 10 Ω shunt and 150.4 Ω series. If 20V applied, what does it read in mA?",
          options: [],
          answer: "5",
          subject: "Physics"
        },
        {
          question: "Three spheres of mass m placed at triangle of side a collide every 4s. If side doubled and mass 2m, new time between collisions is:",
          options: [],
          answer: "8",
          subject: "Physics"
        },
        {
          question: "Two light waves of intensity 4I and 9I interfere. Max - min intensity is xI. Find x:",
          options: [],
          answer: "24",
          subject: "Physics"
        },
        {
          question: "A wire of length 4 cm carrying 8 A placed in 0.15 T field. Magnetic force (in mN) is:",
          options: [],
          answer: "48",
          subject: "Physics"
        },
        {
          question: "RMS speed of ideal gas molecules at 300K and molar mass 28 g/mol is (in m/s):",
          options: [],
          answer: "515",
          subject: "Physics"
        },
        {
          question: "Thermal conductors with k₁=60, k₂=120, k₃=135 W/mK arranged in composite way. Steady state temp at node is ____°C.",
          options: [],
          answer: "40",
          subject: "Physics"
        },
        {
          question: "Dimensions of B/μ₀ are:",
          options: ["ML²T⁻²A⁻¹", "L⁻¹A", "LT⁻²A⁻¹", "MT⁻²A⁻¹"],
          answer: "L⁻¹A",
          subject: "Physics"
        },
        {
          question: "The correct expression for potential energy stored in a parallel plate capacitor is:",
          options: [
            "¼ ε₀ E²Ad", "½ ε₀ E²Ad", "ε₀ E²Ad", "¾ ε₀ E²Ad"
          ],
          answer: "½ ε₀ E²Ad",
          subject: "Physics"
        },
        {
          question: "A plano-convex lens with μ = 1.5 is immersed in liquid μ = 1.2. Plane face silvered, behaves like concave mirror with f = 0.2 m. Find radius of curvature.",
          options: ["0.20 m", "0.15 m", "0.25 m", "0.10 m"],
          answer: "0.10 m",
          subject: "Physics"
        },
        {
          question: "Significant digits: Compute and report y = (32.3 × 1125)/27.4 to proper sig. figs.",
          options: ["1330", "1326.2", "1326.19", "1326.186"],
          answer: "1330",
          subject: "Physics"
        },
        {
          question: "A satellite orbits Earth in circular radius R. Another satellite orbits at 1.03R. What’s time period ratio?",
          options: ["1.03", "1.045", "1.06", "1.015"],
          answer: "1.045",
          subject: "Physics"
        },
        {
          question: "An object projected vertically upward from Earth with KE = 1.5 × PE. Height attained?",
          options: ["h = 3R/4", "h = R", "h = R/2", "h = R/3"],
          answer: "3R/4",
          subject: "Physics"
        },
        {
          question: "A circular wire loop with resistance 9Ω bent into equilateral triangle. Resistance across any two vertices?",
          options: [],
          answer: "2",
          subject: "Physics"
        },




        {
          question: "How many different stereoisomers are possible for the given molecule?",
          options: ["2", "4", "3", "1"],
          answer: "4",
          subject: "Chemistry"
        },
        {
          question: "CH₃–O–CH₂–Cl undergoes SN1 though it is primary halide. Another compound doesn’t undergo SN2 easily. Which is correct?",
          options: [
            "Both Statement I and Statement II are incorrect",
            "Both Statement I and Statement II are correct",
            "Statement I is correct but Statement II is incorrect",
            "Statement I is incorrect but Statement II is correct"
          ],
          answer: "Both Statement I and Statement II are correct",
          subject: "Chemistry"
        },
        {
          question: "A liquid is mechanically stirred in insulated vessel at 25°C. Which thermodynamic relation is correct?",
          options: ["ΔU > 0, q = 0, w > 0", "ΔU < 0, q = 0, w > 0", "ΔU = 0, q < 0, w > 0", "ΔU = 0, q = 0, w = 0"],
          answer: "ΔU > 0, q = 0, w > 0",
          subject: "Chemistry"
        },
        {
          question: "One mole of Co(NH₃)₅Cl₃ gives 3 ions in solution and 2 moles of AgCl with AgNO₃. Structure is:",
          options: [
            "[Co(NH₃)₄Cl].Cl₂.NH₃",
            "[Co(NH₃)₄Cl₂].Cl.NH₃",
            "[Co(NH₃)₃Cl₃].2NH₃",
            "[Co(NH₃)₅Cl]Cl₂"
          ],
          answer: "[Co(NH₃)₅Cl]Cl₂",
          subject: "Chemistry"
        },
        {
          question: "Which statements about Ribose in DNA are correct?",
          options: [
            "A, B and E only",
            "B, D and E only",
            "A, C and D only",
            "A, D and E only"
          ],
          answer: "A, C and D only",
          subject: "Chemistry"
        },
        {
          question: "Which is correct about H₂O, NH₃ and CH₄ geometry?",
          options: [
            "H₂O and NH₃ are angular and pyramidal respectively",
            "CH₄ is planar",
            "NH₃ is angular",
            "CH₄ is angular"
          ],
          answer: "H₂O and NH₃ are angular and pyramidal respectively",
          subject: "Chemistry"
        },
        {
          question: "The given 3D structure is for which compound?",
          options: ["Ammonia", "Benzene", "Urea", "Acetylene"],
          answer: "Urea",
          subject: "Chemistry"
        },
        {
          question: "Which is a pseudo-halide?",
          options: ["CN⁻", "F⁻", "Cl⁻", "OH⁻"],
          answer: "CN⁻",
          subject: "Chemistry"
        },
        {
          question: "Choose correct order of increasing boiling point: 10⁻⁴ M NaCl, Urea, 10⁻³ M NaCl, 10⁻² M NaCl.",
          options: [
            "(ii) < (i) ≡ (iii) < (iv)",
            "(i) < (ii) < (iii) < (iv)",
            "(iv) < (iii) < (i) < (ii)",
            "(ii) < (i) < (iii) < (iv)"
          ],
          answer: "(ii) < (i) < (iii) < (iv)",
          subject: "Chemistry"
        },
        {
          question: "A vessel at 1000 K has CO₂ at 0.5 atm. After equilibrium with graphite: CO₂ ⇌ 2CO, total pressure = 0.8 atm. Kp = ?",
          options: ["0.18 atm", "1.8 atm", "0.3 atm", "3 atm"],
          answer: "1.8 atm",
          subject: "Chemistry"
        },
        {
          question: "Which of the following acids is a vitamin?",
          options: ["Saccharic acid", "Adipic acid", "Aspartic acid", "Ascorbic acid"],
          answer: "Ascorbic acid",
          subject: "Chemistry"
        },
        {
          question: "In Carius method, 180 mg organic compound gives 143.5 mg AgCl. % Cl = ?",
          options: [],
          answer: "20",
          subject: "Chemistry"
        },
        {
          question: "0.1 M 40 mL HCl used to neutralize excess Ca(OH)₂ after reacting with CO₂. Volume of container (cm³)?",
          options: [],
          answer: "45",
          subject: "Chemistry"
        },
        {
          question: "The volume strength of 1.5 M H₂O₂ solution is:",
          options: [],
          answer: "16",
          subject: "Chemistry"
        },
        {
          question: "For reaction: A + B ⇌ C, initial [A] = [B] = 1M, [C] = 0. At equilibrium, [C] = 0.6 M. Kc = ?",
          options: [],
          answer: "2.25",
          subject: "Chemistry"
        },
        {
          question: "C₂H₆ undergoes chlorination. Number of monochlorinated products possible?",
          options: [],
          answer: "2",
          subject: "Chemistry"
        },
        {
          question: "What is the correct IUPAC name of CH₃CH(OH)CH₂COOH?",
          options: ["2-Hydroxybutanoic acid", "3-Hydroxybutanoic acid", "Butanoic acid", "But-3-enoic acid"],
          answer: "3-Hydroxybutanoic acid",
          subject: "Chemistry"
        },
        {
          question: "Gibbs free energy change when 2 moles of H₂ and 1 mole of O₂ at 1 atm, 298 K form H₂O (l) is:",
          options: [],
          answer: "–474",
          subject: "Chemistry"
        },
        {
          question: "Identify complex from which 2 mol AgCl formed per mol complex: [Pt(NH₃)₂Cl₂], [Pt(NH₃)₄]Cl₂, [Pt(NH₃)₄Cl₂], [PtCl₄]²⁻",
          options: [],
          answer: "[Pt(NH₃)₄]Cl₂",
          subject: "Chemistry"
        },
        {
          question: "Which one is correct order of E° (V): Fe³⁺/Fe²⁺, Cu²⁺/Cu⁺, Mn³⁺/Mn²⁺?",
          options: [],
          answer: "Cu²⁺/Cu⁺ > Fe³⁺/Fe²⁺ > Mn³⁺/Mn²⁺",
          subject: "Chemistry"
        },
        {
          question: "Which compound gives positive carbylamine test?",
          options: ["CH₃NH₂", "C₂H₅NO₂", "CH₃CONH₂", "CH₃CH₂CN"],
          answer: "CH₃NH₂",
          subject: "Chemistry"
        },
        {
          question: "Which of the following is most reactive in SN1 reaction?",
          options: ["CH₃Cl", "(CH₃)₂CHCl", "CH₃CH₂Cl", "(CH₃)₃CCl"],
          answer: "(CH₃)₃CCl",
          subject: "Chemistry"
        },
        {
          question: "Which complex shows highest λ absorbed among: [Co(NH₃)₆]³⁺, [Co(CN)₆]³⁻, [CoCl(NH₃)₅]²⁺, [Co(NH₃)₅(H₂O)]³⁺?",
          options: [],
          answer: "[CoCl(NH₃)₅]²⁺",
          subject: "Chemistry"
        },
        {
          question: "Which of the following is a strong acid?",
          options: ["CH₃COOH", "H₂SO₄", "HCOOH", "HNO₂"],
          answer: "H₂SO₄",
          subject: "Chemistry"
        },
        {
          question: "Which among the following species is paramagnetic?",
          options: ["O₂", "N₂", "F₂", "Cl₂"],
          answer: "O₂",
          subject: "Chemistry"
        },  
      ]
    },
  ],




///////////////////////////////////////////////////////////////////////////////////////









  3: [
    {
      title: "jee main (Test-1)",
      questions: [
        // Maths (1–7)
        {
          question: "Group A consists of 7 boys and 3 girls, while group B consists of 6 boys and 5 girls. The number of ways, 4 boys and 4 girls can be invited for a picnic if 5 of them must be from group A and the remaining 3 from group B, is equal to:",
          options: ["8575", "8750", "8925", "9100"],
          answer: "8925",
          subject: "Maths"
        },
        {
          question: "Let a = 3î - ĵ + 2k̂, b = a × (2î - k̂) and c = b × k̂. Then the projection of 2ĵ on a is:",
          options: ["14", "2√7", "2√14", "3√7"],
          answer: "2√14",
          subject: "Maths"
        },
        {
          question: "Let f: (0, ∞) → ℝ be differentiable and satisfies x²f′(x) = 2xf(x) + 3, with f(1) = 4. Then 2f(2) is equal to:",
          options: ["23", "19", "29", "39"],
          answer: "39",
          subject: "Maths"
        },
        {
          question: "Let f(x) = (2 - x)/(1 + x), then f(f(x)) = ?",
          options: ["x", "1 - x", "2x/(1 + x)", "1/(1 + x²)"],
          answer: "x",
          subject: "Maths"
        },
        {
          question: "The maximum value of f(x) = sin²x + sin⁴x on [0, π/2] is:",
          options: ["5/4", "1", "√2", "3/2"],
          answer: "5/4",
          subject: "Maths"
        },
        {
          question: "The number of real roots of the equation cos⁻¹(x) = ln(1 + x), x ∈ (0, 1):",
          options: ["0", "1", "2", "3"],
          answer: "1",
          subject: "Maths"
        },
        {
          question: "Let S be the set of all values of λ such that the system of equations x + 2y - 3z = 2, 2x + λy + 5z = 5, 14x + 3y + μz = 33 has infinitely many solutions. Then λ + μ equals:",
          options: ["12", "10", "13", "11"],
          answer: "12",
          subject: "Maths"
        },
  
        {
          question: "In an arithmetic progression, if S₄₀ = 1030 and S₁₂ = 57, then S₃₀ - S₁₀ equals:",
          options: ["525", "510", "515", "505"],
          answer: "515",
          subject: "Maths"
        },
        {
          question: "The number of real solutions of x² + 3x + 2 = min(|x - 3|, |x + 2|):",
          options: ["2", "1", "3", "0"],
          answer: "2",
          subject: "Maths"
        },
        {
          question: "If the 30th and 12th terms of (1 + x)²ⁿ⁻¹ have coefficients A and B respectively, and 2A = 5B, then n = ?",
          options: ["19", "20", "21", "22"],
          answer: "21",
          subject: "Maths"
        },
        {
          question: "Let y = y(x) be the solution of dy/dx = (2cosx sin2x - 4 sinx)/2, with y(π/3) = 0. Then y′(π/4) + y(π/4) = ?",
          options: ["0", "1", "2", "3"],
          answer: "1",
          subject: "Maths"
        },
        {
          question: "Let S = ∑ (from n=1 to ∞) of (5 + nα)/7ⁿ. Then α = ?",
          options: ["1", "6", "1/7", "6/7"],
          answer: "6",
          subject: "Maths"
        },
  
        {
          question: "The number of functions f: {1, 2, ..., 100} → {0, 1} assigning 1 to exactly one value ≤ 98 is:",
          options: ["98", "196", "392", "784"],
          answer: "392",
          subject: "Maths"
        },
        {
          question: "Let e₁ and e₂ be the eccentricities of two hyperbolas with transverse axis product 100√10. If e₁ = √(5/2), and length of latus rectum of first = 15√2, second = 12√5, then 225e₂² = ?",
          options: ["25", "35", "45", "55"],
          answer: "55",
          subject: "Maths"
        },
        {
          question: "Evaluate: ∫[(x² + 2x + 5)/(x⁴ + 2x³ + 5x² + 2x + 1)] dx = log(...). If α + 2β = ?",
          options: ["12", "14", "16", "18"],
          answer: "16",
          subject: "Maths"
        },

        {
          question: "The equation x² + 3x + 2 = min(|x - 3|, |x + 2|) has how many real solutions?",
          options: ["0", "1", "2", "3"],
          answer: "2",
          subject: "Maths"
        },
        {
          question: "Let P be the image of point Q(7, –2, 5) in the line x–1/2 = y+1/3 = z/4. R(5, p, q) lies on this line. What is the square of the area of triangle PQR?",
          options: ["800", "925", "957", "960"],
          answer: "957",
          subject: "Maths"
        },
        {
          question: "Evaluate: ∫[(x² + 2x + 5)/(x⁴ + 2x³ + 5x² + 2x + 1)] dx. If result is log expression of form α + 2β, find α + 2β.",
          options: ["12", "14", "16", "18"],
          answer: "16",
          subject: "Maths"
        },
        {
          question: "Let e₁ and e₂ be the eccentricities of two hyperbolas with latus rectums 15√2 and 12√5 respectively. If product of transverse axes is 100√10 and e₁ = √(5/2), then 225e₂² = ?",
          options: ["25", "35", "45", "55"],
          answer: "55",
          subject: "Maths"
        },
        {
          question: "How many functions f: {1,2,...,100} → {0,1} assign 1 to exactly one value ≤ 98?",
          options: ["98", "196", "392", "784"],
          answer: "392",
          subject: "Maths"
        },
        {
          question: "If y is solution of dy/dx = (2cosx·sin2x - 4sinx)/2 with y(π/3) = 0, then y′(π/4) + y(π/4) = ?",
          options: ["0", "1", "2", "3"],
          answer: "1",
          subject: "Maths"
        },
        {
          question: "A particle's position vector is r(t) = 5t² î - 5t ĵ. What is speed and angle of motion at t = 2s?",
          options: ["5√17 m/s, tan⁻¹4 with -Y", "5√17 m/s, tan⁻¹4 with +X", "5√15 m/s, tan⁻¹4 with +X", "5√15 m/s, tan⁻¹4 with -Y"],
          answer: "5√17 m/s, tan⁻¹4 with -Y",
          subject: "Maths"
        },






        {
          question: "A point moves such that vector r(t) = 5t²î - 5tĵ. Velocity at t = 2s has magnitude and direction:",
          options: ["5√17 m/s, angle tan⁻¹(4) with -Y", "5√17 m/s, angle tan⁻¹(4) with +X", "5√15 m/s, angle tan⁻¹(4) with +X", "5√15 m/s, angle tan⁻¹(4) with -Y"],
          answer: "5√17 m/s, angle tan⁻¹(4) with -Y",
          subject: "Physics"
        },

        {
          question: "The function f(x) = log|sin(x)| + log|cos(x)| is defined in how many intervals in (0, 2π)?",
          options: ["2", "6", "4", "8"],
          answer: "8",
          subject: "Physics"
        },
  
        {
          question: "The temperature of a body in air falls from 40°C to 24°C in 4 min. If air temp is 16°C, its temperature in next 4 min will be:",
          options: ["14°C", "28°C", "42°C", "56°C"],
          answer: "56°C",
          subject: "Physics"
        },
        {
          question: "A solid sphere rolls without slipping. What is ratio of linear KE to rotational KE?",
          options: ["5:2", "4:3", "3:4", "2:5"],
          answer: "5:2",
          subject: "Physics"
        },
        {
          question: "A particle oscillates as x(t) = x₀ sin²(t/2). Which graph represents its KE as a function of x?",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 4",
          subject: "Physics"
        },
        {
          question: "A solid and hollow sphere of same mass and radius roll down an incline. Which reaches bottom first?",
          options: ["Solid", "Hollow", "Same time", "Solid twice faster"],
          answer: "Solid",
          subject: "Physics"
        },
        {
          question: "Charges q on a rotating ring of radius R with N charges. What is IA – IB for loops A and B?",
          options: ["(2/π)Nqω", "(Nqω)/(π²)", "(2Nqω)/π", "(Nqω)/π"],
          answer: "(2Nqω)/π",
          subject: "Physics"
        },
        {
          question: "Two spheres touch, one uncharged, other 4×10⁻⁸ C. After separation, force = 9×10⁻³ N. Distance?",
          options: ["1 cm", "2 cm", "3 cm", "4 cm"],
          answer: "2 cm",
          subject: "Physics"
        },
        {
          question: "Energy E and momentum p of a body of mass m relate as:",
          options: ["E² = p²c² + m²c⁴", "E² = p²c + mc²", "E = pc + mc", "E = pc + mc²"],
          answer: "E² = p²c² + m²c⁴",
          subject: "Physics"
        },
  

        {
          question: "Order of increasing wavelength: (A) Microwaves, (B) UV, (C) IR, (D) X-rays",
          options: ["λ3 < λ4 < λ2 < λ1", "λ4 < λ3 < λ1 < λ2", "λ4 < λ3 < λ2 < λ1", "λ4 < λ2 < λ3 < λ1"],
          answer: "λ4 < λ2 < λ3 < λ1",
          subject: "Physics"
        },
        {
          question: "Electron moves straight in magnetic field. Which statement is correct?",
          options: [
            "(A) true, (R) false",
            "(A) false, (R) true",
            "Both true and (R) explains (A)",
            "Both true but (R) does not explain (A)"
          ],
          answer: "Both true and (R) explains (A)",
          subject: "Physics"
        },
        {
          question: "The energy E and momentum p of a moving body of mass m are related by:",
          options: [
            "E² = p²c² + m²c⁴",
            "E² = p²c + mc²",
            "E = pc + mc",
            "E = pc + mc²"
          ],
          answer: "E² = p²c² + m²c⁴",
          subject: "Physics"
        },
        {
          question: "Assertion: In an insulated container, a gas is adiabatically shrunk to half of its initial volume. The temperature of the gas decreases. Reason: Free expansion of an ideal gas is an irreversible and an adiabatic process.",
          options: [
            "Both (A) and (R) are true but (R) is not the correct explanation of (A)",
            "(A) is true but (R) is false",
            "(A) is false but (R) is true",
            "Both (A) and (R) are true and (R) is the correct explanation of (A)"
          ],
          answer: "(A) is false but (R) is true",
          subject: "Physics"
        },
        {
          question: "In photoelectric effect, which statements are true?",
          options: [
            "(A), (B), (C)",
            "(D), (E)",
            "(A), (C), (E)",
            "(C), (E)"
          ],
          answer: "(A), (C), (E)",
          subject: "Physics"
        },
        {
          question: "Arrange in ascending order of wavelength (λ): Microwaves (λ₁), UV (λ₂), IR (λ₃), X-rays (λ₄).",
          options: [
            "λ₃ < λ₄ < λ₂ < λ₁",
            "λ₄ < λ₃ < λ₁ < λ₂",
            "λ₄ < λ₃ < λ₂ < λ₁",
            "λ₄ < λ₂ < λ₃ < λ₁"
          ],
          answer: "λ₄ < λ₂ < λ₃ < λ₁",
          subject: "Physics"
        },
        {
          question: "A point's position vector is r(t) = 5t² î - 5t ĵ. What is the velocity at t = 2s?",
          options: [
            "5√17 m/s, angle tan⁻¹4 with -Y",
            "5√17 m/s, angle tan⁻¹4 with +X",
            "5√15 m/s, angle tan⁻¹4 with +X",
            "5√15 m/s, angle tan⁻¹4 with -Y"
          ],
          answer: "5√17 m/s, angle tan⁻¹4 with -Y",
          subject: "Physics"
        },
        {
          question: "Two spheres touch. One has charge 4×10⁻⁸ C, other is uncharged. After touching and separating, force between them is 9×10⁻³ N. Distance between them?",
          options: ["1 cm", "2 cm", "3 cm", "4 cm"],
          answer: "2 cm",
          subject: "Physics"
        },
        {
          question: "Charges are placed on a rotating circle. What is the difference in enclosed current between loop A and B?",
          options: [
            "(2/π)Nqω",
            "(Nqω)/(π²)",
            "(2Nqω)/π",
            "(Nqω)/π"
          ],
          answer: "(2Nqω)/π",
          subject: "Physics"
        },




  
        {
          question: "When ethane-1,2-diamine is added to NiCl₂, the colour changes are:",
          options: [
            "Green → Pale blue → Blue → Violet",
            "Pale blue → Blue → Violet → Green",
            "Pale blue → Blue → Green → Violet",
            "Violet → Blue → Pale blue → Green"
          ],
          answer: "Green → Pale blue → Blue → Violet",
          subject: "Chemistry"
        },
        {
          question: "Which mixing gives max temp rise?",
          options: [
            "30 mL HCl and 30 mL NaOH",
            "30 mL CH₃COOH and 30 mL NaOH",
            "45 mL CH₃COOH and 25 mL NaOH",
            "50 mL HCl and 20 mL NaOH"
          ],
          answer: "30 mL HCl and 30 mL NaOH",
          subject: "Chemistry"
        },
        {
          question: "Identify correct set of reagents for aromatic substitution reaction:",
          options: [
            "Br₂ | FeBr₃, H₂O(Δ), NaOH",
            "Ac₂O, Br₂, H₂O(Δ), NaOH",
            "H₂SO₄, Ac₂O, Br₂, H₂O(Δ), NaOH",
            "Ac₂O, H₂SO₄, Br₂, NaOH"
          ],
          answer: "H₂SO₄, Ac₂O, Br₂, H₂O(Δ), NaOH",
          subject: "Chemistry"
        },


        {
          question: "The number of stereoisomers possible for 5-phenylpent-4-en-2-ol is:",
          options: ["2", "3", "4", "5"],
          answer: "4",
          subject: "Chemistry"
        },

        {
          question: "In photoelectric effect, which statements are true?",
          options: ["(A), (B), (C)", "(D), (E)", "(A), (C), (E)", "(C), (E)"],
          answer: "(A), (C), (E)",
          subject: "Chemistry"
        },

        {
          question: "Structure of major product of haloalkane + AgCN reaction?",
          options: ["(1)", "(2)", "(3)", "(4)"],
          answer: "(3)",
          subject: "Chemistry"
        },
        {
          question: "Identify compound A in reaction series involving KNO₂ and NH₄OH:",
          options: ["CoS", "MnS", "NiS", "ZnS"],
          answer: "CoS",
          subject: "Chemistry"
        },
        {
          question: "A compound has 54.2% C, 9.2% H, 36.6% O. Molar mass = 132 g/mol. What is molecular formula?",
          options: ["C6H12O6", "C5H10O4", "C4H8O3", "C3H6O2"],
          answer: "C6H12O6",
          subject: "Chemistry"
        },
        {
          question: "Given sp and sp² hybridized carbon atoms in a structure. Find count:",
          options: ["3 and 6", "4 and 6", "4 and 5", "3 and 5"],
          answer: "3 and 5",
          subject: "Chemistry"
        },
        {
          question: "The correct order of set of reagents for a given aromatic conversion is:",
          options: [
            "Br₂ | FeBr₃, H₂O(Δ), NaOH",
            "Ac₂O, Br₂, H₂O(Δ), NaOH",
            "H₂SO₄, Ac₂O, Br₂, H₂O(Δ), NaOH",
            "Ac₂O, H₂SO₄, Br₂, NaOH"
          ],
          answer: "H₂SO₄, Ac₂O, Br₂, H₂O(Δ), NaOH",
          subject: "Chemistry"
        },
        {
          question: "Structure of the major product of the given haloalkane reaction is:",
          options: ["(1)", "(2)", "(3)", "(4)"],
          answer: "(3)",
          subject: "Chemistry"
        },
        {
          question: "In the given reaction, the compound 'A' is:",
          options: ["CoS", "MnS", "NiS", "ZnS"],
          answer: "CoS",
          subject: "Chemistry"
        },
        {
          question: "A compound contains 54.2% C, 9.2% H, 36.6% O. Molar mass = 132 g/mol. Molecular formula is:",
          options: ["C6H12O6", "C5H10O4", "C4H8O3", "C3H6O2"],
          answer: "C6H12O6",
          subject: "Chemistry"
        },
        {
          question: "Number of sp and sp² hybridized carbon atoms respectively in the structure are:",
          options: ["3 and 6", "4 and 6", "4 and 5", "3 and 5"],
          answer: "3 and 5",
          subject: "Chemistry"
        },
        {
          question: "Which of the following groups are activating and ortho/para directing?",
          options: [
            "(A), (C), (D) only",
            "(A) and (C) only",
            "(A) only",
            "(A), (B) and (E) only"
          ],
          answer: "(A), (C) and (D) only",
          subject: "Chemistry"
        },

        {
          question: "Match transition metal ions to magnetic moment: (A) Ti³⁺, (B) V²⁺, (C) Ni²⁺, (D) Sc³⁺",
          options: [
            "(A)-(III), (B)-(I), (C)-(II), (D)-(IV)",
            "(A)-(IV), (B)-(II), (C)-(III), (D)-(I)",
            "(A)-(III), (B)-(I), (C)-(IV), (D)-(II)",
            "(A)-(II), (B)-(IV), (C)-(I), (D)-(III)"
          ],
          answer: "(A)-(III), (B)-(I), (C)-(IV), (D)-(II)",
          subject: "Chemistry"
        },
  
        {
          question: "Match (A) Adenine, (B) Cytosine, (C) Thymine, (D) Uracil to structure:",
          options: [
            "(A)-(III), (B)-(I), (C)-(IV), (D)-(II)",
            "(A)-(IV), (B)-(III), (C)-(II), (D)-(I)",
            "(A)-(III), (B)-(IV), (C)-(II), (D)-(I)",
            "(A)-(III), (B)-(IV), (C)-(I), (D)-(II)"
          ],
          answer: "(A)-(III), (B)-(IV), (C)-(II), (D)-(I)",
          subject: "Chemistry"
        },
        {
          question: "The heat of formation of SO₂(g) from S and O₂ using reactions with x and y kcal is:",
          options: [
            "2x/y kcal",
            "y – 2x kcal",
            "x + y kcal",
            "2x + y kcal"
          ],
          answer: "y – 2x kcal",
          subject: "Chemistry"
        },
        {
          question: "In a reaction H₂ + I₂ ⇌ 2HI, which graph correctly shows equilibrium attainment?",
          options: ["Graph 1", "Graph 2", "Graph 3", "Graph 4"],
          answer: "Graph 2",
          subject: "Chemistry"
        },
        {
          question: "In Carius method, 0.25g organic compound gives 0.15g AgBr. %Br in compound is (×10⁻¹ %)?",
          options: ["240", "255", "270", "280"],
          answer: "255",
          subject: "Chemistry"
        },
        {
          question: "Observed molar mass of MX₂ = 65.6, normal = 164. Degree of ionisation of MX₂ is:",
          options: ["60%", "65%", "70%", "75%"],
          answer: "75%",
          subject: "Chemistry"
        },
  
        // Chemistry (73–77)
        {
          question: "No. of stereoisomers for 5-phenylpent-4-en-2-ol:",
          options: ["2", "3", "4", "5"],
          answer: "4",
          subject: "Chemistry"
        },
        {
          question: "A hydrocarbon with molar mass 80 g/mol and 90% C has how many degrees of unsaturation?",
          options: ["2", "3", "4", "5"],
          answer: "3",
          subject: "Chemistry"
        },
        {
          question: "Strongest reducing agent among: Cl⁻, Cr, MnO₄⁻, Mn²⁺ based on SRP values:",
          options: ["Cl⁻", "Cr", "MnO₄⁻", "Mn²⁺"],
          answer: "Cr",
          subject: "Chemistry"
        },
        {
          question: "Which orbital has lowest energy?",
          options: ["4s (n=4)", "3px (n=3)", "3dx²–y² (n=3)", "4pz (n=4)"],
          answer: "3px (n=3)",
          subject: "Chemistry"
        },
        {
          question: "Which reagent forms yellow ppt with cobalt salt solution?",
          options: ["KCl", "KNO₂", "HCl", "NH₄OH"],
          answer: "KNO₂",
          subject: "Chemistry"
        },
  
        {
          question: "Which statement is true for 1st order reaction?",
          options: [
            "I true, II false",
            "Both false",
            "I false, II true",
            "Both true"
          ],
          answer: "I true, II false",
          subject: "Chemistry"
        },
        {
          question: "Which statement about O₃ is correct?",
          options: [
            "I false, II true",
            "Both true",
            "I true, II false",
            "Both false"
          ],
          answer: "I true, II false",
          subject: "Chemistry"
        },
        {
          question: "Identify correct acid-base mixing leading to maximum temp increase:",
          options: [
            "30 mL HCl and 30 mL NaOH",
            "30 mL CH₃COOH and 30 mL NaOH",
            "45 mL CH₃COOH and 25 mL NaOH",
            "50 mL HCl and 20 mL NaOH"
          ],
          answer: "30 mL HCl and 30 mL NaOH",
          subject: "Chemistry"
        },
        {
          question: "The number of stereoisomers for 5-phenylpent-4-en-2-ol is:",
          options: ["2", "3", "4", "5"],
          answer: "4",
          subject: "Chemistry"
        },
      ],
    },    
    
    
    
    
    {
      title:"Jee main (Test-2",
      questions:[
        {
          question: "Let 1/2 + 1/6 + 1/12 + ... up to n terms be Sn. If the sum of first six terms of an A.P. with first term –p and common difference p is S20252026, then the absolute difference between 20th and 15th terms of the A.P. is",
          options: ["25", "90", "20", "45"],
          answer: "25",
          subject: "Maths"
        },
        {
          question: "For a statistical data x₁ to x₁₀, the mean is 5.5 and Σxᵢ² = 371. Two values 4 and 5 were wrong and should be 6 and 8. The variance of the corrected data is",
          options: ["7", "5", "9", "4"],
          answer: "7",
          subject: "Maths"
        },
        {
          question: "In ∆ABC, side AC = 6, vertex B = (1, 2, 3), and A, C lie on line (x+6)/3 = (y–7)/2 = (z–7)/2. Area of ∆ABC is",
          options: ["17", "56", "21", "42"],
          answer: "21",
          subject: "Maths"
        },
        {
          question: "Let f: ℝ\\{0} → ℝ such that f(1/x) – f(x) = (5x – 6)/(3x²). If limₓ→0⁺ f(x)/x = β/α, then α + 2β =",
          options: ["6", "3", "4", "5"],
          answer: "4",
          subject: "Maths"
        },
        {
          question: "A line through (–1,2,1) parallel to (x–1)/2 = y/3 = (z+1)/4 intersects the line (x+2)/3 = (y–3)/2 = (z+4)/1. Find distance from this point to Q(4,–5,1).",
          options: ["10", "5√5", "5", "5√6"],
          answer: "5√5",
          subject: "Maths"
        },
        {
          question: "limₓ→0 (cosec x + 2cosx + 3cosx – cosx·sinx + 4) is",
          options: ["1/15", "1 – 2/15", "1/2 × 15", "0"],
          answer: "1 – 2/15",
          subject: "Maths"
        },
        {
          question: "Let **a** = 2î + ĵ + k̂, **b** = 3î + ĵ – k̂ and **c** is coplanar with **a**, **b**, perpendicular to **b**, and **a**·**c** = 5. Find **c**.",
          options: ["18", "3/2", "11/6", "16"],
          answer: "11/6",
          subject: "Maths"
        },
        {
          question: "Let R = {(x,y): 0 ≤ x ≤ 3, 0 ≤ y ≤ 9 – x²/11}. Find area of largest inscribed rectangle aligned with axes.",
          options: ["625/111", "821/123", "567/121", "730/119"],
          answer: "567/121",
          subject: "Maths"
        },
        {
          question: "Find the area of region: {(x, y): x² + 4x + 2 ≤ y ≤ |x + 2|}",
          options: ["5", "24/5", "20/3", "7"],
          answer: "20/3",
          subject: "Maths"
        },
        {
          question: "A and B throw dice alternately. A wins if he gets sum 5 before B gets 8. B wins if he gets 8 before A gets 5. A starts. Find probability A wins.",
          options: ["8/19", "9/19", "9/17", "8/17"],
          answer: "9/19",
          subject: "Maths"
        },
        {
          question: "Let y(x) solve: (5x / (1 + x²)) y + (1 + x²) dy/dx = 0, with y(0) = 0. Then y(3) = ?",
          options: ["14/3", "5√3/2", "2√2", "15/2"],
          answer: "5√3/2",
          subject: "Maths"
        },
        {
          question: "Let I(m,n) = ∫₀¹ xᵐ⁻¹ (1–x)ⁿ⁻¹ dx. Find I(9,14) + I(10,13)",
          options: ["I(9,1)", "I(1,13)", "I(9,13)", "I(19,27)"],
          answer: "I(9,13)",
          subject: "Maths"
        },
        {
          question: "The product of all rational roots of (x² – 9x + 11)² – (x – 4)(x – 5) = 3 is",
          options: ["7", "14", "21", "28"],
          answer: "14",
          subject: "Maths"
        },
        {
          question: "A circle x² + y² – 2x + 4y – 4 = 0 is reflected in line 2x – 3y + 5 = 0. Let A on image circle lie on same horizontal line as center O. Another point B(α,β), β < 4 lies on circle such that arc AB = 1/6th of perimeter. Then 3β – α = ?",
          options: ["4", "3", "4√3", "3√3"],
          answer: "4",
          subject: "Maths"
        },
        {
          question: "Let α, β be roots of 2z² – 3z – 2i = 0. Then find value of: (Re[(α + β)¹⁹ + (α + β)¹¹] × Im[(α + β)¹⁹ + (α + β)¹¹]) / (α + β)¹⁵",
          options: ["441", "398", "312", "409"],
          answer: "441",
          subject: "Maths"
        },
        {
          question: "Let f(x) = (x² + 2x + 4)(x² + 4x + 16)/(x² + 4x + 32). Find f(1/15) + f(2/15) + ... + f(598/15)",
          options: ["118", "92", "102", "108"],
          answer: "118",
          subject: "Maths"
        },
        {
          question: "The system 2x – y + z = 4; 5x + λy + 3z = 12; 100x – 47y + μz = 212 has infinite solutions. Find μ – 2λ.",
          options: ["59", "55", "56", "57"],
          answer: "57",
          subject: "Maths"
        },
        {
          question: "Let (1 + x)ⁿ⁺⁴ have binomial coefficients of 5th, 6th, and 7th terms in A.P. (i.e. C₄, C₅, C₆). If n ≠ 10, find largest coefficient in expansion.",
          options: ["10", "70", "35", "20"],
          answer: "35",
          subject: "Maths"
        },
        {
          question: "A point (13/2, 1) lies on ellipse (x²/a² + y²/b² = 1). If product of focal distances is 7/4, then find |e₁ – e₂|.",
          options: ["(3 – 2√2)/3", "(1 – 2√2)/3", "(1 – √3)/2", "(3 – 2√2)/2"],
          answer: "(3 – 2√2)/2",
          subject: "Maths"
        },
        {
          question: "Let lines 3x – 4y – α = 0, 8x – 11y – 33 = 0, and 2x – 3y + λ = 0 be concurrent. If image of point (1,2) in line 2x – 3y + λ = 0 is (57/13, –40/13), then |α·λ| = ?",
          options: ["91", "84", "113", "101"],
          answer: "91",
          subject: "Maths"
        },
        {
          question: "How many 3-digit numbers are divisible by 2 and 3 but **not** by 4 or 9?",
          options: [],
          answer: "125",
          subject: "Maths"
        },
        {
          question: "Let f be differentiable and satisfies: 2(x+2)²·f(x) – 3(x+2)² = ∫₀ˣ⁺² t·f(t) dt. If x ≥ 0, find f(2).",
          options: [],
          answer: "19",
          subject: "Maths"
        },
        {
          question: "Matrix A is 3×3, XTAX = 0 for all nonzero vectors X. If det(adj(2(A+I))) = 2^α 3^β 5^γ, find α² + β² + γ²",
          options: [],
          answer: "44",
          subject: "Maths"
        },
        {
          question: "Let S = {p₁, p₂,...,p₁₀} = first 10 primes. Let A = S ∪ P, where P is the set of all distinct products of primes in S. Find number of ordered pairs (x, y), x ∈ S, y ∈ A such that x divides y.",
          options: [],
          answer: "5120",
          subject: "Maths"
        },
        {
          question: "If α ≤ β, α + β = 8, and sec²(tan⁻¹α) + cosec²(cot⁻¹β) = 36, find α² + β.",
          options: [],
          answer: "14",
          subject: "Maths"
        },



        {
          question: "A parallel plate capacitor has area A and separation d. If E is the electric field and ε₀ is permittivity of free space, what is the potential energy stored?",
          options: ["(1/4)ε₀E²Ad", "(1/2)ε₀E²Ad", "ε₀E²Ad", "(3/4)ε₀E²Ad"],
          answer: "(1/2)ε₀E²Ad",
          subject: "Physics"
        },
        {
          question: "A plano-convex lens of refractive index 1.5 is immersed in a liquid (n = 1.2). If its plane side is silvered, and it behaves as a concave mirror with focal length 0.2 m, what is the radius of curvature?",
          options: ["0.20 m", "0.15 m", "0.25 m", "0.10 m"],
          answer: "0.10 m",
          subject: "Physics"
        },
        {
          question: "For y = (32.3 × 1125) / 27.4 with all digits significant, how should the result be reported?",
          options: ["1330", "1326.2", "1326.19", "1326.186"],
          answer: "1330",
          subject: "Physics"
        },
        {
          question: "Two satellites are launched in circular orbits of radii R and 1.03R. What is the percent increase in time period?",
          options: ["9%", "2.5%", "3%", "4.5%"],
          answer: "4.5%",
          subject: "Physics"
        },
        {
          question: "Work done to break a big water drop into 27 equal drops is 10 J. What is the work needed to break it into 64 drops?",
          options: ["10 J", "20 J", "5 J", "15 J"],
          answer: "15 J",
          subject: "Physics"
        },
        {
          question: "In YDSE using 480 nm and 600 nm light, how many bright fringes of 480 nm are needed for first coincidence with 600 nm?",
          options: ["6", "8", "5", "4"],
          answer: "5",
          subject: "Physics"
        },
        {
          question: "If pressure of an ideal gas increases linearly with temperature, which statements are true?",
          options: ["A, D, E", "E only", "A, C", "A, B, C, D"],
          answer: "A, D, E",
          subject: "Physics"
        },
        {
          question: "A car on a banked road of radius r and angle θ has max speed v₀ before slipping. What is μ?",
          options: [
            "(v₀²/rg + tanθ)/(v₀²/rg - tanθ)",
            "(v₀²/rg + tanθ)/(v₀²/rg + tanθ)",
            "(v₀²/rg - tanθ)/(v₀²/rg + tanθ)",
            "(v₀²/rg)/(v₀²/rg + tanθ)"
          ],
          answer: "(v₀²/rg + tanθ)/(v₀²/rg - tanθ)",
          subject: "Physics"
        },
        {
          question: "A force F = α + βx² acts in x-direction. If W = 5 J for 1 m displacement and α = 1 N, find β.",
          options: ["8 N/m²", "15 N/m²", "12 N/m²", "10 N/m²"],
          answer: "12 N/m²",
          subject: "Physics"
        },
        {
          question: "Two plano-convex lenses of R = 2 cm and R = 3 cm (immersed in liquid, n = 1.2) are made of n = 1.5 glass. Find f₁/f₂.",
          options: ["1:2", "1:3", "2:3", "3:5"],
          answer: "1:3",
          subject: "Physics"
        },
        {
          question: "A SHM has T = 2s and amplitude = 1 cm. If D and d are total distance and displacement in 12.5s, find D/d.",
          options: ["10", "15/4", "16/5", "25"],
          answer: "25",
          subject: "Physics"
        },
        {
          question: "An AC is I = Iₐ sin(ωt) + I_b cos(ωt). What is the RMS current?",
          options: [
            "√(Iₐ² + I_b²) / √2",
            "(Iₐ² + I_b²) / √2",
            "√(Iₐ² + I_b²)",
            "Iₐ² + I_b²"
          ],
          answer: "√(Iₐ² + I_b²) / √2",
          subject: "Physics"
        },
        {
          question: "An electron with initial velocity v₀ enters E = –E₀k̂. If its initial λ = λ₀, what is the λ after time t?",
          options: [
            "λ₀ / √(1 + (eE₀t / mv₀)²)",
            "λ₀ + (eE₀t / mv₀)",
            "λ₀",
            "λ₀ – (eE₀t / mv₀)"
          ],
          answer: "λ₀ / √(1 + (eE₀t / mv₀)²)",
          subject: "Physics"
        },
        {
          question: "A square loop of side 1 m is held in front of point charge q = 1 C. If flux is (5/ε₀) Nm²/C, find p in (5/ε₀)p.",
          options: [],
          answer: "48",
          subject: "Physics"
        },
        {
          question: "Screw gauge has least count 0.01 mm. Pitch increases by 75%, circular scale divisions reduce by 50%. New least count in ×10⁻³ mm?",
          options: [],
          answer: "35",
          subject: "Physics"
        },
        {
          question: "Current of 5 A flows in a square loop of side 0.5 m. Magnetic field at center is p × 10⁻⁶ T. Find p.",
          options: [],
          answer: "8",
          subject: "Physics"
        },
        {
          question: "A uniform solid cylinder of radius r rolls on 45° incline. Find linear acceleration of center of mass.",
          options: ["(1/√6)g", "(2/3)g", "2g", "(1/2)g"],
          answer: "(2/3)g",
          subject: "Physics"
        },
        {
          question: "In Bohr model, wavelength from A to C is 2000 Å, B to C is 6000 Å. What is λ for A to B?",
          options: ["2000 Å", "3000 Å", "6000 Å", "4000 Å"],
          answer: "3000 Å",
          subject: "Physics"
        },
        {
          question: "What is the relative decrease in focal length when power increases by 0.1 D from 2.5 D?",
          options: ["0.01", "0.04", "0.1", "0.40"],
          answer: "0.04",
          subject: "Physics"
        },
        {
          question: "Electric field lines for different capacitor geometries are given. Which configurations give 10× capacitance?",
          options: ["C and E only", "C only", "B and D only", "A only"],
          answer: "C and E only",
          subject: "Physics"
        },
        {
          question: "An object is moved by F = α + βx² and W = 5 J for 1 m. If α = 1 N, what is β?",
          options: [],
          answer: "12",
          subject: "Physics"
        },
        {
          question: "Light emission statements: Which of B, D, E apply to solar cell and LED?",
          options: ["B, E", "B, D, E", "A, C, E", "A, C"],
          answer: "B, E",
          subject: "Physics"
        },
        {
          question: "In LCR circuit, at resonance, which relation is true?",
          options: ["X_L = X_C", "Z = R", "Current is max", "All of these"],
          answer: "All of these",
          subject: "Physics"
        },
        {
          question: "Torque on a rectangular loop in uniform magnetic field is max when plane of loop is:",
          options: ["Perpendicular to B", "Parallel to B", "At 45°", "No torque"],
          answer: "Parallel to B",
          subject: "Physics"
        },
        {
          question: "A glass rod rubbed with silk is brought near a negatively charged body. What will happen?",
          options: ["Repelled", "Attracted", "No effect", "Depends on mass"],
          answer: "Repelled",
          subject: "Physics"
        },




        {
          question: "Aman plans to synthesize a molecule using aldol condensation. He performs ozonolysis on a cyclic alkene to form a dicarbonyl compound. Which alkene leads to the target molecule 'x'?",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 3",
          subject: "Chemistry"
        },
        {
          question: "Which molecule among P, Q, R, S reacts fastest with HBr (aq)?",
          options: ["P", "R", "Q", "S"],
          answer: "Q",
          subject: "Chemistry"
        },
        {
          question: "Co(NH₃)₅Cl₃ gives 3 ions in water and 2 moles of AgCl with AgNO₃. The structure of the complex is:",
          options: [
            "[Co(NH₃)₄Cl]Cl₂·NH₃",
            "[Co(NH₃)₄Cl₂]Cl·NH₃",
            "[Co(NH₃)₃Cl₃]·2NH₃",
            "[Co(NH₃)₅Cl]Cl₂"
          ],
          answer: "[Co(NH₃)₅Cl]Cl₂",
          subject: "Chemistry"
        },
        {
          question: "Which of the following is true about Ribose in DNA?",
          options: ["A, B and E", "B, D and E", "A, C and D", "A, C and E"],
          answer: "A, C and D",
          subject: "Chemistry"
        },
        {
          question: "Which is the strongest base among the given species?",
          options: ["CH₃O⁻", "NH₂⁻", "H⁻", "CH₃⁻"],
          answer: "NH₂⁻",
          subject: "Chemistry"
        },
        {
          question: "Which salt shows pH > 7 when dissolved in water?",
          options: ["NH₄Cl", "CH₃COONa", "KNO₃", "NaHSO₄"],
          answer: "CH₃COONa",
          subject: "Chemistry"
        },
        {
          question: "Match the oxoacids of phosphorus with correct oxidation state and basicity.",
          options: ["A – (3, 3), B – (5, 2)", "A – (5, 3), B – (3, 2)", "A – (3, 2), B – (5, 3)", "A – (5, 2), B – (3, 3)"],
          answer: "A – (5, 2), B – (3, 3)",
          subject: "Chemistry"
        },
        {
          question: "Which of the following is paramagnetic?",
          options: ["O₂", "N₂", "CO", "F₂"],
          answer: "O₂",
          subject: "Chemistry"
        },
        {
          question: "Which pair of solutions will form a buffer?",
          options: [
            "HCl and NaOH",
            "CH₃COOH and NaOH (1:1)",
            "CH₃COOH and CH₃COONa",
            "NaOH and NH₄Cl"
          ],
          answer: "CH₃COOH and CH₃COONa",
          subject: "Chemistry"
        },
        {
          question: "A solution contains 1:1 HCl and CH₃COOH, both 0.1 M. What is the [H⁺] in solution?",
          options: ["1.3×10⁻¹", "1×10⁻¹", "3×10⁻²", "1×10⁻²"],
          answer: "1.3×10⁻¹",
          subject: "Chemistry"
        },
        {
          question: "Which of the following contains only σ bonds?",
          options: ["CH₄", "C₂H₆", "C₂H₄", "C₂H₂"],
          answer: "C₂H₆",
          subject: "Chemistry"
        },
        {
          question: "Which reaction type forms soap?",
          options: ["Saponification", "Hydrolysis", "Neutralization", "Oxidation"],
          answer: "Saponification",
          subject: "Chemistry"
        },
        {
          question: "Which of the following represents a correct pair of enantiomers?",
          options: ["A and B", "C and D", "A and C", "B and D"],
          answer: "A and B",
          subject: "Chemistry"
        },
        {
          question: "Which molecule shows geometrical isomerism?",
          options: ["[Pt(NH₃)₂Cl₂]", "[Ni(CN)₄]²⁻", "[Co(NH₃)₅Cl]²⁺", "[Fe(CO)₅]"],
          answer: "[Pt(NH₃)₂Cl₂]",
          subject: "Chemistry"
        },
        {
          question: "Which polymer is a condensation polymer?",
          options: ["Polyethylene", "Teflon", "Nylon-6,6", "PVC"],
          answer: "Nylon-6,6",
          subject: "Chemistry"
        },
        {
          question: "The standard electrode potential for Zn²⁺/Zn and Cu²⁺/Cu are –0.76 V and +0.34 V respectively. What is the EMF of cell Zn|Zn²⁺||Cu²⁺|Cu?",
          options: [],
          answer: "1.10",
          subject: "Chemistry"
        },
        {
          question: "The bond order of N₂⁺ is ______.",
          options: [],
          answer: "2.5",
          subject: "Chemistry"
        },
        {
          question: "Number of ions produced when Al₂(SO₄)₃ is dissolved in water is ______.",
          options: [],
          answer: "5",
          subject: "Chemistry"
        },
        {
          question: "Atomic number of an element is 35. Number of unpaired electrons in ground state is ______.",
          options: [],
          answer: "1",
          subject: "Chemistry"
        },
        {
          question: "Number of resonance structures possible for CO₃²⁻ is ______.",
          options: [],
          answer: "3",
          subject: "Chemistry"
        },
        {
          question: "The half-life of a radioactive element is 10 days. Time after which 75% decays is ______ days.",
          options: [],
          answer: "20",
          subject: "Chemistry"
        },
        {
          question: "In a reaction A + B → Products, rate = k[A]²[B]. If [A] triples and [B] doubles, the rate increases by factor ______.",
          options: [],
          answer: "18",
          subject: "Chemistry"
        },
        {
          question: "1 mole of ideal gas at 300 K and 1 atm expands isothermally to double its volume. Work done (in J) is ______.",
          options: [],
          answer: "1729",
          subject: "Chemistry"
        },
        {
          question: "The oxidation state of Mn in KMnO₄ is ______.",
          options: [],
          answer: "7",
          subject: "Chemistry"
        },
        {
          question: "The pH of 10⁻⁸ M HCl is ______.",
          options: [],
          answer: "6.96",
          subject: "Chemistry"
        }
      ]
    },









    {
      title:"jee main (test-3)",
      questions:[
        {
          question: "If ∑ₙCᵣ · r³/2³ = α – β, where α, β ∈ ℝ, then (α + β)² is equal to",
          options: ["18", "27", "81", "9"],
          answer: "81",
          subject: "Maths"
        },
        {
          question: "Let z ∈ ℂ be such that (z + 2 + 3i)/(z + 2 – 3i) = (2 + 3i)/(2 – 3i). Then the sum of all possible values of z² is",
          options: ["–19 – 2i", "–19 + 2i", "19 – 2i", "19 + 2i"],
          answer: "–19 – 2i",
          subject: "Maths"
        },
        {
          question: "Let a line passing through point (4,1,0) intersect the lines L₁: (x–1)/2 = (y–1)/3 = (z–2)/4 and L₂: x–6 = y = –z + 4 at points A(α, β, γ) and B(a, b, c) respectively. Then the value of the determinant formed by A and B is",
          options: ["16", "6", "12", "8"],
          answer: "8",
          subject: "Maths"
        },
        {
          question: "A line through point (5,5) intersects the ellipse x²/36 + y²/25 = 1 at A and B such that (PA)·(PB) is maximum. Then 5(PA² + PB²) = ?",
          options: ["377", "218", "338", "290"],
          answer: "338",
          subject: "Maths"
        },
        {
          question: "Let A = {–3, –2, –1, 0, 1, 2, 3}. Let R on A be defined by xRy iff 0 ≤ x² + 2y ≤ 4. Let l be number of elements in R, m be minimum elements to make R reflexive. Then l + m = ?",
          options: ["18", "19", "17", "20"],
          answer: "18",
          subject: "Maths"
        },
        {
          question: "Let A be 3×3 matrix with |A| = 5. Then |2adj(3A · adj(2A))| = 2^α · 3^β · 5^γ. Find α + β + γ.",
          options: ["25", "26", "27", "28"],
          answer: "27",
          subject: "Maths"
        },
        {
          question: "Let f(x) be defined piecewise: x < 0 → (1 + x^a)^(1/x), x = 0 → 1 + b, x > 0 → (4 + x^1/3)^(1/x). If f(x) is continuous at x = 0, then e^(a·b·c) = ?",
          options: ["48", "72", "36", "64"],
          answer: "48",
          subject: "Maths"
        },
        {
          question: "A line through origin makes equal angles with coordinate axes and intersects lines L₁: 2x + y + 6 = 0 and L₂: 4x + 2y – p = 0 at points A, B respectively. If AB = 2/√9 and M is foot of perpendicular from A to L₂, then AM/BM = ?",
          options: ["3", "5", "2", "4"],
          answer: "3",
          subject: "Maths"
        },
        {
          question: "The sum of all rational terms in expansion of (2 + ³√3)^8 is",
          options: ["3763", "18817", "33845", "16923"],
          answer: "18817",
          subject: "Maths"
        },
        {
          question: "Line L₁ passes through (1,2,3) and is parallel to z-axis. Line L₂ passes through (λ,5,6) and is parallel to y-axis. If shortest distance between them is 3 for λ = λ₁, λ₂ (λ₂ < λ₁), then square of distance of point (λ₁, λ₂, 7) from L₁ is",
          options: ["32", "25", "37", "40"],
          answer: "25",
          subject: "Maths"
        },
        {
          question: "Radius of smallest circle touching y = x² + 2 and x = y² + 2 is",
          options: ["7√2/4", "7√2/16", "7√2/2", "7√2/8"],
          answer: "7√2/8",
          subject: "Maths"
        },
        {
          question: "The sum 1 + 3 + 11 + 25 + 45 + 71 + … up to 20 terms is equal to",
          options: ["8124", "7240", "7130", "6982"],
          answer: "7240",
          subject: "Maths"
        },
        {
          question: "Number of solutions of 2x + 3tanx = π in [–π/2, π/2] is",
          options: ["5", "3", "4", "6"],
          answer: "5",
          subject: "Maths"
        },
        {
          question: "Let domain of f(x) = log₂(log₄(log₆(3 + 4x – x²))) be (a, b). If ∫ₐᵇ [x] dx = p – q – r, where p, q, r ∈ ℕ, gcd(p,q,r)=1, then p + q + r = ?",
          options: ["8", "10", "11", "9"],
          answer: "10",
          subject: "Maths"
        },
        {
          question: "If domain of f(x) = log((12x³ – 5x + 3)/(4x² + 2e^x – x)) is [α, β), then α² + 4β = ?",
          options: ["3", "7", "4", "5"],
          answer: "4",
          subject: "Maths"
        },
        {
          question: "Let ∫₀ˣ (3t² – t) dt = f(x), and f(5) = –2. Then f(1) = ?",
          options: ["(6 – √2)/5", "(4 – √2)/5", "(2 – √2)/5", "(8 – √2)/5"],
          answer: "(6 – √2)/5",
          subject: "Maths"
        },
        {
          question: "Let a₁, a₂, a₃,… be an increasing GP of positive numbers. If a₃·a₅ = 729 and a₂ + a₄ = 111/4, then 24(a₁ + a₂ + a₃) = ?",
          options: ["130", "131", "129", "128"],
          answer: "129",
          subject: "Maths"
        },
        {
          question: "Let α, β be roots of 2x² + 3x – 16 = 0 and γ, δ be roots of x² + 3x – 1 = 0. Define Pₙ = αⁿ + βⁿ, Qₙ = γⁿ + δⁿ. Then (P₂₅ – P₂₃)/(P₂₄) + (Q₂₅ + Q₂₄)/(Q₂₃) = ?",
          options: ["4", "3", "7", "5"],
          answer: "5",
          subject: "Maths"
        },
        {
          question: "Let g be differentiable such that ∫₀ˣ g(t) dt = x ∫₀ˣ t g(t) dt, x ≥ 0, and y = y(x) solves dy/dx – y tanx = 2(x+1) secx·g(x), y(0)=0. Then y(π/3) = ?",
          options: ["(2π)/3", "(4π)/3", "(2π√3)/3", "(4π√3)/3"],
          answer: "(4π)/3",
          subject: "Maths"
        },
        {
          question: "If y = sinx/(27x) + cosx/(28x) + 1/x, then y'' + y = ?",
          options: ["28", "1", "–1", "27"],
          answer: "–1",
          subject: "Maths"
        },
        {
          question: "Let vector **a** = î + ĵ + k̂, **b** = 3î + 2ĵ – k̂, and **c** = ĵ + k̂. Let **d** = λî + μĵ + unit vector such that **a** × **d** = **b** × **d** and **c**·**d** = 1. If **c** ⊥ **a**, then the value of 2(λ + 3μ) = ?",
          options: ["5","80","20","12"],
          answer: "5",
          subject: "Maths"
        },
        {
          question: "The area of region bounded by y = max{|x|, |x – 2|}, x-axis, x = –2, x = 4 is",
          options: ["2","12","20","29"],
          answer: "12",
          subject: "Maths"
        },
        {
          question: "Let point (4, 2√3) lies on hyperbola x²/a² – y²/b² = 1, and product of focal distances is 32. If p is length of conjugate axis and q is latus rectum, then p² + q² = ?",
          options: ["28", "120", "–1", "27"],
          answer: "120",
          subject: "Maths"
        },
        {
          question: "Total number of 5-letter words using A, B, C, D, E arranged in dictionary. If P(Wₙ) = 2·P(Wₙ₋₁), and P(CDBEA) = (2^α)/(2^β – 1), then α + β = ?",
          options: ["40", "183", "17", "50"],
          answer: "183",
          subject: "Maths"
        },
        {
          question: "Number of 7-digit numbers such that digit sum is even is of the form 10^n · m. Find m + n.",
          options: ["14", "30", "17", "5"],
          answer: "14",
          subject: "Maths"
        },



        {
          question: "Match the following nuclear and chemical reactions correctly.",
          options: [
            "A-III, B-I, C-IV, D-II",
            "A-II, B-I, C-IV, D-III",
            "A-III, B-I, C-II, D-IV",
            "A-II, B-I, C-III, D-IV"
          ],
          answer: "A-III, B-I, C-II, D-IV",
          subject: "Physics"
        },
        {
          question: "A particle is released from height S. At a certain point, KE = 3× PE. What is the height and speed at that moment?",
          options: [
            "S/2, √(2gS)",
            "3S/4, √(2gS)",
            "S/4, √(2gS/3)",
            "S/4, √(3gS/2)"
          ],
          answer: "3S/4, √(2gS)",
          subject: "Physics"
        },
        {
          question: "In minimum deviation through prism, which statements are true?",
          options: [
            "A, B and E only",
            "B, D and E only",
            "B, C and D only",
            "A, C and D only"
          ],
          answer: "A, C and D only",
          subject: "Physics"
        },
        {
          question: "Radiation pressure of 450W light on a reflecting surface 2m away is:",
          options: [
            "1.5 × 10⁻⁸ Pa",
            "0",
            "3 × 10⁻⁸ Pa",
            "6 × 10⁻⁸ Pa"
          ],
          answer: "6 × 10⁻⁸ Pa",
          subject: "Physics"
        },
        {
          question: "Two dielectrics of ε₁ and ε₂ are placed in a capacitor in two configurations. What is C₁/C₂?",
          options: [
            "(4ε₁ε₂)/(ε₁ + ε₂)²",
            "ε₀(ε₁ + ε₂)/2",
            "(ε₁ε₂)/(ε₁ + ε₂)",
            "(2ε₁ε₂)/(ε₁ + ε₂)²"
          ],
          answer: "(4ε₁ε₂)/(ε₁ + ε₂)²",
          subject: "Physics"
        },
        {
          question: "A piston is attached to a spring F = –kx³ and separates gas. Work done when piston moves from L₀ to L₁ is:",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 1",
          subject: "Physics"
        },
        {
          question: "Capacitance of composite dielectric system shown is:",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 1",
          subject: "Physics"
        },
        {
          question: "Melting of ice at 273K and 1 atm involves:",
          options: [
            "Internal energy unchanged",
            "Internal energy decreases",
            "Work done by ice-water system",
            "Work done on ice-water system"
          ],
          answer: "Work done on ice-water system",
          subject: "Physics"
        },
        {
          question: "Color of light required for photoemission from metal with work function 3 eV:",
          options: ["Red", "Yellow", "Green", "Blue"],
          answer: "Blue",
          subject: "Physics"
        },
        {
          question: "Match the quantities with correct dimensions: G, GPE, GP, g.",
          options: [
            "A-II, B-IV, C-III, D-I",
            "A-IV, B-III, C-II, D-I",
            "A-I, B-III, C-IV, D-II",
            "A-III, B-II, C-I, D-IV"
          ],
          answer: "A-IV, B-III, C-II, D-I",
          subject: "Physics"
        },
        {
          question: "A tangential force of 49 N on a solid sphere of mass 20 kg on rough plane leads to acceleration of center of mass:",
          options: ["2.5 m/s²", "0.25 m/s²", "3.5 m/s²", "0.35 m/s²"],
          answer: "3.5 m/s²",
          subject: "Physics"
        },
        {
          question: "Identify correct logic gate for truth table: A·(A + B):",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 2",
          subject: "Physics"
        },
        {
          question: "Potential on shell of radius 10cm is 120V. What is potential at center, 5 cm, and 15 cm?",
          options: ["120V, 120V, 80V", "0V, 120V, 40V", "0V, 0V, 80V", "120V, 0V, 40V"],
          answer: "120V, 120V, 80V",
          subject: "Physics"
        },
        {
          question: "Cylindrical tank full of water with a 50 kg load has a hole at 90 cm. Find velocity of water when hole opens.",
          options: ["3 m/s", "2 m/s", "5 m/s", "4 m/s"],
          answer: "4 m/s",
          subject: "Physics"
        },
        {
          question: "Gas at 800 cm³ and 27°C compressed adiabatically to 200 cm³. ΔT = ? (γ = 1.5)",
          options: ["300 K", "522 K", "327 K", "600 K"],
          answer: "300 K",
          subject: "Physics"
        },
        {
          question: "System of two masses m and M with spring constant k is slightly displaced. Which is true?",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 1",
          subject: "Physics"
        },
        {
          question: "Biconvex lens has R₁ = 10, R₂ = 15, μ = 1.5. What is focal length?",
          options: ["1.5", "1.2", "1.4", "1.8"],
          answer: "1.5",
          subject: "Physics"
        },
        {
          question: "Which graphs represent one-dimensional motion of a particle?",
          options: [
            "A and B only",
            "A, C and D only",
            "A, B and C only",
            "A, B and D only"
          ],
          answer: "A, B and D only",
          subject: "Physics"
        },
        {
          question: "Wire of 25 m length and area 5 mm² has resistivity 2×10⁻⁶ Ωm and is bent into circle. Resistance between opposite points is:",
          options: ["100 Ω", "50 Ω", "12.5 Ω", "25 Ω"],
          answer: "12.5 Ω",
          subject: "Physics"
        },
        {
          question: "A loop with semicircles of radii 6π m and 4π m carries 12 A current. Find magnetic field at center in 10⁻⁷ T units.",
          options: [],
          answer: "7",
          subject: "Physics"
        },
        {
          question: "Ammeter (240 Ω) with 10 Ω shunt and 150.4 Ω series resistance. If current is 20 V / total R, what is reading in mA?",
          options: [],
          answer: "5",
          subject: "Physics"
        },
        {
          question: "Three spheres of mass m at triangle a collide in 4s. If sides doubled and mass becomes 2m, new time is:",
          options: [],
          answer: "8",
          subject: "Physics"
        },
        {
          question: "Two light waves of intensity 4I and 9I interfere. Max–min intensity = xI. What is x?",
          options: [],
          answer: "24",
          subject: "Physics"
        },
        {
          question: "Wire of 4 cm carrying 8 A in 0.15 T field. Magnetic force in mN is:",
          options: [],
          answer: "48",
          subject: "Physics"
        },
        {
          question: "The RMS speed of an ideal gas molecule at 300K if molar mass is 28 g/mol is:",
          options: [],
          answer: "515",
          subject: "Physics"
        },



        {
          question: "2 moles each of ethylene glycol and glucose are dissolved in 500 g of water. The boiling point of the resulting solution is (Kb = 0.52 K·kg·mol⁻¹):",
          options: ["377.3 K", "375.3 K", "379.2 K", "277.3 K"],
          answer: "377.3 K",
          subject: "Chemistry"
        },
        {
          question: "Which compound would give 3-methyl-6-oxoheptanal upon ozonolysis?",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 3",
          subject: "Chemistry"
        },
        {
          question: "In the following reactions, which one is NOT correct?",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 1",
          subject: "Chemistry"
        },
        {
          question: "Among 10⁻⁹ g each of Pb, Po, Pr, and Pt, which has highest number of atoms?",
          options: ["Po", "Pb", "Pt", "Pr"],
          answer: "Pr",
          subject: "Chemistry"
        },
        {
          question: "Correct order of limiting molar conductivity for cations in water at 298K is:",
          options: [
            "H⁺ > Na⁺ > K⁺ > Ca²⁺ > Mg²⁺",
            "Mg²⁺ > H⁺ > Ca²⁺ > K⁺ > Na⁺",
            "H⁺ > Ca²⁺ > Mg²⁺ > K⁺ > Na⁺",
            "H⁺ > Na⁺ > Ca²⁺ > Mg²⁺ > K⁺"
          ],
          answer: "H⁺ > Ca²⁺ > Mg²⁺ > K⁺ > Na⁺",
          subject: "Chemistry"
        },
        {
          question: "Which of the following cannot form hydrogen bonds?",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 4",
          subject: "Chemistry"
        },
        {
          question: "Which metal forms an amphoteric oxide?",
          options: ["Na", "Mg", "Zn", "Ca"],
          answer: "Zn",
          subject: "Chemistry"
        },
        {
          question: "Which polymer is a condensation polymer?",
          options: ["PVC", "Teflon", "Nylon-6,6", "Polyethylene"],
          answer: "Nylon-6,6",
          subject: "Chemistry"
        },
        {
          question: "Which complex shows maximum paramagnetism?",
          options: ["[Fe(CN)₆]⁴⁻", "[Fe(H₂O)₆]²⁺", "[FeF₆]³⁻", "[Fe(H₂O)₆]³⁺"],
          answer: "[Fe(H₂O)₆]²⁺",
          subject: "Chemistry"
        },
        {
          question: "Among B, Be, C and Li, which has correct statements?",
          options: ["B and D only", "B, C and E only", "A, C and D only", "B and C only"],
          answer: "B and C only",
          subject: "Chemistry"
        },
        {
          question: "Which is the correct order of wavelength absorbed by these complexes: [Co(NH₃)₅(H₂O)]³⁺, [Co(NH₃)₆]³⁺, [Co(CN)₆]³⁻, [CoCl(NH₃)₅]²⁺?",
          options: ["C > B > A > D", "D > C > B > A", "C > B > D > A", "D > A > B > C"],
          answer: "D > A > B > C",
          subject: "Chemistry"
        },
        {
          question: "In the reaction sequence: A → B → C, identify A, B, and C.",
          options: ["Option 1", "Option 2", "Option 3", "Option 4"],
          answer: "Option 4",
          subject: "Chemistry"
        },
        {
          question: "Number of optical isomers exhibited by [Fe(C₂O₄)₃]³⁻ complex is _____",
          options: [],
          answer: "2",
          subject: "Chemistry"
        },
        {
          question: "0.42 g of C₄H₁₀N₂ liberates how much N₂ at STP in mL?",
          options: [],
          answer: "109",
          subject: "Chemistry"
        },
        {
          question: "Given: ΔHsub(C) = 710, ΔH(C–H) = 414, ΔH(H–H) = 436, ΔH(C–C) = 611 kJ/mol. What is ΔHf° of C₂H₄?",
          options: [],
          answer: "25",
          subject: "Chemistry"
        },
        {
          question: "On combustion, 0.5 g of organic compound gives 1.46 g CO₂ and 0.9 g H₂O. Percentage of carbon is:",
          options: [],
          answer: "80",
          subject: "Chemistry"
        },
        {
          question: "In Cr reactions, if B = CrO₄²⁻ and C = Cr₂O₇²⁻, then number of terminal oxygens in C is:",
          options: [],
          answer: "6",
          subject: "Chemistry"
        },
        {
          question: "Order of reactivity in SN1: (A) CH₃Cl, (B) (CH₃)₂CHCl, (C) (CH₃)₃CCl, (D) C₆H₅CH₂Cl",
          options: ["C > D > B > A", "D > C > B > A", "C > B > D > A", "B > C > D > A"],
          answer: "C > D > B > A",
          subject: "Chemistry"
        },
        {
          question: "The color of [Ti(H₂O)₆]³⁺ is due to:",
          options: [
            "Charge transfer transition",
            "d–d transition",
            "LMCT",
            "No transition (colorless)"
          ],
          answer: "d–d transition",
          subject: "Chemistry"
        },
        {
          question: "Which of the following is a pseudo-halide?",
          options: ["CN⁻", "Cl⁻", "OH⁻", "F⁻"],
          answer: "CN⁻",
          subject: "Chemistry"
        },
        {
          question: "Which one shows maximum boiling point?",
          options: ["CH₄", "C₂H₆", "CH₃OH", "CH₃Cl"],
          answer: "CH₃OH",
          subject: "Chemistry"
        },
        {
          question: "Which plot represents Raoult’s law for ideal solution?",
          options: ["Plot 1", "Plot 2", "Plot 3", "Plot 4"],
          answer: "Plot 2",
          subject: "Chemistry"
        },
        {
          question: "The compound that releases nitrogen gas in Lassaigne’s test is:",
          options: ["NH₂NH₂", "C₆H₅NH₂", "CH₃NH₂", "NH₄Cl"],
          answer: "NH₂NH₂",
          subject: "Chemistry"
        },
        {
          question: "Which statement about DNA and RNA is correct?",
          options: [
            "Both contain deoxyribose",
            "Both contain uracil",
            "DNA contains thymine, RNA contains uracil",
            "Both are double-stranded"
          ],
          answer: "DNA contains thymine, RNA contains uracil",
          subject: "Chemistry"
        },
        {
          question: "Which salt solution has highest pH?",
          options: ["CH₃COONa", "NH₄Cl", "NaHSO₄", "KNO₃"],
          answer: "CH₃COONa",
          subject: "Chemistry"
        }
      ]
      
    },






    {
      title:"jee main (test-4)",
      questions:[
        {
          question: "From all the English alphabets, five letters are chosen and are arranged in alphabetical order. The total number of ways, in which the middle letter is ‘M’, is:",
          options: ["4356", "6084", "14950", "5148"],
          answer: "5148",
          subject: "Maths"
        },
        {
          question: "Using the principal values of the inverse trigonometric functions, the sum of the maximum and the minimum values of 16((sec⁻¹x)² + (cosec⁻¹x)²) is:",
          options: ["18π²", "31π²", "24π²", "22π²"],
          answer: "22π²",
          subject: "Maths"
        },
        {
          question: "The number of non-empty equivalence relations on the set {1, 2, 3} is:",
          options: ["5", "7", "4", "6"],
          answer: "5",
          subject: "Maths"
        },
        {
          question: "Let the relation R on the set A = {1, 2, 3, ..., 10} be defined as aRb ⇔ b = a + 1. Then the number of elements in the transitive closure of R is:",
          options: ["36", "45", "55", "10"],
          answer: "45",
          subject: "Maths"
        },
        {
          question: "If a vector a makes angles α, β, γ with x, y, z axes respectively and sin²α + sin²β + sin²γ = 2, then the angle between vector a and the z-axis is:",
          options: ["π/2", "π/3", "π/4", "π/6"],
          answer: "π/3",
          subject: "Maths"
        },
        {
          question: "Let e₁ and e₂ be the eccentricities of two hyperbolas with transverse axis product 100√10. If e₁ = √(5/2), and length of latus rectum of first = 15√2, second = 12√5, then 225e₂² = ?",
          options: ["25", "35", "45", "55"],
          answer: "55",
          subject: "Maths"
        },
        {
          question: "If A = [1 2; 3 4] and Aⁿ = [a b; c d], then a + d is equal to:",
          options: ["Fₙ₊₁", "F₂ₙ", "Fₙ₋₁", "Fₙ"],
          answer: "Fₙ₊₁",
          subject: "Maths"
        },
        {
          question: "Let f(x) = 7tan⁸x + 7tan⁶x − 3tan⁴x − 3tan²x, and I₁ = ∫₀^π/4 f(x) dx, I₂ = ∫₀^π/4 x f(x) dx. Then 7I₁ + 12I₂ is equal to:",
          options: ["π", "2π", "1", "2"],
          answer: "1",
          subject: "Maths"
        },
        {
          question: "Let vector **b** = λî + 4k̂ and vector **a** = 2î + 2ĵ + 2k̂. If **a** + **c** = 7 and **c** is projection of **b** on **a**, then area of parallelogram formed by **b** and **c** is:",
          options: [],
          answer: "16",
          subject: "Maths"
        },
        {
          question: "Let ∑ (r=0 to 15) [2^(r+1)]/(r+1) C₁₅ = m/n with gcd(m,n)=1, then m − n equals:",
          options: [],
          answer: "2035",
          subject: "Maths"
        },
        {
          question: "Let f(x) = −3x² − 2 for x < 1 and ax² + bx for x ≥ 1. If f(x) is differentiable for all x, then area enclosed by y = f(x) and y = −20 is 3α + β, α, β ∈ Z, then α + β =",
          options: [],
          answer: "10",
          subject: "Maths"
        },
        {
          question: "Let matrix A be of order 3 such that det(A) = −2. If det(3adj(−6adj(3A))) = 2ᵐ + n·3ᵐⁿ, with m > n, then 4m + 2n = ?",
          options: [],
          answer: "34",
          subject: "Maths"
        },
        {
          question: "Let f(x) = log₂(log₄(log₆(3 + 4x − x²))). If the domain is (a, b) and ∫ₐ^ᵦ x dx = p − q − r, then p + q + r =",
          options: [],
          answer: "47",
          subject: "Maths"
        },
        {
          question: "Find number of solutions of 2x + 3tanx = π in x ∈ [−π/2, π/2]",
          options: ["5", "3", "4", "6"],
          answer: "5",
          subject: "Maths"
        },
        {
          question: "Sum of 20 terms of the series 1 + 3 + 11 + 25 + 45 + 71 + ⋯ is:",
          options: ["8124", "7240", "7130", "6982"],
          answer: "7240",
          subject: "Maths"
        },
        {
          question: "The number of solutions of |x − 2| + |x − 4| + |x − 6| = 10 is:",
          options: ["3", "2", "1", "0"],
          answer: "3",
          subject: "Maths"
        },
        {
          question: "If f(x) = x³ − 3x² − 9x + 6, then total number of critical points is:",
          options: ["2", "1", "3", "0"],
          answer: "2",
          subject: "Maths"
        },
        {
          question: "Let α and β be roots of x² + x + 1 = 0, then |α³ + β³| equals:",
          options: ["1", "2", "0", "√3"],
          answer: "1",
          subject: "Maths"
        },
        {
          question: "A man has 4 keys and only one opens the lock. He tries them one after another without replacement. Probability lock opens on second try is:",
          options: ["1/2", "1/4", "1/3", "3/4"],
          answer: "1/3",
          subject: "Maths"
        },
        {
          question: "If P(E) = 3/5, P(F) = 2/5, and P(E ∩ F) = 1/5, then P(E ∪ F) equals:",
          options: ["4/5", "3/5", "1", "2/5"],
          answer: "4/5",
          subject: "Maths"
        },
        {
          question: "Let z₁ = 1 + i and z₂ = 2 − 3i. Then |z₁z₂| equals:",
          options: ["√10", "√13", "√26", "√20"],
          answer: "√26",
          subject: "Maths"
        },
        {
          question: "If (1 + i)^n is purely real, then n is divisible by:",
          options: ["4", "2", "3", "5"],
          answer: "4",
          subject: "Maths"
        },
        {
          question: "Find the remainder when (x² + x + 1)(x − 1)³ is divided by x² + 1",
          options: ["2x + 3", "x − 1", "x + 2", "x² + 1"],
          answer: "2x + 3",
          subject: "Maths"
        },
        {
          question: "Area of triangle with sides a = 13, b = 14, and included angle C = π/6 is:",
          options: ["91", "91/2", "91√3/2", "91√2/2"],
          answer: "91/2",
          subject: "Maths"
        },
        {
          question: "If f(x) = tan⁻¹x + cot⁻¹x, then f(x) is:",
          options: ["π/2", "π", "0", "undefined"],
          answer: "π/2",
          subject: "Maths"
        },




        {
          question: "An electron enters symmetrically between two oppositely charged metal plates (each of 10 cm length) with horizontal velocity 10⁶ m/s. If electric field is 9.1 V/cm, what is the vertical component of velocity as it exits?",
          options: ["0", "16 × 10⁶", "16 × 10⁴", "1 × 10⁶"],
          answer: "16 × 10⁶",
          subject: "Physics"
        },
        {
          question: "A 10⁻³ kg ice at –10°C is converted to vapour at 110°C. What is the heat required?",
          options: ["3022 J", "3043 J", "3024 J", "3003 J"],
          answer: "3043 J",
          subject: "Physics"
        },
        {
          question: "If B is magnetic field and μ₀ is permeability of free space, dimensions of B/μ₀ are:",
          options: ["ML²T⁻²A⁻¹", "L⁻¹A", "LT⁻²A⁻¹", "MT⁻²A⁻¹"],
          answer: "L⁻¹A",
          subject: "Physics"
        },
        {
          question: "A bob of mass m performs vertical circular motion on a string. If it becomes slack at point D, ratio of KE at point B to point C is:",
          options: ["1", "3", "4", "2"],
          answer: "2",
          subject: "Physics"
        },
        {
          question: "A uniform disc of radius R has a circular portion of radius R/2 removed. Find the moment of inertia of remaining part about central axis.",
          options: ["27/32 MR²", "217/32 MR²", "213/32 MR²", "29/32 MR²"],
          answer: "213/32 MR²",
          subject: "Physics"
        },
        {
          question: "A 40 μF capacitor is connected to 100 V. If a dielectric of K = 2 is introduced, extra charge and energy change are:",
          options: ["2 mC & 0.4 J", "8 mC & 2.0 J", "4 mC & 0.2 J", "2 mC & 0.2 J"],
          answer: "4 mC & 0.2 J",
          subject: "Physics"
        },
        {
          question: "An ideal monoatomic gas is heated by 50°C at constant pressure. If E₁ and E₂ are heat and internal energy change respectively, and E₁/E₂ = 9/2, then x =",
          options: [],
          answer: "15",
          subject: "Physics"
        },
        {
          question: "Two soap bubbles of radius 2 cm and 4 cm in contact. Radius of curvature of common surface is:",
          options: [],
          answer: "4",
          subject: "Physics"
        },
        {
          question: "Ratio of heights in first and last second of projectile with u = 60 m/s at 30° is:",
          options: [],
          answer: "5",
          subject: "Physics"
        },
        {
          question: "In YDSE, fringe width decreases in a denser medium. This is because:",
          options: ["Both A and R true, R is correct explanation", "A true, R false", "Both true, R not explanation", "A false, R true"],
          answer: "Both A and R true, R is correct explanation",
          subject: "Physics"
        },
        {
          question: "Sliding contact of potentiometer at center, Rp = 1Ω, Re = 2Ω, find current in circuit.",
          options: ["1.35 A", "1.0 A", "0.3 A", "0.9 A"],
          answer: "1.0 A",
          subject: "Physics"
        },
        {
          question: "A loop carries current I = 12 A, formed of semicircles with radii 6π m and 4π m. Resultant magnetic field at center is k × 10⁻⁷ T. Find k:",
          options: [],
          answer: "7",
          subject: "Physics"
        },
        {
          question: "An ammeter with 240 Ω internal resistance has 10 Ω shunt and 150.4 Ω series. If 20V applied, what does it read in mA?",
          options: [],
          answer: "5",
          subject: "Physics"
        },
        {
          question: "Three spheres of mass m placed at triangle of side a collide every 4s. If side doubled and mass 2m, new time between collisions is:",
          options: [],
          answer: "8",
          subject: "Physics"
        },
        {
          question: "Two light waves of intensity 4I and 9I interfere. Max - min intensity is xI. Find x:",
          options: [],
          answer: "24",
          subject: "Physics"
        },
        {
          question: "A wire of length 4 cm carrying 8 A placed in 0.15 T field. Magnetic force (in mN) is:",
          options: [],
          answer: "48",
          subject: "Physics"
        },
        {
          question: "RMS speed of ideal gas molecules at 300K and molar mass 28 g/mol is (in m/s):",
          options: [],
          answer: "515",
          subject: "Physics"
        },
        {
          question: "Thermal conductors with k₁=60, k₂=120, k₃=135 W/mK arranged in composite way. Steady state temp at node is ____°C.",
          options: [],
          answer: "40",
          subject: "Physics"
        },
        {
          question: "Dimensions of B/μ₀ are:",
          options: ["ML²T⁻²A⁻¹", "L⁻¹A", "LT⁻²A⁻¹", "MT⁻²A⁻¹"],
          answer: "L⁻¹A",
          subject: "Physics"
        },
        {
          question: "The correct expression for potential energy stored in a parallel plate capacitor is:",
          options: [
            "¼ ε₀ E²Ad", "½ ε₀ E²Ad", "ε₀ E²Ad", "¾ ε₀ E²Ad"
          ],
          answer: "½ ε₀ E²Ad",
          subject: "Physics"
        },
        {
          question: "A plano-convex lens with μ = 1.5 is immersed in liquid μ = 1.2. Plane face silvered, behaves like concave mirror with f = 0.2 m. Find radius of curvature.",
          options: ["0.20 m", "0.15 m", "0.25 m", "0.10 m"],
          answer: "0.10 m",
          subject: "Physics"
        },
        {
          question: "Significant digits: Compute and report y = (32.3 × 1125)/27.4 to proper sig. figs.",
          options: ["1330", "1326.2", "1326.19", "1326.186"],
          answer: "1330",
          subject: "Physics"
        },
        {
          question: "A satellite orbits Earth in circular radius R. Another satellite orbits at 1.03R. What’s time period ratio?",
          options: ["1.03", "1.045", "1.06", "1.015"],
          answer: "1.045",
          subject: "Physics"
        },
        {
          question: "An object projected vertically upward from Earth with KE = 1.5 × PE. Height attained?",
          options: ["h = 3R/4", "h = R", "h = R/2", "h = R/3"],
          answer: "3R/4",
          subject: "Physics"
        },
        {
          question: "A circular wire loop with resistance 9Ω bent into equilateral triangle. Resistance across any two vertices?",
          options: [],
          answer: "2",
          subject: "Physics"
        },




        {
          question: "How many different stereoisomers are possible for the given molecule?",
          options: ["2", "4", "3", "1"],
          answer: "4",
          subject: "Chemistry"
        },
        {
          question: "CH₃–O–CH₂–Cl undergoes SN1 though it is primary halide. Another compound doesn’t undergo SN2 easily. Which is correct?",
          options: [
            "Both Statement I and Statement II are incorrect",
            "Both Statement I and Statement II are correct",
            "Statement I is correct but Statement II is incorrect",
            "Statement I is incorrect but Statement II is correct"
          ],
          answer: "Both Statement I and Statement II are correct",
          subject: "Chemistry"
        },
        {
          question: "A liquid is mechanically stirred in insulated vessel at 25°C. Which thermodynamic relation is correct?",
          options: ["ΔU > 0, q = 0, w > 0", "ΔU < 0, q = 0, w > 0", "ΔU = 0, q < 0, w > 0", "ΔU = 0, q = 0, w = 0"],
          answer: "ΔU > 0, q = 0, w > 0",
          subject: "Chemistry"
        },
        {
          question: "One mole of Co(NH₃)₅Cl₃ gives 3 ions in solution and 2 moles of AgCl with AgNO₃. Structure is:",
          options: [
            "[Co(NH₃)₄Cl].Cl₂.NH₃",
            "[Co(NH₃)₄Cl₂].Cl.NH₃",
            "[Co(NH₃)₃Cl₃].2NH₃",
            "[Co(NH₃)₅Cl]Cl₂"
          ],
          answer: "[Co(NH₃)₅Cl]Cl₂",
          subject: "Chemistry"
        },
        {
          question: "Which statements about Ribose in DNA are correct?",
          options: [
            "A, B and E only",
            "B, D and E only",
            "A, C and D only",
            "A, D and E only"
          ],
          answer: "A, C and D only",
          subject: "Chemistry"
        },
        {
          question: "Which is correct about H₂O, NH₃ and CH₄ geometry?",
          options: [
            "H₂O and NH₃ are angular and pyramidal respectively",
            "CH₄ is planar",
            "NH₃ is angular",
            "CH₄ is angular"
          ],
          answer: "H₂O and NH₃ are angular and pyramidal respectively",
          subject: "Chemistry"
        },
        {
          question: "The given 3D structure is for which compound?",
          options: ["Ammonia", "Benzene", "Urea", "Acetylene"],
          answer: "Urea",
          subject: "Chemistry"
        },
        {
          question: "Which is a pseudo-halide?",
          options: ["CN⁻", "F⁻", "Cl⁻", "OH⁻"],
          answer: "CN⁻",
          subject: "Chemistry"
        },
        {
          question: "Choose correct order of increasing boiling point: 10⁻⁴ M NaCl, Urea, 10⁻³ M NaCl, 10⁻² M NaCl.",
          options: [
            "(ii) < (i) ≡ (iii) < (iv)",
            "(i) < (ii) < (iii) < (iv)",
            "(iv) < (iii) < (i) < (ii)",
            "(ii) < (i) < (iii) < (iv)"
          ],
          answer: "(ii) < (i) < (iii) < (iv)",
          subject: "Chemistry"
        },
        {
          question: "A vessel at 1000 K has CO₂ at 0.5 atm. After equilibrium with graphite: CO₂ ⇌ 2CO, total pressure = 0.8 atm. Kp = ?",
          options: ["0.18 atm", "1.8 atm", "0.3 atm", "3 atm"],
          answer: "1.8 atm",
          subject: "Chemistry"
        },
        {
          question: "Which of the following acids is a vitamin?",
          options: ["Saccharic acid", "Adipic acid", "Aspartic acid", "Ascorbic acid"],
          answer: "Ascorbic acid",
          subject: "Chemistry"
        },
        {
          question: "In Carius method, 180 mg organic compound gives 143.5 mg AgCl. % Cl = ?",
          options: [],
          answer: "20",
          subject: "Chemistry"
        },
        {
          question: "0.1 M 40 mL HCl used to neutralize excess Ca(OH)₂ after reacting with CO₂. Volume of container (cm³)?",
          options: [],
          answer: "45",
          subject: "Chemistry"
        },
        {
          question: "The volume strength of 1.5 M H₂O₂ solution is:",
          options: [],
          answer: "16",
          subject: "Chemistry"
        },
        {
          question: "For reaction: A + B ⇌ C, initial [A] = [B] = 1M, [C] = 0. At equilibrium, [C] = 0.6 M. Kc = ?",
          options: [],
          answer: "2.25",
          subject: "Chemistry"
        },
        {
          question: "C₂H₆ undergoes chlorination. Number of monochlorinated products possible?",
          options: [],
          answer: "2",
          subject: "Chemistry"
        },
        {
          question: "What is the correct IUPAC name of CH₃CH(OH)CH₂COOH?",
          options: ["2-Hydroxybutanoic acid", "3-Hydroxybutanoic acid", "Butanoic acid", "But-3-enoic acid"],
          answer: "3-Hydroxybutanoic acid",
          subject: "Chemistry"
        },
        {
          question: "Gibbs free energy change when 2 moles of H₂ and 1 mole of O₂ at 1 atm, 298 K form H₂O (l) is:",
          options: [],
          answer: "–474",
          subject: "Chemistry"
        },
        {
          question: "Identify complex from which 2 mol AgCl formed per mol complex: [Pt(NH₃)₂Cl₂], [Pt(NH₃)₄]Cl₂, [Pt(NH₃)₄Cl₂], [PtCl₄]²⁻",
          options: [],
          answer: "[Pt(NH₃)₄]Cl₂",
          subject: "Chemistry"
        },
        {
          question: "Which one is correct order of E° (V): Fe³⁺/Fe²⁺, Cu²⁺/Cu⁺, Mn³⁺/Mn²⁺?",
          options: [],
          answer: "Cu²⁺/Cu⁺ > Fe³⁺/Fe²⁺ > Mn³⁺/Mn²⁺",
          subject: "Chemistry"
        },
        {
          question: "Which compound gives positive carbylamine test?",
          options: ["CH₃NH₂", "C₂H₅NO₂", "CH₃CONH₂", "CH₃CH₂CN"],
          answer: "CH₃NH₂",
          subject: "Chemistry"
        },
        {
          question: "Which of the following is most reactive in SN1 reaction?",
          options: ["CH₃Cl", "(CH₃)₂CHCl", "CH₃CH₂Cl", "(CH₃)₃CCl"],
          answer: "(CH₃)₃CCl",
          subject: "Chemistry"
        },
        {
          question: "Which complex shows highest λ absorbed among: [Co(NH₃)₆]³⁺, [Co(CN)₆]³⁻, [CoCl(NH₃)₅]²⁺, [Co(NH₃)₅(H₂O)]³⁺?",
          options: [],
          answer: "[CoCl(NH₃)₅]²⁺",
          subject: "Chemistry"
        },
        {
          question: "Which of the following is a strong acid?",
          options: ["CH₃COOH", "H₂SO₄", "HCOOH", "HNO₂"],
          answer: "H₂SO₄",
          subject: "Chemistry"
        },
        {
          question: "Which among the following species is paramagnetic?",
          options: ["O₂", "N₂", "F₂", "Cl₂"],
          answer: "O₂",
          subject: "Chemistry"
        },  
      ]
    },
  ],
};

export default testData;







